import AstrologyContent from './AstrologyContent';
import StockMarketLive from './StockMarketLive';
import NethajIQPage from './NethajIQPage';
import BirthChartContent from './BirthChartContent';
import DonateButton from './DonateButton';
import React, { useState, useEffect, useRef, useCallback } from "react";
import AdvertisePage from './AdvertisePage';
import GoogleAdUnit from './GoogleAdUnit';
import "./WatchNowPage.css";
import AdService from "./AdService";
import { supabase } from "./supabaseClient";
import { npAudio } from "./audioCoordinator";
import LegalFooter from "./LegalFooter";

const API_URL = process.env.REACT_APP_BACKEND_URL || "https://nethajiprime-backend.onrender.com";

const BACKEND = process.env.REACT_APP_BACKEND_URL || "https://nethajiprime-backend.onrender.com";
const BUNNY_THUMB = "https://vz-d3b5a5b7-183.b-cdn.net/675198";
const BUNNY_EMBED = "https://iframe.mediadelivery.net/embed/675198";

const RSS_CHANNELS = [
  { id: "nethaji",     label: "Nethaji TV",  channelId: "UCUcNLZFSeEPCmhFPMsTB_4g", color: "#8b0000" },
  { id: "nmk",         label: "NMK TV",      channelId: "UCHxP-ry5QxMKTDXTQIGUs9Q", color: "#0d47a1" },
  { id: "harichandra", label: "Harichandra", channelId: "UCk_iGqMBw24OPUjKyWcJKmw", color: "#4a148c" },
  { id: "bharath",     label: "Bharath TV",  channelId: "UC1xF2lFpUvHXZCAXwR_fVIw", color: "#00695c" },
];

const CHIPS = ["ALL","🎬 REELS","📚 NethajiPrime Playlist","🔴 LIVE","📺 ALL VIDEOS","🎤️ INTERVIEWS","🙏 DEVOTIONAL","⭐ ASTROLOGY","📈 STOCK MARKET","🧠 NethajIQ","🎬 NP ORIGINALS","🧸 KIDS","❤️ HEALTH","🍴 KITCHEN"];
// Newest first (published_at || created_at; speeches has no published_at yet,
// so this resolves to created_at). Module-level so every component -
// including VideoModal's "More Like This" - can call it. Null dates sink.
const sortNewest = (arr) => (arr || []).slice().sort(
  (a, b) => new Date(b.published_at || b.created_at || 0) - new Date(a.published_at || a.created_at || 0)
);
// ── RESPONSIVE HOOK ───────────────────────────────────────────────────────────
function useWindowSize() {
  const [size, setSize] = React.useState({ w: window.innerWidth, h: window.innerHeight });
  React.useEffect(() => {
    const handler = () => setSize({ w: window.innerWidth, h: window.innerHeight });
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);
  return size;
}

function useResponsive() {
  const { w } = useWindowSize();
  return {
    isMobile:  w <= 768,
    isTablet:  w > 768 && w <= 1024,
    isDesktop: w > 1024 && w <= 1920,
    isTV:      w > 1920,
    w,
  };
}



if (!document.getElementById("np-responsive")) {
  const s = document.createElement("style");
  s.id = "np-responsive";
  s.textContent = `
* { box-sizing: border-box; }

/* ── DESKTOP DEFAULT ── */
.np-mobile-bottom-nav { display: none; }

/* ── MOBILE (≤768px) ── */
@media (max-width: 768px) {
  /* Nav */
  .np-nav { padding: 0 10px !important; height: 50px !important; }
  .np-nav-mid { display: none !important; }
  .np-nav-right { gap: 4px !important; }
  .np-nav-right button { font-size: 9px !important; padding: 5px 8px !important; letter-spacing: 0 !important; }

  /* Bottom nav */
  .np-mobile-bottom-nav { display: flex !important; flex-direction: column; }

  /* Hero */
.np-hero { min-height: 0 !important; flex-direction: column !important; position: relative !important; overflow: hidden !important; }
.np-hero-left { position: absolute !important; bottom: 0 !important; left: 0 !important; right: 0 !important; z-index: 3 !important; width: 100% !important; padding: 12px 14px 70px !important; background: linear-gradient(to top, #1a0008 65%, rgba(26,0,8,0.3) 85%, transparent 100%) !important; }
.np-hero-right { position: absolute !important; inset: 0 !important; width: 100% !important; height: 100% !important; min-height: unset !important; z-index: 1 !important; }
.np-hero-right img { width: 100% !important; height: 100% !important; object-fit: cover !important; object-position: top center !important; }
  .np-hero-eng { font-size: 24px !important; margin-bottom: 4px !important; }
  .np-hero-tam { font-size: 18px !important; margin-bottom: 8px !important; }
  .np-hero-desc { font-size: 12px !important; margin-bottom: 12px !important; }
  .np-btn-play { font-size: 13px !important; padding: 10px 20px !important; }
  .np-hero-btns { flex-direction: row !important; gap: 8px !important; }
  .np-hero-btns button { flex: 1 !important; font-size: 13px !important; padding: 10px 8px !important; }

  /* Cards */
  .np-card { width: calc(46vw - 10px) !important; min-width: 140px !important; max-width: 190px !important; }
  .np-card-img { width: 100% !important; height: auto !important; aspect-ratio: 16/9 !important; }

  /* Sections */
  .np-section { padding: 0 4px !important; margin-top: 10px !important; }
  .np-chips { padding: 0 6px !important; gap: 6px !important; }
  .np-live { margin: 8px 8px !important; padding: 10px !important; }

  /* Video list items */
  .np-vitem { padding: 0 0 12px 0 !important; gap: 0 !important; flex-direction: column !important; border-bottom: 1px solid rgba(255,255,255,0.07) !important; }
  .np-vthumb { width: 100% !important; min-width: 100% !important; max-width: 100% !important; height: auto !important; aspect-ratio: 16/9 !important; border-radius: 0 !important; }
  .np-vinfo { padding: 8px 10px 0 10px !important; width: 100% !important; }
  .np-vtitle { font-size: 14px !important; line-height: 1.4 !important; }
  .np-vmeta { font-size: 11px !important; margin-top: 3px !important; }
  .np-stats-row { margin-top: 6px !important; }
  .np-share-wrap { margin-top: 6px !important; }
  .np-vthumb { width: 40vw !important; min-width: 120px !important; max-width: 200px !important; height: calc(40vw * 0.5625) !important; flex-shrink: 0 !important; border-radius: 4px !important; }
  .np-vinfo { flex: 1 !important; min-width: 0 !important; }
  .np-vtitle { font-size: 12px !important; line-height: 1.3 !important; margin-bottom: 3px !important; }
  .np-vmeta { font-size: 10px !important; }

  /* Share buttons - scrollable single row */
  @media (min-width: 768px) { .np-share-wrap { flex-wrap: nowrap !important; overflow-x: auto !important; overflow-y: hidden !important; scrollbar-width: none !important; -webkit-overflow-scrolling: touch !important; gap: 3px !important; margin-top: 4px !important; } }
  .np-share-wrap::-webkit-scrollbar { display: none !important; }
  .np-hype-btn { height: 18px !important; min-height: 18px !important; max-height: 18px !important; padding-top: 0 !important; padding-bottom: 0 !important; line-height: 18px !important; display: inline-flex !important; align-items: center !important; box-sizing: border-box !important; -webkit-appearance: none !important; }
  /* One uniform pill for every share child (a AND button) — was two rules that
     forced <button> to 18px and shrank text to 8px, overriding the inline styles. */
  .np-share-wrap a, .np-share-wrap button { box-sizing: border-box !important; height: 40px !important; min-height: 40px !important; max-height: 40px !important; padding: 0 16px !important; line-height: 1 !important; font-size: 13px !important; letter-spacing: 0.5px !important; border-radius: 8px !important; display: inline-flex !important; align-items: center !important; justify-content: center !important; flex-shrink: 0 !important; -webkit-appearance: none !important; appearance: none !important; }

  /* Stats row - scrollable */
  .np-stats-row { flex-wrap: nowrap !important; overflow-x: auto !important; scrollbar-width: none !important; gap: 4px !important; }
  .np-stats-row::-webkit-scrollbar { display: none !important; }
  .np-stats-row span, .np-stats-row button { font-size: 9px !important; padding: 1px 5px !important; flex-shrink: 0 !important; }

  /* Main content padding for bottom nav */
  /* WARNING: never set 'overscroll-behavior: none' on body/html here — it silently breaks vertical touch-scrolling on Android Chrome (window.scrollTo works, finger drag does not). */ body { padding-bottom: 65px !important; } body { min-height: 100% !important; } body { -webkit-overflow-scrolling: touch !important; }
  .np-main-content { padding: 8px 4px 70px !important; }
}

/* ── TABLET (769px - 1024px) ── */
@media (min-width: 769px) and (max-width: 1024px) {
  /* Cards */
  .np-card { width: calc(33vw - 16px) !important; min-width: 180px !important; max-width: 240px !important; }
  .np-section { padding: 0 16px !important; }

  /* Hide bottom nav on tablet */
  .np-mobile-bottom-nav { display: none !important; }

  /* Hero - fix cropping on iPad */
  .np-hero { min-height: 420px !important; max-height: 480px !important; overflow: hidden !important; }
  .np-hero-right { width: 55% !important; min-width: unset !important; }
  .np-hero-right img { width: 100% !important; height: 100% !important; object-fit: cover !important; object-position: center top !important; }
  .np-hero-left { width: 45% !important; padding: 20px 16px !important; }

  /* Hero text - not too big on iPad */
  .np-hero-eng { font-size: clamp(18px, 3vw, 28px) !important; line-height: 1.2 !important; margin-bottom: 6px !important; }
  .np-hero-tam { font-size: clamp(16px, 2.5vw, 24px) !important; line-height: 1.3 !important; margin-bottom: 8px !important; }
  .np-hero-desc { font-size: 13px !important; margin-bottom: 12px !important; }

  /* Buttons - proper size on tablet */
  .np-btn-play { font-size: 14px !important; padding: 10px 20px !important; white-space: nowrap !important; }
  .np-hero-btns { flex-direction: row !important; gap: 10px !important; flex-wrap: nowrap !important; }
  .np-hero-btns button { font-size: 14px !important; padding: 10px 16px !important; }

  /* Category chips - scrollable */
  .np-chips { padding: 0 12px !important; gap: 8px !important; overflow-x: auto !important; flex-wrap: nowrap !important; }
  .np-chips::-webkit-scrollbar { display: none !important; }

  /* Nav */
  .np-nav { padding: 0 16px !important; height: 56px !important; }
  .np-nav-mid { display: none !important; }
}

/* ── LARGE TABLET / SMALL LAPTOP (1025px - 1279px) ── */
@media (min-width: 1025px) and (max-width: 1279px) {
  .np-card { width: calc(25vw - 16px) !important; min-width: 200px !important; max-width: 280px !important; }
  .np-mobile-bottom-nav { display: none !important; }
  .np-hero { min-height: 480px !important; }
  .np-hero-eng { font-size: clamp(24px, 3.5vw, 36px) !important; }
  .np-hero-tam { font-size: clamp(20px, 3vw, 30px) !important; }
  .np-btn-play { font-size: 15px !important; padding: 12px 24px !important; }
}

/* ── 4K/TV (≥1920px) ── */
@media (min-width: 1920px) {
  .np-hero { min-height: 800px !important; }
  .np-hero-eng { font-size: 90px !important; }
  .np-hero-tam { font-size: 56px !important; }
  .np-btn-play { font-size: 30px !important; padding: 20px 50px !important; }
  .np-card { width: 480px !important; }
  .np-card-img { width: 480px !important; height: 270px !important; }
  .np-section { padding: 0 60px !important; }
  .np-nav { height: 90px !important; padding: 0 60px !important; }
  .np-logo-n { font-size: 48px !important; }
  button:focus, a:focus { outline: 4px solid #FFD700 !important; }
}
`
  document.head.appendChild(s);
}
if (!document.getElementById("np-fonts")) {
  const l = document.createElement("link");
  l.id = "np-fonts"; l.rel = "stylesheet";
  l.href = "https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Rajdhani:wght@600;700&family=Noto+Sans+Tamil:wght@700&display=swap";
  document.head.appendChild(l);
}

if (!document.getElementById("np-responsive")) {
  const s = document.createElement("style");
  s.id = "np-responsive";
  s.textContent = `
    * { box-sizing: border-box; }
    ::-webkit-scrollbar { display: none; }

    /* ── MOBILE (max 768px) ── */
    @media (max-width: 768px) {
      .np-nav { padding: 0 12px !important; height: 54px !important; flex-wrap: nowrap !important; }
      .np-logo-n { font-size: 22px !important; }
      .np-logo-p { font-size: 16px !important; }
      .np-nav-mid { display: none !important; }
      .np-nav-right { gap: 6px !important; }
      .np-sub-btn { font-size: 10px !important; padding: 6px 10px !important; }
      .np-search-btn { padding: 6px 8px !important; }

      .np-hero { min-height: 480px !important; flex-direction: column !important; position: relative !important; overflow: hidden !important; }
      .np-hero-left { flex: none !important; width: 100% !important; padding: 24px 16px 20px !important; position: absolute !important; bottom: 0 !important; left: 0 !important; right: 0 !important; z-index: 2 !important; background: linear-gradient(to top, #1a0008 70%, transparent 100%) !important; }
      .np-hero-right { position: absolute !important; inset: 0 !important; width: 100% !important; height: 100% !important; }
      .np-hero-eng { font-size: 32px !important; }
      .np-hero-tam { font-size: 22px !important; }
      .np-hero-desc { font-size: 13px !important; margin-bottom: 14px !important; }
      .np-btn-play { font-size: 15px !important; padding: 10px 20px !important; }
      .np-btn-wl { font-size: 15px !important; padding: 10px 16px !important; }

      .np-chips { padding: 0 8px !important; }
      .np-chip { padding: 10px 10px !important; font-size: 11px !important; }

      .np-live { margin: 10px 12px !important; padding: 10px 12px !important; flex-wrap: wrap !important; }

      .np-section { padding: 0 12px !important; margin-top: 18px !important; }
      .np-card { width: 180px !important; }
      .np-card-img { width: 180px !important; height: 101px !important; }
      .np-card-title { font-size: 12px !important; }

      .np-vthumb { width: 120px !important; height: 68px !important; }
      .np-vtitle { font-size: 13px !important; }

      .np-leaderboard { padding: 0 12px !important; }
.np-sec-head { display: flex !important; align-items: center !important; gap: 8px !important; line-height: 1 !important; }
.np-sec-bar { width: 4px !important; height: 20px !important; border-radius: 2px !important; flex-shrink: 0 !important; align-self: center !important; display: inline-block !important; vertical-align: middle !important; }
      .np-modal { max-width: 100% !important; margin: 0 !important; border-radius: 0 !important; max-height: 100vh !important; }
      .np-modal-info { padding: 10px 12px !important; }
      .np-modal-title { font-size: 16px !important; }

      .np-search-overlay { padding: 60px 12px 12px !important; }
      .np-share-btn { font-size: 9px !important; padding: 3px 7px !important; }
    }

    /* ── TABLET (768px - 1024px) ── */
    @media (min-width: 768px) and (max-width: 1024px) {
      .np-hero { min-height: 440px !important; }
      .np-hero-left { flex: 0 0 50% !important; padding: 36px 24px 40px 32px !important; }
      .np-hero-eng { font-size: 44px !important; }
      .np-hero-tam { font-size: 28px !important; }
      .np-nav-mid { gap: 16px !important; }
      .np-card { width: 240px !important; }
      .np-card-img { width: 240px !important; height: 135px !important; }
    }

    /* ── SMART TV / 4K (min 1920px) ── */
    @media (min-width: 1920px) {
      .np-nav { height: 90px !important; padding: 0 60px !important; }
      .np-logo-n { font-size: 48px !important; }
      .np-logo-p { font-size: 36px !important; }
      .np-nav-mid { gap: 48px !important; }
      .np-nl { font-size: 20px !important; }
      .np-sub-btn { font-size: 18px !important; padding: 14px 28px !important; }

      .np-hero { min-height: 800px !important; }
      .np-hero-eng { font-size: 96px !important; }
      .np-hero-tam { font-size: 60px !important; }
      .np-hero-desc { font-size: 24px !important; }
      .np-btn-play { font-size: 32px !important; padding: 22px 56px !important; }
      .np-btn-wl { font-size: 28px !important; padding: 20px 44px !important; }

      .np-section { padding: 0 60px !important; margin-top: 48px !important; }
      .np-sec-nm { font-size: 32px !important; }
      .np-card { width: 480px !important; }
      .np-card-img { width: 480px !important; height: 270px !important; }
      .np-card-title { font-size: 20px !important; }
      .np-card-meta { font-size: 14px !important; }

      .np-chip { font-size: 18px !important; padding: 20px 28px !important; }
      .np-live { margin: 28px 60px !important; padding: 24px 32px !important; }
      .np-live-t { font-size: 24px !important; }

      .np-vthumb { width: 280px !important; height: 158px !important; }
      .np-vtitle { font-size: 22px !important; }
      .np-vmeta { font-size: 16px !important; }

      .np-modal { max-width: 1400px !important; }
      .np-modal-title { font-size: 36px !important; }
    }

    /* ── Focus styles for TV remote navigation ── */
    @media (min-width: 1920px) {
      button:focus, a:focus { outline: 4px solid #FFD700 !important; outline-offset: 4px !important; }
    }
  `;
  document.head.appendChild(s);
}

function formatNum(n) {
  if (n >= 1000000) return (n/1000000).toFixed(1) + "M";
  if (n >= 1000) return (n/1000).toFixed(1) + "K";
  return n.toString();
}

// ── HYPE BUTTON ─────────────────────────────────────────────────────────────
function HypeButton({ item, backend }) {
  const [hypes, setHypes] = useState(0);
  const [hyped, setHyped] = useState(false);
  const [viral, setViral] = useState(false);

  // Load the stored hype count on mount (was missing -> cards always showed 0).
  useEffect(() => {
    if (!item?.id) return;
    let alive = true;
    fetch(`${backend}/api/hype/${item.id}`)
      .then(r => r.json())
      .then(d => { if (alive && d && typeof d.hype_count === 'number') setHypes(d.hype_count); })
      .catch(() => {});
    return () => { alive = false; };
  }, [item?.id, backend]);

  const handleHype = async (e) => {
    e.stopPropagation();
    if (hyped) return;
    try {
      const userId = localStorage.getItem("np_user_id") || "guest";
      const r = await fetch(`${backend}/api/hype/${item.id}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ user_id: userId })
      });
      const data = await r.json();
      if (data.hype_count !== undefined || data.success) {
        setHypes(data.hype_count || data.hypes || 1);
        setHyped(true);
        setViral(data.is_viral || data.viral || false);
      }
    } catch(e) {}
  };


  // OTT APP 19: single card row helper
  const hrowClass = (vids) =>
    `np-hrow${Array.isArray(vids) && vids.length === 1 ? ' single-card-row' : ''}`;


  return (
    <button className="np-hype-btn" onClick={handleHype} style={{
      background: hyped ? "#FF4500" : "rgba(255,69,0,0.15)",
      border: "1px solid #FF4500",
      color: hyped ? "#fff" : "#FF4500",
      fontFamily: "'Bebas Neue',sans-serif",
      fontSize: 8, letterSpacing: 0,
      padding: "0 6px", borderRadius: 3, height: 18, display: "inline-flex", alignItems: "center", boxSizing: "border-box",
      cursor: hyped ? "default" : "pointer",
      whiteSpace: "nowrap",
    }}>
      {viral ? "🤯 VIRAL" : `⚡ HYPE${hypes > 0 ? " " + hypes : ""}`}
    </button>
  );
}

// ── TRENDING BADGE ───────────────────────────────────────────────────────────
function TrendingBadge({ videoId, trendingIds }) {
  const rank = trendingIds.indexOf(videoId);
  if (rank === -1 || rank > 4) return null;
  const labels = ["🔥 #1 TRENDING", "🔥 #2 TRENDING", "⚡ #3", "⚡ #4", "⭐ #5"];
  return (
    <div style={{ position:"absolute", bottom: 6, right: 6, background: "rgba(255,69,0,0.9)", color:"#fff", fontFamily:"'Bebas Neue',sans-serif", fontSize: 9, letterSpacing: 1, padding:"2px 6px", borderRadius: 3 }}>
      {labels[rank]}
    </div>
  );
}

// ── LEADERBOARD ──────────────────────────────────────────────────────────────
function Leaderboard({ backend }) {
  const [data, setData] = useState([]);
  const [show, setShow] = useState(false);


  // OTT APP 19: Fluid column count
  useEffect(() => {
    const setColumns = () => {
      const w = window.innerWidth;
      const cols = w < 480 ? 2 : w < 700 ? 3 : w < 1100 ? 4 : w < 1600 ? 5 : 6;
      document.documentElement.style.setProperty('--np-cols', cols);
    };
    setColumns();
    window.addEventListener('resize', setColumns);
    return () => window.removeEventListener('resize', setColumns);
  }, []);

  useEffect(() => {
    fetch(`${backend}/api/leaderboard`)
      .then(r => r.json())
      .then(d => setData((d && d.leaderboard) ? d.leaderboard : []))
      .catch(() => {});
  }, [backend]);

  // Fewer than 3 fans reads as an empty room — hide until real activity
  // builds up, then the section appears naturally.
  if (!data || data.length < 3) return null;

  return (
    <div style={{ padding: "0 16px", marginTop: 24 }}>
      <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom: 12 }}>
        <div style={{ display:"flex", alignItems:"center", gap: 10 }}>
          <div style={{ width: 4, height: 20, background: "#FFD700", borderRadius: 2, flexShrink: 0, alignSelf: "center", display: "inline-block" }} />
          <div style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize: 20, letterSpacing: 3, color: "#fff" }}>🏆 TOP FANS THIS WEEK</div>
        </div>
        <button onClick={() => setShow(!show)} style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize: 11, letterSpacing: 2, color: "#FFD700", background: "rgba(255,215,0,0.15)", border: "1px solid #FFD700", padding: "6px 14px", borderRadius: 4, cursor: "pointer" }}>
          {show ? "HIDE" : "SHOW ALL"}
        </button>
      </div>
      <div style={{ display:"flex", gap: 10, overflowX: show ? "visible" : "auto", flexWrap: show ? "wrap" : "nowrap", scrollbarWidth: "none" }}>
        {(data || []).slice(0, show ? 10 : 5).map((v, i) => (
          <div key={String(v.video_id || v.user_name || i) + String(i)} style={{ flexShrink: 0, background: i === 0 ? "rgba(255,215,0,0.15)" : "rgba(255,255,255,0.05)", border: `1px solid ${i === 0 ? "#FFD700" : "rgba(255,255,255,0.1)"}`, borderRadius: 8, padding: "12px 16px", minWidth: 160 }}>
            <div style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize: 24, color: i === 0 ? "#FFD700" : i === 1 ? "#C0C0C0" : i === 2 ? "#CD7F32" : "#fff", marginBottom: 4 }}>
              {i === 0 ? "🥇" : i === 1 ? "🥈" : i === 2 ? "🥉" : `#${i+1}`}
            </div>
            <div style={{ fontFamily:"'Rajdhani',sans-serif", fontSize: 12, fontWeight: 700, color: "#fff", marginBottom: 6 }}>
              {v.user_name || v.video_id || "User"}
            </div>
            <div style={{ display:"flex", gap: 6, flexWrap:"wrap" }}>
              {v.total_points > 0 && <span style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize: 10, color: "#FFD700" }}>⭐ {v.total_points} pts</span>}
              {v.hypes_given > 0 && <span style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize: 10, color: "#FF4500" }}>⚡ {v.hypes_given}</span>}
              {v.badge && <span style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize: 10, color: "#aaa" }}>{v.badge}</span>}
              {v.views > 0 && <span style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize: 10, color: "#FFD700" }}>👁 {formatNum(v.views)}</span>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

// ── CONTINUE WATCHING ────────────────────────────────────────────────────────
function ContinueWatchingRow({ userId, onPlay, backend }) {
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (!userId) return;
    fetch(`${backend}/api/watch-progress/${userId}`)
      .then(r => r.json())
      .then(data => setItems(data.progress || []))
      .catch(() => {});
  }, [userId, backend]);

  if (!items.length) return null;

  return (
    <div style={{ padding: "0 28px", marginTop: 24 }}>
      <div style={{ display:"flex", alignItems:"center", gap: 10, marginBottom: 12 }}>
        <div style={{ width: 4, height: 22, background: "#54b3d6", borderRadius: 2 }} />
        <div style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize: 20, letterSpacing: 3, color: "#fff" }}>▶ CONTINUE WATCHING</div>
      </div>
      <div style={{ display:"flex", gap: 12, overflowX:"auto", scrollbarWidth:"none", paddingBottom: 8 }}>
        {items.map(item => (
          <div key={item.video_id} style={{ flexShrink: 0, width: 280, cursor: "pointer" }}
            onClick={() => onPlay({ id: item.video_id, title: item.title, thumb: item.thumb, type: item.video_type, url: item.url })}>
            <div style={{ width: 280, height: 158, borderRadius: 9, background: "#2a0010", position: "relative", overflow: "hidden", border: "2px solid rgba(84,179,214,0.3)" }}>
              {item.thumb && <img src={item.thumb} alt={item.title} style={{ width:"100%", height:"100%", objectFit:"cover" }} />}
              <div style={{ position:"absolute", bottom: 0, left: 0, right: 0, height: 4, background: "rgba(255,255,255,0.2)" }}>
                <div style={{ height:"100%", width:`${item.progress}%`, background: "#FFD700", borderRadius: 2 }} />
              </div>
              <div style={{ position:"absolute", bottom: 8, right: 8, background:"rgba(0,0,0,0.8)", color:"#FFD700", fontFamily:"'Bebas Neue',sans-serif", fontSize:10, padding:"2px 6px", borderRadius:3 }}>
                {item.progress}% WATCHED
              </div>
            </div>
            <div style={{ fontFamily:"'Rajdhani',sans-serif", fontSize: 13, fontWeight: 700, color: "#fff", marginTop: 6, lineHeight: 1.3, display:"-webkit-box", WebkitLineClamp:2, WebkitBoxOrient:"vertical", overflow:"hidden" }}>{item.title}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

// ── SHARE BUTTONS ────────────────────────────────────────────────────────────
function ShareButtons({ item }) {
  const isYT = item.type === "youtube";

  // YouTube videos: share YouTube URL (primary) + NP Prime link (secondary)
  // NP Originals: share NP Prime deep link only
  const primaryUrl = isYT ? item.url : `https://nethajiprime.com/watch/${item.id}`;
  const npLink = `https://nethajiprime.com/watch/${item.id}`;

  // WhatsApp message: for YouTube include both links
  const waText = isYT
    ? `Watch "${item.title}" on YouTube!
${item.url}

Also streaming on Nethaji Prime OTT:
${npLink}`
    : `Watch "${item.title}" on Nethaji Prime OTT!
${npLink}`;

  // Twitter/Threads: concise with primary URL
  const twText = isYT
    ? `Watch "${item.title}" on YouTube! ${item.url} | Also on @NethajipPrime OTT`
    : `Watch "${item.title}" on Nethaji Prime OTT! ${npLink}`;

  const enc_primary = encodeURIComponent(primaryUrl);
  const enc_wa = encodeURIComponent(waText);
  const enc_tw = encodeURIComponent(twText);
  const enc_tg_text = encodeURIComponent(isYT ? `Watch "${item.title}" on YouTube! Also on Nethaji Prime OTT: ${npLink}` : `Watch "${item.title}" on Nethaji Prime OTT!`);

  const btns = [
    { label: "WhatsApp",  bg: "#25D366",  href: `https://wa.me/?text=${enc_wa}` },
    { label: "Facebook",  bg: "#1877F2",  href: `https://www.facebook.com/sharer/sharer.php?u=${enc_primary}&quote=${encodeURIComponent(`Watch "${item.title}" on Nethaji Prime OTT!`)}` },
    { label: "Twitter",   bg: "#000",     border: "1px solid #333", href: `https://twitter.com/intent/tweet?text=${enc_tw}` },
    { label: "Telegram",  bg: "#229ED9",  href: `https://t.me/share/url?url=${enc_primary}&text=${enc_tg_text}` },
    { label: "Threads",   bg: "#000",     border: "1px solid #333", href: `https://www.threads.net/intent/post?text=${enc_tw}` },
  ];

  const copyText = isYT
    ? `${item.url}

Also watch on Nethaji Prime OTT: ${npLink}`
    : npLink;

  // One shared pill for every share button. border-box + a fixed height make
  // <a> and <button> render identically; only the background varies (Twitter/
  // Threads add a hairline border for definition on the dark modal).
  const SHARE_BTN = {
    boxSizing: "border-box", height: 40, padding: "0 16px",
    display: "inline-flex", alignItems: "center", justifyContent: "center",
    borderRadius: 8, border: "none", textDecoration: "none",
    color: "#fff", cursor: "pointer", whiteSpace: "nowrap",
    fontFamily: "'Bebas Neue',sans-serif", fontSize: 13, fontWeight: 700,
    letterSpacing: 0.5, lineHeight: 1,
  };
  return (
    <div className="np-share-wrap" style={{ display:"flex", gap:8, flexWrap:"wrap", marginTop:6, width:"100%" }}>
      {btns.map(btn => (
        <a key={btn.label} href={btn.href} target="_blank" rel="noreferrer"
          style={{ ...SHARE_BTN, background: btn.bg, ...(btn.border ? { border: btn.border } : {}) }}>
          {btn.label}
        </a>
      ))}
      <button onClick={() => { navigator.clipboard.writeText(copyText); alert("Link copied!"); }}
        style={{ ...SHARE_BTN, background: "linear-gradient(45deg,#f09433,#e6683c,#dc2743,#cc2366,#bc1888)" }}>
        Instagram
      </button>
      <button onClick={() => { navigator.clipboard.writeText(copyText); alert("Link copied!"); }}
        style={{ ...SHARE_BTN, background: "rgba(255,255,255,0.15)", border: "1px solid rgba(255,255,255,0.3)" }}>
        COPY LINK
      </button>
    </div>
  );
}

// ── WATCHLIST ────────────────────────────────────────────────────────────────
function useWatchlist(userId, backend) {
  const [watchlist, setWatchlist] = React.useState([]);
  const fetchWL = React.useCallback(async () => {
    if (!userId) return;
    try {
      const r = await fetch(`${backend}/api/watchlist/${userId}`);
      const d = await r.json();
      setWatchlist(d.watchlist || []);
    } catch(e) {}
  }, [userId, backend]);
  React.useEffect(() => { fetchWL(); }, [fetchWL]);

  const addToWatchlist = async (item) => {
    try {
      await fetch(`${backend}/api/watchlist`, { method:"POST", headers:{"Content-Type":"application/json"}, body: JSON.stringify({ user_id:userId, video_id:item.id, title:item.title, thumb:item.thumb||item.thumbnail_url||"", video_type:item.type||"youtube", channel_label:item.channelLabel||item.category||"", url:item.url||"" }) });
      await fetchWL();
    } catch(e) {}
  };

  const removeFromWatchlist = async (videoId) => {
    try { await fetch(`${backend}/api/watchlist/${userId}/${videoId}`, {method:"DELETE"}); await fetchWL(); } catch(e) {}
  };

  const isInWatchlist = (videoId) => watchlist.some(w => w.video_id === videoId);
  return { watchlist, addToWatchlist, removeFromWatchlist, isInWatchlist };
}

function WatchlistPage({ userId, backend, onPlay, onClose }) {
  const { watchlist, removeFromWatchlist } = useWatchlist(userId, backend);
  const isMobile = window.innerWidth <= 480;

  // Look up full video details (video_url / bunny_video_id) since watchlist table
  // only stores minimal info needed for the card display, not playback source.
  const playWatchlistItem = async (item) => {
    console.log('[Watchlist] playWatchlistItem called with:', item);
    try {
      const res = await fetch(backend + '/speeches');
      const data = await res.json();
      const fullVideo = (data.speeches || []).find(v => v.id === item.video_id);
      console.log('[Watchlist] fullVideo lookup result:', fullVideo);
      if (fullVideo) {
        const playObj = {
          id: fullVideo.id,
          title: fullVideo.title,
          thumb: fullVideo.thumbnail_url || item.thumb,
          type: 'speech',
          video_url: fullVideo.video_url || '',
          bunny_video_id: fullVideo.bunny_video_id || '',
          category: fullVideo.category
        };
        onPlay(playObj);
        onClose();
        return;
      }
    } catch (e) { console.error('Watchlist play lookup failed:', e); }
    onPlay({ id: item.video_id, title: item.title, thumb: item.thumb, type: item.video_type, url: item.url });
    onClose();
  };
  return (
    <div style={{ position:"fixed", inset:0, background:"#0a0a0a", zIndex:9999, overflowY:"auto", WebkitOverflowScrolling:"touch" }}>
      {/* Header */}
      <div style={{ position:"sticky", top:0, background:"#0a0a0a", borderBottom:"1px solid rgba(255,215,0,0.15)", padding:"16px 16px 12px", display:"flex", alignItems:"center", justifyContent:"space-between", zIndex:1 }}>
        <div style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:26, letterSpacing:3, color:"#FFD700" }}>
          🎬 MY WATCHLIST
          <span style={{ fontSize:13, marginLeft:10, color:"rgba(255,215,0,0.5)", fontFamily:"'Rajdhani',sans-serif", fontWeight:600 }}>
            {watchlist.length} {watchlist.length === 1 ? "VIDEO" : "VIDEOS"}
          </span>
        </div>
        <button onClick={onClose} style={{ background:"#FF0000", border:"none", color:"#fff", width:44, height:44, borderRadius:"50%", cursor:"pointer", fontSize:18, flexShrink:0 }}>✕</button>
      </div>

      {/* Content */}
      <div style={{ maxWidth:860, margin:"0 auto", padding:"16px 12px 80px" }}>
        {!watchlist.length ? (
          <div style={{ textAlign:"center", padding:"60px 20px" }}>
            <div style={{ fontSize:48, marginBottom:16 }}>📋</div>
            <div style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:20, color:"#555", letterSpacing:2 }}>NO VIDEOS IN WATCHLIST YET</div>
            <div style={{ fontFamily:"'Rajdhani',sans-serif", fontSize:13, color:"#444", marginTop:8 }}>Add videos by clicking + WATCHLIST on any video</div>
          </div>
        ) : watchlist.map(item => (
          <div key={item.video_id} style={{
            display:"flex", gap:12,
            background:"rgba(255,255,255,0.04)",
            border:"1px solid rgba(255,215,0,0.08)",
            borderRadius:10, padding:10,
            alignItems:"flex-start",
            marginBottom:10,
            flexWrap: isMobile ? "wrap" : "nowrap"
          }}>
            {/* Thumbnail */}
            <div
              style={{ flexShrink:0, width:isMobile?"100%":140, height:isMobile?"auto":78, aspectRatio:"16/9", borderRadius:6, overflow:"hidden", background:"#1a0010", cursor:"pointer" }}
              onClick={() => playWatchlistItem(item)}
            >
              {item.thumb
                ? <img src={item.thumb} alt={item.title} style={{ width:"100%", height:"100%", objectFit:"cover", display:"block" }} />
                : <div style={{ width:"100%", height:"100%", display:"flex", alignItems:"center", justifyContent:"center", color:"#333", fontSize:28 }}>🎬</div>
              }
            </div>

            {/* Info + buttons */}
            <div style={{ flex:1, minWidth:0, display:"flex", flexDirection:"column", gap:6 }}>
              <div style={{ fontFamily:"'Rajdhani',sans-serif", fontSize:15, fontWeight:700, color:"#fff", lineHeight:1.3,
                overflow:"hidden", display:"-webkit-box", WebkitLineClamp:2, WebkitBoxOrient:"vertical" }}>
                {item.title}
              </div>
              <div style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:11, color:"#FFD700", letterSpacing:1 }}>
                {(item.channel_label||"NP ORIGINAL").toUpperCase()}
              </div>
              {/* Buttons row */}
              <div style={{ display:"flex", gap:8, marginTop:4, flexWrap:"wrap" }}>
                <button
                  onClick={() => playWatchlistItem(item)}
                  style={{ background:"#FFD700", color:"#000", fontFamily:"'Bebas Neue',sans-serif", fontSize:13, padding:"9px 20px", border:"none", borderRadius:6, cursor:"pointer", minHeight:44, fontWeight:700, letterSpacing:1 }}>
                  ▶ PLAY
                </button>
                <button
                  onClick={() => removeFromWatchlist(item.video_id)}
                  style={{ background:"rgba(255,0,0,0.1)", color:"#FF4444", fontFamily:"'Bebas Neue',sans-serif", fontSize:13, padding:"9px 16px", border:"1px solid rgba(255,0,0,0.4)", borderRadius:6, cursor:"pointer", minHeight:44, letterSpacing:1 }}>
                  REMOVE
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}


// ── LOGIN SOUND (Bold Brass Hit + Fade) ─────────────────────────────────────


// ── BAND 3D SPLASH SCREEN ───────────────────────────────────────────────────
function playBandSound() {
  try {
    const A = new (window.AudioContext || window.webkitAudioContext)();
    const master = A.createDynamicsCompressor();
    master.threshold.value = -16; master.knee.value = 10;
    master.ratio.value = 4; master.attack.value = 0.003; master.release.value = 0.15;
    const mg = A.createGain(); mg.gain.value = 0.68;
    master.connect(mg); mg.connect(A.destination);

    const P = (p) => { const n = A.createStereoPanner(); n.pan.value = p; n.connect(master); return n; };
    const mP = (from, to, s, dur) => {
      const n = A.createStereoPanner();
      n.pan.setValueAtTime(from, A.currentTime + s);
      n.pan.linearRampToValueAtTime(to, A.currentTime + s + dur);
      n.connect(master); return n;
    };

    const bass = (freq, s, dur, vol, p) => {
      const o = A.createOscillator(); const g = A.createGain();
      const f = A.createBiquadFilter(); f.type = 'lowpass'; f.frequency.value = 300; f.Q.value = 2;
      const pk = P(p || 0);
      o.connect(f); f.connect(g); g.connect(pk); o.type = 'sawtooth'; o.frequency.value = freq;
      g.gain.setValueAtTime(0, A.currentTime + s);
      g.gain.linearRampToValueAtTime(vol, A.currentTime + s + 0.01);
      g.gain.exponentialRampToValueAtTime(vol * 0.3, A.currentTime + s + 0.15);
      g.gain.exponentialRampToValueAtTime(0.001, A.currentTime + s + dur);
      o.start(A.currentTime + s); o.stop(A.currentTime + s + dur + 0.05);
    };

    const chord = (freqs, s, dur, vol, p) => {
      freqs.forEach((f, i) => {
        const o = A.createOscillator(); const g = A.createGain();
        const flt = A.createBiquadFilter(); flt.type = 'bandpass'; flt.frequency.value = f * 2; flt.Q.value = 3;
        const pk = P(p || 0);
        o.connect(flt); flt.connect(g); g.connect(pk); o.type = 'sawtooth'; o.frequency.value = f;
        g.gain.setValueAtTime(0, A.currentTime + s + i * 0.008);
        g.gain.linearRampToValueAtTime(vol, A.currentTime + s + i * 0.008 + 0.02);
        g.gain.exponentialRampToValueAtTime(0.001, A.currentTime + s + dur);
        o.start(A.currentTime + s + i * 0.008); o.stop(A.currentTime + s + dur + 0.05);
      });
    };

    const hat = (s, p, vol) => {
      const pk = P(p || 0);
      const nl = Math.floor(A.sampleRate * 0.04); const nb = A.createBuffer(1, nl, A.sampleRate);
      const nd = nb.getChannelData(0);
      for (let i = 0; i < nl; i++) nd[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / nl, 5);
      const ns = A.createBufferSource(); const ng = A.createGain();
      const nf = A.createBiquadFilter(); nf.type = 'highpass'; nf.frequency.value = 10000;
      ns.buffer = nb; ns.connect(nf); nf.connect(ng); ng.connect(pk);
      ng.gain.setValueAtTime(vol, A.currentTime + s); ns.start(A.currentTime + s);
    };

    const kick = (s, p, vol, dec) => {
      const pk = P(p || 0);
      const o = A.createOscillator(); const g = A.createGain();
      o.connect(g); g.connect(pk); o.type = 'sine';
      o.frequency.setValueAtTime(160, A.currentTime + s);
      o.frequency.exponentialRampToValueAtTime(40, A.currentTime + s + 0.07);
      g.gain.setValueAtTime(vol, A.currentTime + s);
      g.gain.exponentialRampToValueAtTime(0.001, A.currentTime + s + dec);
      o.start(A.currentTime + s); o.stop(A.currentTime + s + dec + 0.05);
    };

    const snare = (s, p, vol) => {
      const pk = P(p || 0);
      const nl = Math.floor(A.sampleRate * 0.15); const nb = A.createBuffer(1, nl, A.sampleRate);
      const nd = nb.getChannelData(0);
      for (let i = 0; i < nl; i++) nd[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / nl, 1.8);
      const ns = A.createBufferSource(); const ng = A.createGain();
      const nf = A.createBiquadFilter(); nf.type = 'bandpass'; nf.frequency.value = 1500; nf.Q.value = 1;
      ns.buffer = nb; ns.connect(nf); nf.connect(ng); ng.connect(pk);
      ng.gain.setValueAtTime(vol, A.currentTime + s);
      ng.gain.exponentialRampToValueAtTime(0.001, A.currentTime + s + 0.15);
      ns.start(A.currentTime + s);
    };

    const lead = (freq, s, dur, vol, from, to) => {
      const mp = mP(from, to, s, dur);
      const o = A.createOscillator(); const g = A.createGain();
      const f = A.createBiquadFilter(); f.type = 'bandpass'; f.frequency.value = freq * 1.5; f.Q.value = 2;
      const lfo = A.createOscillator(); const lg = A.createGain();
      lfo.frequency.value = 6; lg.gain.value = 4;
      lfo.connect(lg); lg.connect(o.frequency);
      o.connect(f); f.connect(g); g.connect(mp); o.type = 'sawtooth'; o.frequency.value = freq;
      g.gain.setValueAtTime(0, A.currentTime + s);
      g.gain.linearRampToValueAtTime(vol, A.currentTime + s + 0.05);
      g.gain.exponentialRampToValueAtTime(0.001, A.currentTime + s + dur);
      o.start(A.currentTime + s); lfo.start(A.currentTime + s);
      o.stop(A.currentTime + s + dur + 0.05); lfo.stop(A.currentTime + s + dur + 0.05);
    };

    const sub = (s, freq, dur, vol) => {
      const o = A.createOscillator(); const g = A.createGain();
      o.connect(g); g.connect(A.destination); o.type = 'sine';
      o.frequency.setValueAtTime(freq * 1.5, A.currentTime + s);
      o.frequency.exponentialRampToValueAtTime(freq, A.currentTime + s + 0.1);
      g.gain.setValueAtTime(vol, A.currentTime + s);
      g.gain.exponentialRampToValueAtTime(0.001, A.currentTime + s + dur);
      o.start(A.currentTime + s); o.stop(A.currentTime + s + dur + 0.05);
    };

    sub(0.0, 40, 1.5, 0.5); sub(0.1, 55, 1.3, 0.4);
    bass(82, 0.3, 0.4, 0.7, -0.6); bass(110, 0.55, 0.35, 0.6, -0.5); bass(82, 0.75, 0.4, 0.65, -0.6);
    hat(0.5, 0.7, 0.3); hat(0.75, 0.6, 0.25); hat(1.0, 0.8, 0.3);
    kick(0.8, 0.0, 0.9, 0.55);
    chord([196, 246, 293, 392], 1.0, 0.8, 0.25, 0.7);
    lead(392, 1.0, 0.6, 0.3, -0.8, 0.8);
    bass(82, 1.2, 0.35, 0.7, -0.6); kick(1.4, 0.0, 0.9, 0.6); snare(1.6, 0.2, 0.6); hat(1.4, 0.7, 0.28);
    chord([246, 310, 370], 1.6, 0.7, 0.28, -0.5); lead(523, 1.6, 0.5, 0.28, 0.7, -0.7);
    bass(110, 1.8, 0.3, 0.75, -0.6); kick(1.8, 0.0, 1.0, 0.7); hat(1.8, 0.5, 0.3);
    chord([196, 246, 293, 370, 440], 1.85, 1.2, 0.32, 0.0);
    lead(440, 2.0, 0.8, 0.35, 1.0, -1.0);
    kick(2.2, -0.4, 0.9, 0.7); snare(2.3, 0.0, 0.7); kick(2.38, 0.4, 0.9, 0.8);
    hat(2.2, 0.6, 0.3); hat(2.3, -0.6, 0.3); bass(82, 2.2, 0.5, 0.75, -0.6);
    kick(2.5, 0.0, 1.5, 1.5); snare(2.5, 0.0, 1.2);
    chord([130, 164, 196, 246, 293, 370, 440], 2.5, 2.5, 0.4, 0.0);
    sub(2.5, 40, 4.0, 1.2); sub(2.5, 55, 3.5, 1.0);
    bass(55, 2.5, 2.5, 0.9, 0.0); lead(880, 2.5, 1.5, 0.35, -1.0, 1.0);
    kick(3.0, -0.8, 0.7, 0.5); kick(3.4, 0.8, 0.5, 0.35); snare(3.2, 0.0, 0.4);
    sub(2.7, 38, 2.5, 0.4);
  } catch(e) {}
}

function SplashScreen({ onDone }) {
  const [step, setStep] = React.useState(0);
  const startSplash = React.useCallback(() => {
    if (window._npSplashPlayed) return;
    window._npSplashPlayed = true;
    setStep(1);
    playBandSound();
    const timers = [
      setTimeout(() => setStep(2), 800),
      setTimeout(() => setStep(3), 1400),
      setTimeout(() => setStep(4), 1700),
      setTimeout(() => setStep(5), 2400),
      setTimeout(() => setStep(6), 4000),
      setTimeout(() => { try { localStorage.setItem('np_splash_shown','1'); } catch(e){} onDone(); }, 5000),
    ];
    window._npSplashTimers = timers;
  }, [onDone]);

  React.useEffect(() => {
    return () => { if(window._npSplashTimers) window._npSplashTimers.forEach(clearTimeout); };
  }, []);

  const cols = ['#FFD700','#FFA500','#FF8C00','#FFFACD'];

  return (
    <div className={`np-splash-wrap${step >= 6 ? ' fade-out' : ''}`}>
      {/* Background glow */}
      <div style={{ position:'absolute', inset:0, background: step >= 5 ? 'radial-gradient(ellipse 70% 60% at 50% 50%, rgba(255,140,0,0.10) 0%, rgba(100,0,0,0.06) 40%, transparent 70%)' : 'transparent', transition:'background 0.6s ease' }} />

      {/* Sweep */}
      {step >= 5 && <div className="np-splash-sw" />}

      {/* Rings */}
      {step >= 5 && [0,1,2,3].map(i => (
        <div key={i} className="np-splash-ring" style={{ border:`${2-i*0.4}px solid rgba(255,${180+i*15},0,${0.7-i*0.15})`, animationDelay:`${i*0.12}s`, animationDuration:`${1.8+i*0.35}s` }} />
      ))}

      {/* Orbs */}
      {step >= 5 && Array.from({length:24},(_,i) => (
        <div key={i} className="np-splash-orb" style={{ width:2+(i%3)*1.5, height:2+(i%3)*1.5, margin:`-${1+(i%3)*0.75}px`, background:cols[i%4], boxShadow:`0 0 6px ${cols[i%4]}`, '--r':`${(i/24)*360}deg`, animationDuration:`${1.5+(i%3)*0.5}s`, animationDelay:`${(i%5)*0.08}s` }} />
      ))}

      {/* N Logo */}
      <div style={{ position:'relative', zIndex:10, display:'flex', flexDirection:'column', alignItems:'center' }}>
        <div className={`np-splash-n${step>=5?' s5':step>=3?' s3':step>=2?' s2':step>=1?' s1':''}`}>N</div>

        {/* Subtitle */}
        <div className={`np-splash-sub${step >= 3 ? ' show' : ''}`}>
          <div className={`np-splash-nm${step >= 3 ? ' show' : ''}`}>NETHAJI PRIME</div>
          <div className={`np-splash-ln${step >= 4 ? ' show' : ''}`} />
          <div style={{ display:'flex', alignItems:'center', gap:6, flexShrink:1, minWidth:0, overflow:'hidden', marginTop:3 }}>
            <div className={`np-splash-ott${step >= 4 ? ' show' : ''}`}>OTT</div>
            <div className={`np-splash-ex${step >= 4 ? ' show' : ''}`}>EXCLUSIVE STREAMING</div>
          </div>
          <div className={`np-splash-ta${step >= 5 ? ' show' : ''}`}>தமிழ் சமூக அரசியல் ஊடகம்</div>
        </div>
      </div>

      {/* TAP TO ENTER - shown before splash starts */}
      {step === 0 && (
        <div onClick={startSplash} style={{ position:'absolute', inset:0, display:'flex', alignItems:'center', justifyContent:'center', flexDirection:'column', gap:16, cursor:'pointer', zIndex:20 }}>
          <div style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:'clamp(48px,12vw,96px)', color:'#FFD700', letterSpacing:4, textShadow:'0 0 40px rgba(255,215,0,0.6)' }}>NETHAJI PRIME</div>
          <div style={{ fontFamily:"'Rajdhani',sans-serif", fontWeight:700, fontSize:14, letterSpacing:4, color:'rgba(255,215,0,0.5)', border:'1px solid rgba(255,215,0,0.3)', padding:'10px 28px', borderRadius:4, animation:'np-badgeFade 1.5s ease infinite alternate' }}>TAP TO ENTER</div>
          <div style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:10, letterSpacing:3, color:'rgba(255,255,255,0.2)', marginTop:8 }}>OTT EXCLUSIVE STREAMING</div>
        </div>
      )}

      {/* Bottom vignette */}
      <div style={{ position:'absolute', bottom:0, left:0, right:0, height:'40%', background:'linear-gradient(to top, #000, transparent)', pointerEvents:'none' }} />
    </div>
  );
}

// ── SKELETON LOADER ───────────────────────────────────────────────
function SkeletonCard() {
  return (
    <div className="np-skeleton-card">
      <div className="np-skeleton np-skeleton-thumb" />
      <div className="np-skeleton np-skeleton-title" />
      <div className="np-skeleton np-skeleton-title2" />
      <div className="np-skeleton np-skeleton-meta" />
    </div>
  );
}
function SkeletonRow() {
  return (
    <div style={{ marginBottom:28 }}>
      <div className="np-skeleton np-skeleton-row-label" />
      <div className="np-skeleton-cards">
        {[0,1,2,3,4].map(i => <SkeletonCard key={i} />)}
      </div>
    </div>
  );
}
function SkeletonScreen() {
  return (
    <div style={{ padding:'0 16px' }}>
      <div className="np-skeleton np-skeleton-hero" />
      <SkeletonRow />
      <SkeletonRow />
      <SkeletonRow />
    </div>
  );
}



// -- AVATAR MENU --
function AvatarMenu({ user, onLogout, onWatchlist, onUpgrade, onLikedVideos, onWatchHistory, onSettings, onAdminDashboard, onAdvertise }) {
  const [open, setOpen] = React.useState(false);
  const ref = React.useRef(null);
  React.useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, []);
  if (!user) return null;
  const name = user.full_name || user.name || user.email || 'User';
  const initial = name.charAt(0).toUpperCase();
  const isAdmin = user.is_admin || user.is_superadmin;
  const menuItems = [
    { icon: '📺', label: 'My Watchlist', action: () => { onWatchlist && onWatchlist(); setOpen(false); } },
    { icon: '❤️', label: 'Liked Videos', action: () => { onLikedVideos && onLikedVideos(); setOpen(false); } },
    { icon: '⏱', label: 'Watch History', action: () => { onWatchHistory && onWatchHistory(); setOpen(false); } },
    { icon: '⚙️', label: 'Settings', action: () => { onSettings && onSettings(); setOpen(false); } },
    { icon: '📢', label: 'Advertise With Us', action: () => { onAdvertise && onAdvertise(); setOpen(false); } },
    ...(isAdmin ? [{ icon: '🛡️', label: 'Admin Dashboard', action: () => { onAdminDashboard && onAdminDashboard(); setOpen(false); } }] : []),
  ];
  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <div onClick={() => setOpen(s => !s)} style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer', padding: '4px 8px', borderRadius: 8, border: '1px solid rgba(212,168,67,0.3)' }}>
        {user.picture
          ? <img src={user.picture} alt={name} onError={(e) => { e.target.style.display='none'; }} style={{ width: 28, height: 28, borderRadius: '50%', border: '2px solid #FFD700', objectFit: 'cover', flexShrink: 0 }} />
          : <div style={{ width: 28, height: 28, borderRadius: '50%', background: 'linear-gradient(135deg,#FFD700,#d4a843)', color: '#000', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, fontWeight: 900, flexShrink: 0 }}>{initial}</div>
        }
        <span className="np-username-desktop" style={{ fontFamily: "'Bebas Neue',sans-serif", fontSize: 11, color: '#FFD700', letterSpacing: 1 }}>{name.split(' ')[0].toUpperCase()}</span>
        <span style={{ color: '#FFD700', fontSize: 8 }}>{open ? '▲' : '▼'}</span>
      </div>
      {open && (
        <div style={{ position: 'fixed', top: 60, right: 16, width: 220, background: '#1a0505', border: '1px solid rgba(212,168,67,0.3)', borderRadius: 10, boxShadow: '0 8px 32px rgba(0,0,0,0.8)', zIndex: 9999, overflow: 'hidden' }}>
          <div style={{ padding: '12px 16px', borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
            <div style={{ color: '#FFD700', fontFamily: "'Bebas Neue',sans-serif", fontSize: 14 }}>{name}</div>
            <div style={{ color: 'rgba(255,255,255,0.4)', fontSize: 11 }}>{user.email || ''}</div>
          </div>
          {menuItems.map(item => (
            <div key={item.label} onClick={item.action}
              style={{ padding: '10px 16px', display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer', color: item.gold ? '#FFD700' : '#fff', fontSize: 13, borderBottom: '1px solid rgba(255,255,255,0.05)' }}>
              <span>{item.icon}</span>{item.label}
            </div>
          ))}
          <div onClick={() => { onLogout && onLogout(); setOpen(false); }}
            style={{ padding: '10px 16px', display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer', color: '#ff4444', fontSize: 13 }}>
            <span>🚪</span> Sign Out
          </div>
        </div>
      )}
    </div>
  );
}


// -- LIKED VIDEOS PANEL --
function LikedVideosPanel({ userId, backend, onPlay, onClose }) {
  const [videos, setVideos] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  React.useEffect(() => {
    if (!userId) { setLoading(false); return; }
    fetch(backend + '/api/user-likes/' + userId)
      .then(r => r.json())
      .then(d => {
        // Get video IDs and fetch their details from shorts
        const ids = (d.likes || []).map(l => l.video_id);
        fetch(backend + '/speeches')
            .then(r => r.json())
            .then(vd => {
              const all = vd.speeches || [];
              setVideos(ids.map(id => all.find(v => v.id === id) || { id, title: 'Video ' + id.slice(0,8) }));
              setLoading(false);
            })
            .catch(() => {
              setVideos(ids.map(id => ({ id, title: id.slice(0,8) })));
              setLoading(false);
            });
            return;
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [userId, backend]);
  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.92)', zIndex:9999, display:'flex', alignItems:'center', justifyContent:'center', padding:16 }}>
      <div style={{ background:'#1a0505', borderRadius:10, width:'100%', maxWidth:600, maxHeight:'80vh', overflow:'auto', border:'1px solid rgba(212,168,67,0.3)' }}>
        <div style={{ padding:'16px 20px', borderBottom:'1px solid rgba(255,255,255,0.1)', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
          <span style={{ color:'#FFD700', fontFamily:"'Bebas Neue',sans-serif", fontSize:18, letterSpacing:2 }}>❤️ LIKED VIDEOS</span>
          <button onClick={onClose} style={{ background:'none', border:'none', color:'#fff', fontSize:20, cursor:'pointer' }}>✕</button>
        </div>
        {loading ? <div style={{ padding:24, color:'rgba(255,255,255,0.4)', textAlign:'center' }}>Loading...</div>
          : videos.length === 0 ? <div style={{ padding:24, color:'rgba(255,255,255,0.4)', textAlign:'center' }}>No liked videos yet</div>
          : <div style={{ padding:16 }}>
              {videos.map((v,i) => (
                <div key={v.id}
                  onClick={() => { if(onPlay) onPlay({...v, type: v.type || 'speech'}); onClose(); }}
                  style={{ display:'flex', gap:12, padding:'10px 0', borderBottom:'1px solid rgba(255,255,255,0.06)', alignItems:'center', cursor:'pointer' }}
                  onMouseEnter={e=>e.currentTarget.style.background='rgba(255,255,255,0.04)'}
                  onMouseLeave={e=>e.currentTarget.style.background='transparent'}>
                  {(v.thumbnail_url || v.thumb)
                    ? <img src={v.thumbnail_url||v.thumb} alt={v.title} style={{ width:96, height:54, objectFit:'cover', borderRadius:6, flexShrink:0, border:'1px solid rgba(255,215,0,0.2)' }} />
                    : <div style={{ width:96, height:54, background:'rgba(255,215,0,0.1)', borderRadius:6, flexShrink:0, display:'flex', alignItems:'center', justifyContent:'center', fontSize:22 }}>{'\u2764\uFE0F'}</div>
                  }
                  <div style={{ flex:1, minWidth:0 }}>
                    <div style={{ color:'#fff', fontSize:13, fontWeight:600, lineHeight:1.3, overflow:'hidden', display:'-webkit-box', WebkitLineClamp:2, WebkitBoxOrient:'vertical' }}>{v.title || 'Video'}</div>
                    <div style={{ color:'rgba(255,255,255,0.4)', fontSize:11, marginTop:3 }}>{v.speaker_name||v.channelLabel||v.category||'NP Original'}</div>
                    <div style={{ color:'#FFD700', fontSize:10, marginTop:4 }}>{'\u25BA PLAY'}</div>
                  </div>
                </div>
              ))}
            </div>
        }
      </div>
    </div>
  );
}

// -- WATCH HISTORY PANEL --
function WatchHistoryPanel({ userId, backend, onClose, onPlay }) {
  const [history, setHistory] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [clearing, setClearing] = React.useState(false);
  const isMobile = window.innerWidth <= 480;

  React.useEffect(() => {
    if (!userId) { setLoading(false); return; }
    fetch(backend + '/api/watch-progress/' + userId)
      .then(r => r.json())
      .then(d => { setHistory(d.progress || []); setLoading(false); })
      .catch(() => setLoading(false));
  }, [userId, backend]);

  const clearHistory = async () => {
    if (!window.confirm('Clear all watch history?')) return;
    setClearing(true);
    try {
      await fetch(backend + '/api/watch-progress/' + userId, { method: 'DELETE' });
      setHistory([]);
    } catch(e) {}
    setClearing(false);
  };

  return (
    <div style={{ position:'fixed', top:0, left:0, right:0, bottom:0, background:'#0a0a0a', zIndex:9999, overflowY:'scroll', WebkitOverflowScrolling:'touch', minHeight:'100vh', touchAction:'pan-y' }}>
      <div style={{ position:'sticky', top:0, background:'#0a0a0a', borderBottom:'1px solid rgba(255,215,0,0.15)', padding:'14px 16px', display:'flex', alignItems:'center', justifyContent:'space-between', zIndex:1 }}>
        <div style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:22, letterSpacing:2, color:'#FFD700' }}>
          ⏱ WATCH HISTORY
          {history.length > 0 && <span style={{ fontSize:12, marginLeft:10, color:'rgba(255,215,0,0.5)', fontFamily:"'Rajdhani',sans-serif", fontWeight:600 }}>{history.length} VIDEOS</span>}
        </div>
        <div style={{ display:'flex', gap:8, alignItems:'center' }}>
          {history.length > 0 && (
            <button onClick={clearHistory} disabled={clearing} style={{ background:'rgba(255,0,0,0.1)', border:'1px solid rgba(255,0,0,0.3)', color:'#ff4444', fontFamily:"'Bebas Neue',sans-serif", fontSize:11, padding:'8px 12px', borderRadius:6, cursor:'pointer', letterSpacing:1, minHeight:44 }}>
              {clearing ? '...' : 'CLEAR ALL'}
            </button>
          )}
          <button onClick={onClose} style={{ background:'#FF0000', border:'none', color:'#fff', width:44, height:44, borderRadius:'50%', cursor:'pointer', fontSize:18, flexShrink:0 }}>✕</button>
        </div>
      </div>
      <div style={{ maxWidth:860, margin:'0 auto', padding:'16px 12px 80px' }}>
        {loading ? (
          <div style={{ textAlign:'center', padding:'60px 20px', color:'rgba(255,255,255,0.3)', fontFamily:"'Bebas Neue',sans-serif", letterSpacing:2 }}>LOADING...</div>
        ) : history.length === 0 ? (
          <div style={{ textAlign:'center', padding:'60px 20px' }}>
            <div style={{ fontSize:48, marginBottom:16 }}>⏱</div>
            <div style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:20, color:'#555', letterSpacing:2 }}>NO WATCH HISTORY YET</div>
            <div style={{ fontFamily:"'Rajdhani',sans-serif", fontSize:13, color:'#444', marginTop:8 }}>Videos you watch will appear here</div>
          </div>
        ) : history.map((v, i) => {
          const pct = Math.min(100, Math.round(v.progress || 0));
          const isComplete = pct >= 90;
          return (
            <div key={v.video_id || i} style={{ display:'flex', gap:12, background:'rgba(255,255,255,0.04)', border:'1px solid rgba(255,215,0,0.08)', borderRadius:10, padding:10, marginBottom:10, alignItems:'flex-start', flexWrap: isMobile ? 'wrap' : 'nowrap' }}>
              <div style={{ flexShrink:0, width:isMobile?'100%':140, aspectRatio:'16/9', borderRadius:6, overflow:'hidden', background:'#1a0010', cursor:'pointer', position:'relative' }}
                onClick={() => onPlay && onPlay(v)}>
                {v.thumb
                  ? <img src={v.thumb} alt={v.title} style={{ width:'100%', height:'100%', objectFit:'cover', display:'block' }} />
                  : <div style={{ width:'100%', height:'100%', display:'flex', alignItems:'center', justifyContent:'center', color:'#333', fontSize:28 }}>🎬</div>
                }
                <div style={{ position:'absolute', bottom:0, left:0, right:0, height:3, background:'rgba(255,255,255,0.2)' }}>
                  <div style={{ height:'100%', width:pct+'%', background: isComplete ? '#00d480' : '#FFD700' }} />
                </div>
                {isComplete && <div style={{ position:'absolute', top:6, right:6, background:'#00d480', color:'#000', fontSize:9, fontWeight:800, padding:'2px 6px', borderRadius:8, fontFamily:"'Bebas Neue',sans-serif", letterSpacing:1 }}>DONE</div>}
              </div>
              <div style={{ flex:1, minWidth:0, display:'flex', flexDirection:'column', gap:6 }}>
                <div style={{ fontFamily:"'Rajdhani',sans-serif", fontSize:15, fontWeight:700, color:'#fff', lineHeight:1.3, overflow:'hidden', display:'-webkit-box', WebkitLineClamp:2, WebkitBoxOrient:'vertical' }}>
                  {v.title || v.video_id}
                </div>
                <div style={{ display:'flex', alignItems:'center', gap:8 }}>
                  <div style={{ flex:1, height:4, background:'rgba(255,255,255,0.1)', borderRadius:2, overflow:'hidden' }}>
                    <div style={{ height:'100%', width:pct+'%', background: isComplete ? '#00d480' : '#FFD700', borderRadius:2 }} />
                  </div>
                  <span style={{ fontFamily:"'Rajdhani',sans-serif", fontSize:11, color: isComplete ? '#00d480' : 'rgba(255,215,0,0.7)', fontWeight:700, flexShrink:0 }}>
                    {isComplete ? 'Completed' : pct + '% watched'}
                  </span>
                </div>
                {onPlay && (
                  <button onClick={() => { onPlay(v); onClose(); }}
                    style={{ background: isComplete ? 'rgba(0,212,128,0.15)' : '#FFD700', color: isComplete ? '#00d480' : '#000', fontFamily:"'Bebas Neue',sans-serif", fontSize:13, padding:'9px 20px', border: isComplete ? '1px solid #00d480' : 'none', borderRadius:6, cursor:'pointer', minHeight:44, fontWeight:700, letterSpacing:1, alignSelf:'flex-start' }}>
                    {isComplete ? '▶ WATCH AGAIN' : '▶ RESUME'}
                  </button>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

// -- SETTINGS PANEL --
function SettingsPanel({ user, onClose }) {
  const [lang, setLang] = React.useState(localStorage.getItem('np_lang') || 'ta');
  const [quality, setQuality] = React.useState(localStorage.getItem('np_quality') || 'auto');
  const [notifications, setNotifications] = React.useState(!!localStorage.getItem('np_push_subscribed'));
  const save = () => {
    localStorage.setItem('np_lang', lang);
    localStorage.setItem('np_quality', quality);
    alert('Settings saved!');
    onClose();
  };
  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.92)', zIndex:9999, display:'flex', alignItems:'center', justifyContent:'center', padding:16 }}>
      <div style={{ background:'#1a0505', borderRadius:10, width:'100%', maxWidth:500, border:'1px solid rgba(212,168,67,0.3)' }}>
        <div style={{ padding:'16px 20px', borderBottom:'1px solid rgba(255,255,255,0.1)', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
          <span style={{ color:'#FFD700', fontFamily:"'Bebas Neue',sans-serif", fontSize:18, letterSpacing:2 }}>⚙️ SETTINGS</span>
          <button onClick={onClose} style={{ background:'none', border:'none', color:'#fff', fontSize:20, cursor:'pointer' }}>✕</button>
        </div>
        <div style={{ padding:20 }}>
          <div style={{ marginBottom:16 }}>
            <div style={{ color:'rgba(255,255,255,0.6)', fontSize:12, marginBottom:6, letterSpacing:1 }}>LANGUAGE</div>
            <select value={lang} onChange={e=>setLang(e.target.value)} style={{ background:'#0f0005', color:'#fff', border:'1px solid rgba(212,168,67,0.3)', borderRadius:4, padding:'6px 12px', width:'100%', fontSize:14 }}>
              <option value="ta">Tamil</option>
              <option value="en">English</option>
            </select>
          </div>
          <div style={{ marginBottom:16 }}>
            <div style={{ color:'rgba(255,255,255,0.6)', fontSize:12, marginBottom:6, letterSpacing:1 }}>VIDEO QUALITY</div>
            <select value={quality} onChange={e=>setQuality(e.target.value)} style={{ background:'#0f0005', color:'#fff', border:'1px solid rgba(212,168,67,0.3)', borderRadius:4, padding:'6px 12px', width:'100%', fontSize:14 }}>
              <option value="auto">Auto</option>
              <option value="1080p">1080p HD</option>
              <option value="720p">720p</option>
              <option value="480p">480p</option>
            </select>
          </div>
          <div style={{ marginBottom:24, display:'flex', justifyContent:'space-between', alignItems:'center' }}>
            <span style={{ color:'rgba(255,255,255,0.7)', fontSize:14 }}>Push Notifications</span>
            <span style={{ color: notifications ? '#00d480' : 'rgba(255,255,255,0.3)', fontSize:13 }}>{notifications ? '✓ Enabled' : 'Not enabled'}</span>
          </div>
          <div style={{ display:'flex', gap:10 }}>
            <button onClick={save} style={{ flex:1, background:'#FFD700', color:'#000', border:'none', borderRadius:6, padding:'10px', fontFamily:"'Bebas Neue',sans-serif", fontSize:14, letterSpacing:2, cursor:'pointer' }}>SAVE</button>
            <button onClick={onClose} style={{ flex:1, background:'transparent', color:'#fff', border:'1px solid rgba(255,255,255,0.2)', borderRadius:6, padding:'10px', fontSize:14, cursor:'pointer' }}>CANCEL</button>
          </div>
        </div>
      </div>
    </div>
  );
}

// -- NOTIFICATION BELL --
const PUSH_PREF_DEFAULTS = { new_uploads: true, rss_videos: true, bulletin: true, deals: false };
const PUSH_PREF_LABELS = [
  ["new_uploads", "New OTT uploads"],
  ["rss_videos", "New YouTube videos"],
  ["bulletin", "Daily bulletin"],
  ["deals", "Deals & offers"],
];

function PushPrefsSection({ backend }) {
  const [prefs, setPrefs] = React.useState(() => {
    try { return JSON.parse(localStorage.getItem('np_push_prefs')) || null; } catch { return null; }
  });
  const [open, setOpen] = React.useState(false);
  React.useEffect(() => {
    if (!open || prefs) return;
    (async () => {
      try {
        const reg = await navigator.serviceWorker.ready;
        const sub = await reg.pushManager.getSubscription();
        if (!sub) return;
        const r = await fetch(backend + '/api/push-prefs?endpoint=' + encodeURIComponent(sub.endpoint));
        const d = await r.json();
        if (d.prefs) { setPrefs(d.prefs); localStorage.setItem('np_push_prefs', JSON.stringify(d.prefs)); }
      } catch {}
    })();
  }, [open, prefs, backend]);
  const cur = prefs || PUSH_PREF_DEFAULTS;
  const toggle = async (key) => {
    const next = { ...cur, [key]: !cur[key] };
    setPrefs(next);
    localStorage.setItem('np_push_prefs', JSON.stringify(next));
    try {
      const reg = await navigator.serviceWorker.ready;
      const sub = await reg.pushManager.getSubscription();
      if (sub) await fetch(backend + '/api/push-prefs', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ endpoint: sub.endpoint, prefs: next })
      });
    } catch {}
  };
  return (
    <div style={{ borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
      <div onClick={() => setOpen(o => !o)} style={{ padding: '8px 16px', color: 'rgba(255,255,255,0.6)', fontSize: 11, letterSpacing: 1, cursor: 'pointer', display: 'flex', justifyContent: 'space-between' }}>
        <span>{'\u2699 NOTIFICATION PREFERENCES'}</span><span>{open ? '\u25b2' : '\u25bc'}</span>
      </div>
      {open && PUSH_PREF_LABELS.map(([key, label]) => (
        <label key={key} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '6px 16px', color: '#fff', fontSize: 12, cursor: 'pointer' }}>
          <span>{label}</span>
          <input type="checkbox" checked={!!cur[key]} onChange={() => toggle(key)} />
        </label>
      ))}
    </div>
  );
}

function PushPromptBanner({ backend }) {
  const [visible, setVisible] = React.useState(false);
  const [busy, setBusy] = React.useState(false);
  React.useEffect(() => {
    try {
      if (!('serviceWorker' in navigator) || !('PushManager' in window)) return;
      if (typeof Notification !== 'undefined' && Notification.permission === 'denied') return;
      if (localStorage.getItem('np_push_subscribed')) return;
      const snooze = parseInt(localStorage.getItem('np_push_prompt_snooze') || '0');
      if (Date.now() - snooze < 7 * 86400000) return;
      const visits = parseInt(localStorage.getItem('np_visit_count') || '0');
      const engaged = localStorage.getItem('np_engaged') === '1';
      // Only after real engagement: 2nd visit or a video watched — never on
      // first page load (that prompt gets denied and burns the permission).
      if (visits >= 2 || engaged) setVisible(true);
    } catch {}
  }, []);
  if (!visible) return null;
  const enable = async () => {
    setBusy(true);
    try {
      const permission = await Notification.requestPermission();
      if (permission === 'granted') {
        const reg = await navigator.serviceWorker.ready;
        const keyRes = await fetch(backend + '/api/push-vapid-key');
        const { public_key } = await keyRes.json();
        if (public_key) {
          const sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: public_key });
          await fetch(backend + '/api/push-subscribe', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ subscription: sub.toJSON(), prefs: PUSH_PREF_DEFAULTS })
          });
          localStorage.setItem('np_push_subscribed', '1');
        }
      }
    } catch (e) { console.error('Push prompt error:', e); }
    setBusy(false); setVisible(false);
  };
  const later = () => { try { localStorage.setItem('np_push_prompt_snooze', Date.now().toString()); } catch {} setVisible(false); };
  return (
    <div style={{ position: 'fixed', bottom: 76, left: '50%', transform: 'translateX(-50%)', zIndex: 9998, background: '#1a0505', border: '1px solid rgba(255,215,0,0.4)', borderRadius: 10, padding: '12px 16px', display: 'flex', alignItems: 'center', gap: 12, boxShadow: '0 8px 32px rgba(0,0,0,0.8)', maxWidth: '92vw' }}>
      <span style={{ fontSize: 20 }}>{'\ud83d\udd14'}</span>
      <span style={{ color: '#fff', fontSize: 13 }}>Get notified when new videos drop</span>
      <button onClick={enable} disabled={busy} style={{ background: '#FFD700', color: '#000', border: 'none', borderRadius: 6, padding: '6px 12px', fontSize: 12, fontWeight: 700, cursor: 'pointer', whiteSpace: 'nowrap' }}>{busy ? '...' : 'ENABLE'}</button>
      <button onClick={later} style={{ background: 'none', color: 'rgba(255,255,255,0.5)', border: 'none', fontSize: 12, cursor: 'pointer' }}>Later</button>
    </div>
  );
}

function NotificationBell({ backend }) {
  const [open, setOpen] = React.useState(false);
  const [notifications, setNotifications] = React.useState([]);
  const [unread, setUnread] = React.useState(0);
  const [loading, setLoading] = React.useState(false);
  const ref = React.useRef(null);

  React.useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, []);

  const fetchNotifications = React.useCallback(async () => {
    try {
      const r = await fetch(backend + '/api/notifications');
      const d = await r.json();
      const notifs = d.notifications || [];
      setNotifications(notifs);
      const lastSeen = parseInt(localStorage.getItem('np_notif_last_seen') || '0');
      setUnread(notifs.filter(n => new Date(n.created_at).getTime() > lastSeen).length);
    } catch(e) {}
  }, [backend]);

  React.useEffect(() => {
    fetchNotifications();
    const iv = setInterval(fetchNotifications, 60000);
    return () => clearInterval(iv);
  }, [fetchNotifications]);

  const handleSubscribe = async () => {
    if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
      alert('Push notifications not supported in this browser.'); return;
    }
    setLoading(true);
    try {
      const permission = await Notification.requestPermission();
      if (permission !== 'granted') { setLoading(false); return; }
      const reg = await navigator.serviceWorker.ready;
      const keyRes = await fetch(backend + '/api/push-vapid-key');
      const { public_key } = await keyRes.json();
      if (!public_key) { alert('Push not configured yet.'); setLoading(false); return; }
      const sub = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: public_key
      });
      await fetch(backend + '/api/push-subscribe', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ subscription: sub.toJSON() })
      });
      localStorage.setItem('np_push_subscribed', '1');
      setIsPushSubscribed(true);
      alert('Push notifications enabled!');
    } catch(e) { console.error('Push error:', e); }
    setLoading(false);
  };

  const handleOpen = () => {
    setOpen(o => !o);
    localStorage.setItem('np_notif_last_seen', Date.now().toString());
    setUnread(0);
  };

  const [isPushSubscribed, setIsPushSubscribed] = React.useState(!!localStorage.getItem('np_push_subscribed'));
  React.useEffect(() => {
    if ('serviceWorker' in navigator && 'PushManager' in window) {
      navigator.serviceWorker.ready.then(reg => {
        reg.pushManager.getSubscription().then(sub => {
          if (sub) { localStorage.setItem('np_push_subscribed', '1'); setIsPushSubscribed(true); }
        });
      }).catch(()=>{});
    }
  }, []);
  const isSubscribed = isPushSubscribed;

  return (
    <div ref={ref} style={{ position: 'relative', display: 'inline-block' }}>
      <button onClick={handleOpen} style={{ background: 'none', border: 'none', cursor: 'pointer', position: 'relative', padding: '4px 8px', fontSize: 20, lineHeight: 1 }} title="Notifications">
        <span role="img" aria-label="bell">&#x1F514;</span>
        {unread > 0 && (
          <span style={{ position: 'absolute', top: 0, right: 0, background: '#FF0000', color: '#fff', borderRadius: '50%', width: 16, height: 16, fontSize: 10, display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700 }}>
            {unread > 9 ? '9+' : unread}
          </span>
        )}
      </button>

      {open && (
        <div style={{ position: 'fixed', top: 60, right: 16, width: 300, maxHeight: 400, overflowY: 'auto', background: '#1a0505', border: '1px solid rgba(212,168,67,0.3)', borderRadius: 10, boxShadow: '0 8px 32px rgba(0,0,0,0.8)', zIndex: 9999 }}>
          <div style={{ padding: '12px 16px', borderBottom: '1px solid rgba(255,255,255,0.1)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span style={{ color: '#FFD700', fontFamily: "'Bebas Neue',sans-serif", fontSize: 16, letterSpacing: 2 }}>NOTIFICATIONS</span>
            {!isSubscribed
              ? <button onClick={handleSubscribe} disabled={loading} style={{ background: '#FFD700', color: '#000', border: 'none', borderRadius: 4, padding: '4px 10px', fontSize: 11, fontWeight: 700, cursor: 'pointer' }}>{loading ? '...' : 'ENABLE'}</button>
              : <span style={{ color: '#00d480', fontSize: 10 }}>&#x2713; ON</span>
            }
          </div>
          {isSubscribed && <PushPrefsSection backend={backend} />}
          {notifications.length === 0
            ? <div style={{ padding: 24, textAlign: 'center', color: 'rgba(255,255,255,0.4)', fontSize: 13 }}>No notifications yet</div>
            : notifications.map((n, i) => (
              <div key={n.id || i} onClick={() => { if (n.url && n.url !== '/') window.location.href = n.url; setOpen(false); }}
                style={{ padding: '12px 16px', borderBottom: '1px solid rgba(255,255,255,0.06)', cursor: 'pointer', background: i === 0 ? 'rgba(255,215,0,0.04)' : 'transparent' }}>
                <div style={{ color: '#fff', fontSize: 13, fontWeight: 600, marginBottom: 3 }}>{n.title}</div>
                <div style={{ color: 'rgba(255,255,255,0.6)', fontSize: 12 }}>{n.body}</div>
                <div style={{ color: 'rgba(255,255,255,0.3)', fontSize: 10, marginTop: 4 }}>
                  {new Date(n.created_at).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' })}
                </div>
              </div>
            ))
          }
        </div>
      )}
    </div>
  );
}





// ── NETHAJI BULLETIN NEWS (Original v5 from AppMain) ──────────────
window._bulletinAudio = null;
window.stopBulletinAudio = function() {
  if (window._bulletinAudio) {
    window._bulletinAudio.pause();
    window._bulletinAudio.src = '';
    window._bulletinAudio = null;
  }
};

// ═══════════════════════════════════════
// NETHAJI BULLETIN v5 - Fixed Audio
// ═══════════════════════════════════════

// Single global audio instance
let _globalAudio = null;
let _globalSession = 0;

function stopAllBulletinAudio() {
  _globalSession++;
  if (_globalAudio) {
    _globalAudio.pause();
    _globalAudio.src = '';
    _globalAudio = null;
  }
}

function NethajiBulletin({ lang }) {
  const API_URL = process.env.REACT_APP_BACKEND_URL || "https://nethajiprime-backend.onrender.com";
  const [bulletin, setBulletin] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const [playing, setPlaying] = React.useState(false);
  const [currentLine, setCurrentLine] = React.useState(-1);
  const [currentElaboration, setCurrentElaboration] = React.useState("");
  const [liveHeadlines, setLiveHeadlines] = React.useState([]);
  const [speed, setSpeed] = React.useState(1);
  const speedRef = React.useRef(1);
  const [clock, setClock] = React.useState("");

  // Live newsroom clock
  React.useEffect(() => {
    const tick = () => setClock(new Date().toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit", second: "2-digit" }));
    tick();
    const iv = setInterval(tick, 1000);
    return () => clearInterval(iv);
  }, []);

  // Register with the audio coordinator so radio/video can stop the bulletin.
  React.useEffect(() => {
    npAudio.register('bulletin-watch', () => { stopAllBulletinAudio(); setPlaying(false); setCurrentLine(-1); });
    return () => npAudio.unregister('bulletin-watch');
  }, []);

  // Fetch live RSS headlines
  React.useEffect(() => {
    const API = process.env.REACT_APP_BACKEND_URL || "https://nethajiprime-backend.onrender.com";
    const cat = lang === "ta" ? "tamil" : lang === "en_india" ? "india" : "world";
    fetch(API + "/api/news-feeds?category=" + cat + "&limit=30")
      .then(r => r.json())
      .then(d => {
        const titles = (d.items || []).map(i => i.title).filter(Boolean);
        if (titles.length > 0) setLiveHeadlines(titles);
      })
      .catch(() => {});
  }, [lang]);
  const videoRef = React.useRef(null);

  // Stop audio and reload when tab changes
  React.useEffect(() => {
    stopAllBulletinAudio();
    setPlaying(false);
    setCurrentLine(-1);
    if (videoRef.current) videoRef.current.pause();
    setLoading(true);
    setBulletin(null);
    const bulletinLang = lang === "ta" ? "ta" : lang === "en_india" ? "en_india" : "en_world";
    fetch(API_URL + "/api/bulletin/today?lang=" + bulletinLang)
      .then(r => r.json())
      .then(data => {
        if (data.bulletin) {
          setBulletin(data.bulletin);
        }
        setLoading(false);
      })
      .catch(() => setLoading(false));
    // Cleanup on unmount
    return () => {
      stopAllBulletinAudio();
      if (videoRef.current) videoRef.current.pause();
    };
  }, [lang]);

  const audioElRef = React.useRef(null);

  // Playback-speed control — applies immediately to the current audio and to
  // every subsequent sentence (via speedRef read in playIndex).
  const changeSpeed = (s) => {
    setSpeed(s);
    speedRef.current = s;
    if (audioElRef.current) audioElRef.current.playbackRate = s;
  };

  const playNext = (headlines, index, ttsLang, session) => {
    if (session !== _globalSession) return;
    if (index >= headlines.length) {
      setPlaying(false);
      setCurrentLine(-1);
      if (videoRef.current) videoRef.current.pause();
      return;
    }
    setCurrentLine(index);
    if (videoRef.current) {
      videoRef.current.muted = true;
      videoRef.current.playbackRate = 1.0;
      videoRef.current.play().catch(() => {});
    }

    const text = encodeURIComponent(headlines[index].replace(/\*\*/g, '').substring(0, 300));
    const src = API_URL + "/tts?text=" + text + "&lang=" + ttsLang;

    // Preload next audio while current loads
    if (index + 1 < headlines.length) {
      const nextText = encodeURIComponent(headlines[index + 1].replace(/\*\*/g, '').substring(0, 300));
      const nextSrc = API_URL + "/tts?text=" + nextText + "&lang=" + ttsLang;
      const preload = new Audio();
      preload.preload = 'auto';
      preload.src = nextSrc;
    }

    if (!audioElRef.current) {
      audioElRef.current = new Audio();
    }
    const audio = audioElRef.current;
    _globalAudio = audio;

    audio.src = src;
    audio.onended = null;
    audio.onerror = null;

    let moved = false;
    const moveNext = () => {
      if (moved) return;
      moved = true;
      if (session !== _globalSession) return;
      if (videoRef.current) videoRef.current.pause();
      setTimeout(() => playNext(headlines, index + 1, ttsLang, session), 500);
    };

    audio.onended = moveNext;
    audio.onerror = () => {
      setTimeout(moveNext, 2000);
    };

    const playPromise = audio.play();
    if (playPromise) {
      playPromise.catch(() => {
        setTimeout(moveNext, 3000);
      });
    }
  };

  const playBulletin = () => {
    if (!bulletin) return;
    stopAllBulletinAudio();
    npAudio.stopOthers('bulletin-watch');   // starting bulletin stops radio + video
    const session = _globalSession;
    setPlaying(true);
    setCurrentLine(0);
    const bulletinLang = lang === "ta" ? "ta" : lang === "en_india" ? "en_india" : "en_world";
    const ttsUrl = API_URL + "/api/bulletin/tts-full?lang=" + bulletinLang;
    if (!audioElRef.current) audioElRef.current = new Audio();
    const audio = audioElRef.current;
    const ttsLang = lang === "ta" ? "ta" : "en-in";
    const BACKEND = API_URL;
    // Prefer the clean headlines array (10 RSS items) over the fragile summary-text split.
    // Fallback to summary-text splitting only if headlines array is unavailable.
    const closingPhrases = ["that is all for today", "thank you", "inRaiya ceydikaL ivvaLavutaan", "nandri"];
    const isClosingLine = (s) => {
      const low = s.toLowerCase();
      return closingPhrases.some(p => low.includes(p.toLowerCase()));
    };
    // Pre-generated R2 audio (Phase 1). When present, sentences[] and tts_sentences[]
    // are 1:1 aligned (bodies carry no intro/closing to strip), so index them together
    // and DON'T re-filter — that re-filtering is what previously desynced text vs audio.
    const pregenUrls = bulletin.tts_sentences || [];
    const hasPregen = bulletin.sentences && bulletin.sentences.length > 0 && pregenUrls.length > 0;
    let allSentences, displayHeadlines;
    if (hasPregen) {
      allSentences = bulletin.sentences;
      displayHeadlines = allSentences;   // displayOffset 0 -> currentLine == audio index
    } else {
      const cleanSentences = (bulletin.sentences && bulletin.sentences.length > 0) ? bulletin.sentences : null;
      const rawSentences = cleanSentences || (bulletin.summary || "")
        .split(/\n+|(?<=[.!?])\s+/)
        .map(s => s.replace(/\*\*/g, "").trim())
        .filter(s => s.length > 30);
      const naturalSentences = rawSentences.filter(s => !isClosingLine(s) && !s.startsWith("வணக்கம்") && !s.startsWith("Good morning") && !s.startsWith("Good evening"));
      allSentences = naturalSentences.length > 0
        ? naturalSentences
        : (bulletin.headlines && bulletin.headlines.length > 0 ? bulletin.headlines : []);
      // Display headlines skip intro, but audio plays all sentences
      displayHeadlines = allSentences.filter(s => !s.startsWith("வணக்கம்") && !s.startsWith("Good morning") && !s.startsWith("Good evening") && !isClosingLine(s));
    }

    // Cache elaborations per headline so we only fetch once each
    // SIMPLE & CLEAN: read each summary sentence exactly once, no elaboration fetching, no repetition.
    const playIndex = (i) => {
      if (i >= allSentences.length || session !== _globalSession) {
        setPlaying(false); setCurrentLine(-1);
        if (videoRef.current) videoRef.current.pause();
        return;
      }
      const displayOffset = allSentences.length - displayHeadlines.length;
      const displayIdx = Math.max(0, i - displayOffset);
      if (i >= displayOffset) setCurrentLine(displayIdx);
      setCurrentElaboration('');

      const sentenceText = allSentences[i].replace(/\*\*/g, '').trim();
      const src = (pregenUrls[i] && pregenUrls[i] !== null)
        ? pregenUrls[i]
        : BACKEND + '/tts?text=' + encodeURIComponent(sentenceText.substring(0, 500)) + '&lang=' + ttsLang;

      if (!audioElRef.current) audioElRef.current = new Audio();
      const audio = audioElRef.current;
      _globalAudio = audio;
      audio.onended = null; audio.onerror = null; audio.oncanplay = null;
      audio.src = src;
      audio.onended = () => { if (videoRef.current) videoRef.current.pause(); setTimeout(() => playIndex(i + 1), 400); };
      audio.onerror = () => { setTimeout(() => playIndex(i + 1), 500); };
      audio.oncanplay = () => {
        audio.oncanplay = null;
        audio.playbackRate = speedRef.current;
        if (videoRef.current) { videoRef.current.muted = true; videoRef.current.playbackRate = 1.0; videoRef.current.play().catch(() => {}); }
        audio.play().catch(() => setTimeout(() => playIndex(i + 1), 500));
      };
      audio.load();
      if (i + 1 < allSentences.length && !(pregenUrls[i+1] && pregenUrls[i+1] !== null)) {
        const nextText = allSentences[i+1].replace(/\*\*/g, '').trim();
        const preload = new Audio();
        preload.src = BACKEND + '/tts?text=' + encodeURIComponent(nextText.substring(0, 500)) + '&lang=' + ttsLang;
        preload.load();
      }
    };
    playIndex(0);
    return;
    // Legacy Web Speech disabled
    const ttsLang2 = lang === "ta" ? "ta" : "en-in";
    const voices = window.speechSynthesis ? window.speechSynthesis.getVoices() : [];
    const pallaviVoice = voices.find(v => v.name.includes("Pallavi")) || voices.find(v => v.name.includes("Vani")) || voices.find(v => v.lang === "ta-IN") || voices.find(v => v.lang.startsWith("ta"));
    const neerjaVoice  = voices.find(v => v.name.includes("Neerja") && v.lang === "en-IN");
    const ariaVoice    = voices.find(v => v.name.includes("Aria") && v.lang === "en-US");
    const bestVoice    = lang === "ta" ? pallaviVoice : lang === "en_india" ? neerjaVoice : ariaVoice;
    // Use Claude summary sentences for better elaboration
    const summaryText = bulletin.summary || '';
    const summarySentences = summaryText
      .split(/\n+|(?<=[.!?])\s+/)
      .map(s => s.replace(/\*\*/g, '').trim())
      .filter(s => s.length > 30);
    const allHeadlines = (bulletin.headlines && bulletin.headlines.length > 0) ? bulletin.headlines : (liveHeadlines.length > 0 ? liveHeadlines : summarySentences);
    if (false) { // Disabled Web Speech - use backend TTS always
      window.speechSynthesis.cancel();
      const headlines = allHeadlines;
    const elaborationsMap = {};
    // Pre-fetch all elaborations in parallel (non-blocking)
    const API = process.env.REACT_APP_BACKEND_URL || "https://nethajiprime-backend.onrender.com";
    Promise.all(headlines.slice(0,7).map(async (h, idx) => {
      try {
        const r = await fetch(API + "/api/bulletin/elaborate?headline=" + encodeURIComponent(h) + "&lang=" + lang);
        const d = await r.json();
        if (d.elaboration) elaborationsMap[idx] = h + ". " + d.elaboration;
      } catch(e) {}
    })).catch(() => {});

      let idx = 0;
      const speakNext = (i) => {
        if (i >= headlines.length) { setPlaying(false); setCurrentLine(-1); setCurrentElaboration(""); if (videoRef.current) videoRef.current.pause(); return; }
        // currentLine set in utt.onstart
        setCurrentElaboration("");
        if (videoRef.current) { videoRef.current.muted = true; videoRef.current.playbackRate = 1.0; videoRef.current.play().catch(() => {}); }
        const textToRead = headlines[i].replace(/\*\*/g, '').replace(/^[^:]+:\s*/, '').substring(0, 500);
        const utt = new SpeechSynthesisUtterance(textToRead);
        utt.voice = bestVoice; utt.lang = bestVoice.lang;
        utt.rate = lang === "ta" ? 0.75 : 0.80; utt.pitch = 1.05; utt.volume = 1.0;
        utt.onstart = () => { setCurrentLine(i);
          const API2 = process.env.REACT_APP_BACKEND_URL || "https://nethajiprime-backend.onrender.com";
          fetch(API2 + "/api/bulletin/elaborate?headline=" + encodeURIComponent(headlines[i]) + "&lang=" + lang)
            .then(r => r.json()).then(d => { if (d.elaboration) setCurrentElaboration(d.elaboration); })
            .catch(() => {});
        };
        let advanced = false;
        const goNext = () => { if (advanced) return; advanced = true; if (videoRef.current) videoRef.current.pause(); setTimeout(() => speakNext(i + 1), 500); };
        utt.onend = goNext;
        utt.onerror = goNext;
        // Chrome bug workaround: speechSynthesis can silently stall on subsequent utterances.
        // Cancel any stuck queue, then resume/speak with a tiny delay, plus a watchdog timeout.
        window.speechSynthesis.cancel();
        setTimeout(() => {
          window.speechSynthesis.speak(utt);
          // Watchdog: estimate speech duration and force-advance if onend never fires
          const estMs = Math.max(2500, textToRead.length * 90);
          setTimeout(() => { if (window.speechSynthesis.speaking === false) goNext(); }, estMs + 1500);
        }, 50);
      };
      const introText = lang === "ta" ? "வணக்கம். இன்றைய முக்கிய செய்திகள்." : "Good morning. Here are today top stories.";
      const introUtt = new SpeechSynthesisUtterance(introText);
      introUtt.voice = bestVoice; introUtt.lang = bestVoice.lang;
      introUtt.rate = lang === "ta" ? 0.85 : 0.9; introUtt.pitch = 1.05;
      if (videoRef.current) { videoRef.current.muted = true; videoRef.current.play().catch(()=>{}); }
      if (videoRef.current) { videoRef.current.muted = true; videoRef.current.play().catch(()=>{}); }
      // Skip separate intro - summary already has introduction
      setTimeout(() => speakNext(0), 300);
    } else {
      // Fallback to original gTTS
      // Use Claude summary split into sentences for better elaboration
      const summaryText = bulletin.summary || '';
      const summarySentences = summaryText
        .split(/\n+|(?<=[.!?])\s+/)
        .map(s => s.replace(/\*\*/g, '').trim())
        .filter(s => s.length > 30);
      const textToRead = summarySentences.length > 0 ? summarySentences : (bulletin.headlines || []);
      playNext(textToRead, 0, ttsLang, session);
    }
  };

  const stopBulletin = () => {
    window.speechSynthesis && window.speechSynthesis.cancel();
    stopAllBulletinAudio();
    if (videoRef.current) videoRef.current.pause();
    setPlaying(false);
    setCurrentLine(-1);
  };

  if (loading) return (
    <div style={{background:"#000",padding:40,textAlign:"center",color:"#00a8e1",borderBottom:"2px solid #cc0000"}}>
      <div style={{fontSize:32,marginBottom:8}}>📺</div>
      <div style={{fontSize:14,letterSpacing:2}}>Loading Nethaji Bulletin...</div>
    </div>
  );
  if (!bulletin) return null;

  const hour = new Date().getHours();
  const isMorning = hour < 12;
  const summaryTextDisplay = bulletin ? (bulletin.summary || '') : '';
  const summarySentencesDisplay = summaryTextDisplay
    .split(/\n+|(?<=[.!?])\s+/)
    .map(s => s.replace(/\*\*/g, '').trim())
    .filter(s => s.length > 30);
  const cleanSentencesDisplay = (bulletin && bulletin.sentences && bulletin.sentences.length > 0) ? bulletin.sentences : null;
  const headlines = cleanSentencesDisplay || (summarySentencesDisplay.length > 0 ? summarySentencesDisplay : (liveHeadlines.length > 0 ? liveHeadlines : (bulletin ? (bulletin.headlines || []) : [])));

  // Breaking-news ticker: seamless loop (content duplicated, -50% keyframe) with
  // duration proportional to the headline count, so the scroll speed stays constant
  // and readable whether there are 10 or 35 stories (was a fixed 40s → too fast now).
  const tickerText = (headlines || []).join("   •   ");
  const tickerDuration = Math.min(800, Math.max(40, (headlines || []).length * 20));

  return (
    <div style={{background:"#000",borderBottom:"3px solid #cc0000",position:"relative",overflow:"hidden"}}>
      <style>{`
        @keyframes pulse { 0%,100%{opacity:1;transform:scale(1)} 50%{opacity:0.4;transform:scale(0.82)} }
        @keyframes ticker { 0%{transform:translateX(0)} 100%{transform:translateX(-100%)} }
        @keyframes npTicker { from{transform:translateX(0)} to{transform:translateX(-50%)} }
        @keyframes npSlideIn { 0%{opacity:0;transform:translateX(26px)} 100%{opacity:1;transform:translateX(0)} }
        @keyframes npLiveDot { 0%,100%{opacity:1;box-shadow:0 0 0 0 rgba(255,255,255,0.6)} 50%{opacity:0.55;box-shadow:0 0 0 5px rgba(255,255,255,0)} }
        .bulletin-layout { display: flex; flex-direction: row; min-height: 420px; }
        .bulletin-anchor { width: 45%; position: relative; flex-shrink: 0; background: #000; }
        .bulletin-anchor video { width: 100%; height: 100%; min-height: 420px; object-fit: cover; display: block; }
        .bulletin-news { flex: 1; padding: 20px 24px; display: flex; flex-direction: column; background: linear-gradient(135deg,#050510,#0a0a1a); }
        @media (max-width: 768px) {
          .bulletin-layout { flex-direction: column; }
          .bulletin-anchor { width: 100%; }
          .bulletin-anchor video { min-height: 280px; max-height: 320px; object-fit: cover; }
          .bulletin-news { padding: 16px; }
        }
      `}</style>

      {/* Newsroom Header */}
      <div style={{background:"linear-gradient(90deg,#1a0008,#2a0012,#1a0008)",padding:"10px 16px",borderBottom:"2px solid #cc0000",display:"flex",alignItems:"center",justifyContent:"space-between",flexWrap:"wrap",gap:8}}>
        <div style={{display:"flex",alignItems:"center",gap:12,flexWrap:"wrap"}}>
          <span style={{display:"inline-flex",alignItems:"center",gap:7,background:"#cc0000",padding:"4px 10px",borderRadius:4}}>
            <span style={{width:9,height:9,borderRadius:"50%",background:"#fff",display:"inline-block",animation:"npLiveDot 1.1s infinite"}}/>
            <span style={{color:"#fff",fontWeight:900,fontSize:12,letterSpacing:2}}>LIVE</span>
          </span>
          <span style={{color:"#FFD700",fontWeight:900,fontSize:14,letterSpacing:2}}>📺 NETHAJI PRIME</span>
          <span style={{color:"rgba(255,255,255,0.5)",fontSize:11,fontWeight:700}}>
            {playing ? "🔴 ON AIR" : (isMorning ? "🌅 MORNING EDITION" : "🌆 EVENING EDITION")}
          </span>
        </div>
        <div style={{display:"flex",alignItems:"center",gap:8,flexWrap:"wrap"}}>
          {[["Politics","#cc0000"],["Economy","#1e88e5"],["Sports","#2e7d32"],["World","#8e24aa"],["Tech","#f5a623"]].map(([c,col]) => (
            <span key={c} style={{background:col+"22",border:"1px solid "+col,color:col,fontSize:9,fontWeight:800,letterSpacing:1,padding:"2px 7px",borderRadius:10}}>{c.toUpperCase()}</span>
          ))}
          <span style={{color:"#FFD700",fontSize:12,fontWeight:800,fontFamily:"monospace",letterSpacing:1,minWidth:74,textAlign:"right"}}>{clock}</span>
        </div>
      </div>

      {/* Main Layout */}
      <div className="bulletin-layout">
        {/* Anchor */}
        <div className="bulletin-anchor">
          <video ref={videoRef} src={bulletin.anchor_video} loop muted playsInline/>
          <div style={{position:"absolute",inset:0,background:"linear-gradient(to right,transparent 60%,#000 100%)"}}/>
          <div style={{position:"absolute",bottom:0,left:0,right:0,background:"linear-gradient(transparent,rgba(0,0,0,0.95))",padding:"30px 14px 10px"}}>
            <div style={{display:"inline-block",background:"#cc0000",padding:"3px 10px",marginBottom:3}}>
              <span style={{color:"#fff",fontWeight:900,fontSize:13,letterSpacing:2}}>{bulletin.anchor_name}</span>
            </div>
            <div style={{color:"#d4a843",fontSize:10,letterSpacing:2}}>{bulletin.anchor_tamil} | NEWS ANCHOR</div>
          </div>
        </div>

        {/* News */}
        <div className="bulletin-news">
          {/* Reading Now */}
          {playing && currentLine >= 0 && currentLine < headlines.length && (
            <div key={currentLine} style={{background:"linear-gradient(135deg,rgba(255,215,0,0.14),rgba(204,0,0,0.12))",border:"1px solid rgba(255,215,0,0.5)",borderRadius:8,padding:"10px 14px",marginBottom:14,minHeight:60,animation:"npSlideIn 0.4s ease"}}>
              <div style={{color:"#FFD700",fontSize:10,fontWeight:900,letterSpacing:3,marginBottom:4}}>🎙️ READING NOW</div>
              <div style={{color:"#fff",fontSize:13.5,lineHeight:1.5,fontWeight:700}}>{headlines[currentLine]}</div>
              {currentElaboration && (
                <div style={{color:"rgba(255,255,255,0.75)",fontSize:11,lineHeight:1.6,marginTop:6,fontStyle:"italic",borderTop:"1px solid rgba(255,255,255,0.1)",paddingTop:6}}>
                  {currentElaboration}
                </div>
              )}
            </div>
          )}

          {/* Headlines */}
          <div style={{flex:1,overflowY:"auto",maxHeight:300}}>
            <div style={{color:"#d4a843",fontSize:10,fontWeight:900,letterSpacing:3,marginBottom:8,display:"flex",alignItems:"center",gap:6}}>
              <div style={{width:3,height:12,background:"#cc0000",flexShrink:0}}/>
              TOP {headlines.length} HEADLINES
            </div>
            {headlines.map((h, i) => {
              const active = playing && i === currentLine;
              return (
              <div key={i} style={{
                color: active ? "#FFD700" : "rgba(255,255,255,0.55)",
                fontSize: active ? 13.5 : 12,
                padding:"7px 10px",
                borderRadius:6,
                fontFamily: "'Noto Sans Tamil', sans-serif",
                background: active ? "rgba(255,215,0,0.12)" : "transparent",
                borderLeft: active ? "3px solid #FFD700" : "3px solid transparent",
                marginBottom:3,
                lineHeight:1.4,
                fontWeight: active ? 800 : 400,
                transition:"all 0.35s ease"
              }}>
                <span style={{color: active ? "#FFD700":"#555",fontWeight:900,marginRight:6,fontSize:10}}>{active ? "🔊" : (i+1)+"."}</span>
                {h}
              </div>
              );
            })}
          </div>

          {/* Controls */}
          <div style={{marginTop:12,paddingTop:10,borderTop:"1px solid rgba(255,255,255,0.05)",display:"flex",gap:10,alignItems:"center",flexWrap:"wrap"}}>
            <button onClick={playing ? stopBulletin : playBulletin} style={{
              background:playing?"linear-gradient(135deg,#cc0000,#880000)":"linear-gradient(135deg,#d4a843,#b8860b)",
              border:"none",borderRadius:6,padding:"10px 20px",
              color:"#fff",fontWeight:900,fontSize:13,cursor:"pointer",letterSpacing:1
            }}>
              {playing ? "⏹ STOP" : "▶ PLAY BULLETIN"}
            </button>
            <div style={{display:"flex",alignItems:"center",gap:4}}>
              <span style={{color:"rgba(255,255,255,0.35)",fontSize:10,fontWeight:700,marginRight:2}}>SPEED</span>
              {[0.75,1,1.25,1.5].map(s => (
                <button key={s} onClick={() => changeSpeed(s)} style={{
                  background: speed===s ? "#FFD700" : "transparent",
                  border: "1px solid " + (speed===s ? "#FFD700" : "rgba(255,215,0,0.35)"),
                  color: speed===s ? "#1a0008" : "#FFD700",
                  borderRadius:14, padding:"4px 9px", fontSize:11, fontWeight:800, cursor:"pointer"
                }}>{s}x</button>
              ))}
            </div>
            {playing && <span style={{color:"rgba(255,255,255,0.4)",fontSize:11,animation:"pulse 1s infinite"}}>Broadcasting...</span>}
          </div>
        </div>
      </div>

      {/* Ticker */}
      <div style={{background:"#cc0000",padding:"5px 0",overflow:"hidden"}}>
        <div style={{display:"flex",alignItems:"center"}}>
          <div style={{background:"#000",padding:"5px 12px",flexShrink:0,fontWeight:900,fontSize:10,color:"#d4a843",letterSpacing:2,whiteSpace:"nowrap"}}>BREAKING</div>
          <div style={{overflow:"hidden",flex:1}}>
            <div style={{display:"inline-flex",whiteSpace:"nowrap",willChange:"transform",animation:`npTicker ${tickerDuration}s linear infinite`}}>
              <span style={{color:"#fff",fontSize:11,fontWeight:600,paddingRight:40}}>{tickerText}</span>
              <span aria-hidden="true" style={{color:"#fff",fontSize:11,fontWeight:600,paddingRight:40}}>{tickerText}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}


function LiveNewsTab({ lang = "en" }) {
  React.useEffect(() => {
    return () => { 
      window._bulletinAudio = null;
      if (window._currentBulletinAudio) {
        window._currentBulletinAudio.pause();
        window._currentBulletinAudio.src = '';
        window._currentBulletinAudio = null;
      }
    };
  }, []);
  const TAMIL_CHANNELS = [
    { id: "puthiya", name: "Puthiya Thalaimurai", color: "#cc0000" },
    { id: "thanthi", name: "Thanthi TV", color: "#0055aa" },
    { id: "sun", name: "Sun News", color: "#ff6600" },
    { id: "polimer", name: "Polimer News", color: "#006633" },
    { id: "news18", name: "News18 Tamil", color: "#cc0000" },
    { id: "news7", name: "News7 Tamil", color: "#0077cc" },
    { id: "ddnews", name: "DD Tamil News", color: "#006400" },
  ];
  const INDIA_CHANNELS = []
  const WORLD_CHANNELS = []
  const [activeTab, setActiveTab] = React.useState("tamil");
  const [tamilChannels, setTamilChannels] = React.useState(TAMIL_CHANNELS.map(c => ({...c, videoId: null})));
  const [indiaChannels, setIndiaChannels] = React.useState(INDIA_CHANNELS);
  const [worldChannels, setWorldChannels] = React.useState(WORLD_CHANNELS);
  const [watching, setWatching] = React.useState(null);
  const [news, setNews] = React.useState([]);
  const [currentNews, setCurrentNews] = React.useState(0);
  const [loading, setLoading] = React.useState(true);
  React.useEffect(() => {
    fetch(API_URL+"/api/live-channels?region=tamil")
      .then(r => r.json()).then(data => { if (Array.isArray(data)) setTamilChannels(prev => prev.map(ch => { const found = data.find(d => d.id === ch.id); return found ? {...ch, videoId: found.videoId} : ch; })); }).catch(() => {});
    fetch(API_URL+"/api/live-channels?region=india")
      .then(r => r.json()).then(data => { if (Array.isArray(data)) setIndiaChannels(data); }).catch(() => {});
    fetch(API_URL+"/api/live-channels?region=world")
      .then(r => r.json()).then(data => { if (Array.isArray(data)) setWorldChannels(data); }).catch(() => {});
    const rssFeeds = {
      tamil: "https://api.rss2json.com/v1/api.json?rss_url=https://feeds.bbci.co.uk/tamil/rss.xml",
      india: "https://api.rss2json.com/v1/api.json?rss_url=https://timesofindia.indiatimes.com/rssfeedstopstories.cms",
      world: "https://api.rss2json.com/v1/api.json?rss_url=https://feeds.bbci.co.uk/news/world/rss.xml"
    };
    fetch(rssFeeds["tamil"])
      .then(r => r.json()).then(d => { if (d.items) { setNews(d.items.slice(0, 20)); setLoading(false); } }).catch(() => setLoading(false));
    const t = setInterval(() => {
      fetch(API_URL+"/api/live-channels?region=tamil")
        .then(r => r.json()).then(data => { if (Array.isArray(data)) setTamilChannels(prev => prev.map(ch => { const found = data.find(d => d.id === ch.id); return found ? {...ch, videoId: found.videoId} : ch; })); }).catch(() => {});
    }, 30 * 60 * 1000);
    return () => clearInterval(t);
  }, []);
  React.useEffect(() => {
    if (news.length === 0) return;
    const t = setInterval(() => setCurrentNews(i => (i + 1) % Math.min(news.length, 10)), 8000);
    return () => clearInterval(t);
  }, [news]);
  const istTime = new Date().toLocaleTimeString("en-IN", { timeZone: "Asia/Kolkata", hour: "2-digit", minute: "2-digit" });
  const RSS = {
    tamil: "https://api.rss2json.com/v1/api.json?rss_url=https://feeds.bbci.co.uk/tamil/rss.xml",
    india: "https://api.rss2json.com/v1/api.json?rss_url=https://timesofindia.indiatimes.com/rssfeedstopstories.cms",
    world: "https://api.rss2json.com/v1/api.json?rss_url=https://feeds.bbci.co.uk/news/world/rss.xml"
  };
  React.useEffect(() => {
    setLoading(true);
    setNews([]);
    fetch(RSS[activeTab])
      .then(r => r.json()).then(d => { if (d.items) { setNews(d.items.slice(0, 20)); setLoading(false); } }).catch(() => setLoading(false));
  }, [activeTab]);
  const activeChannels = activeTab === "tamil" ? tamilChannels : activeTab === "india" ? indiaChannels : worldChannels;
  const renderGrid = (channels) => (
    <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(240px,1fr))",gap:"14px"}}>
      {channels.map(ch => (
        <div key={ch.id} className="ch-card"
          style={{background:"linear-gradient(135deg,#0a0000,#150000)",border:watching&&watching.id===ch.id?"2px solid #d4a843":"1px solid rgba(204,0,0,0.2)",borderRadius:"8px",overflow:"hidden",boxShadow:"0 4px 16px rgba(0,0,0,0.4)"}}
          onClick={() => ch.videoId && setWatching(ch)}>
          <div style={{padding:"24px 16px",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",gap:"10px",background:"linear-gradient(135deg,rgba(204,0,0,0.15),#000)",minHeight:"120px",position:"relative"}}>
            <div style={{position:"absolute",top:0,left:0,right:0,height:"2px",background:"linear-gradient(90deg,transparent,#cc0000,transparent)"}}></div>
            <div style={{width:"56px",height:"56px",borderRadius:"50%",background:"linear-gradient(135deg,"+ch.color+","+ch.color+"88)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:"14px",fontWeight:900,color:"#fff",letterSpacing:"1px"}}>NEWS</div>
            <div style={{color:"#fff",fontWeight:900,fontSize:"14px",letterSpacing:"1px",textAlign:"center"}}>{ch.name}</div>
            <div style={{display:"flex",alignItems:"center",gap:"5px"}}>
              <div style={{width:"6px",height:"6px",borderRadius:"50%",background:"#ff0000",animation:"pulse 1s infinite"}}></div>
              <span style={{color:"rgba(255,255,255,0.5)",fontSize:"10px",letterSpacing:"2px"}}>LIVE 24/7</span>
            </div>
          </div>
          <div style={{padding:"10px 14px",display:"flex",alignItems:"center",justifyContent:"space-between",background:"rgba(0,0,0,0.5)"}}>
            <span style={{color:"rgba(255,255,255,0.35)",fontSize:"10px"}}>Courtesy: {ch.name}</span>
            <button onClick={e => { e.stopPropagation(); if(ch.videoId) window.open("https://www.youtube.com/watch?v="+ch.videoId,"_blank"); }}
              style={{background:"linear-gradient(135deg,#cc0000,#880000)",border:"none",color:"#fff",padding:"5px 14px",borderRadius:"3px",cursor:"pointer",fontSize:"11px",fontWeight:900}}>
              WATCH
            </button>
          </div>
        </div>
      ))}
    </div>
  );
  return (
    <div className="live-news-container" style={{background:"#000",minHeight:"100vh"}}>
      <style>{`
        @keyframes pulse { 0%,100%{opacity:1} 50%{opacity:0.3} }
        @keyframes fadeIn { from{opacity:0;transform:translateY(8px)} to{opacity:1;transform:translateY(0)} }
        @keyframes ticker { 0%{transform:translateX(0)} 100%{transform:translateX(-50%)} }
        .ch-card:hover { transform:scale(1.02); }
        .ch-card { transition:all 0.25s ease; cursor:pointer; }
        .news-fade { animation:fadeIn 0.5s ease; }
      `}</style>
      <div style={{background:"linear-gradient(135deg,#0a0000,#1a0300,#0a0000)",padding:"32px 4% 16px",borderBottom:"3px solid #cc0000",position:"relative"}}>
        <div style={{position:"absolute",top:0,left:0,right:0,height:"2px",background:"linear-gradient(90deg,transparent,#cc0000,#ff4444,#cc0000,transparent)"}}></div>
        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",flexWrap:"wrap",gap:"12px"}}>
          <div style={{display:"flex",alignItems:"center",gap:"14px"}}>
            <div style={{display:"flex",alignItems:"center",gap:"6px",background:"rgba(204,0,0,0.25)",border:"1px solid rgba(204,0,0,0.6)",padding:"5px 12px",borderRadius:"3px"}}>
              <div style={{width:"8px",height:"8px",borderRadius:"50%",background:"#ff0000",animation:"pulse 1s infinite"}}></div>
              <span style={{color:"#ff4444",fontWeight:900,letterSpacing:"4px",fontSize:"12px"}}>LIVE</span>
            </div>
            <div>
              <div style={{color:"#fff",fontWeight:900,fontSize:"26px",letterSpacing:"3px",lineHeight:1.1}}>NETHAJI PRIME</div>
              <div style={{color:"#d4a843",fontWeight:700,fontSize:"11px",letterSpacing:"6px"}}>NEWS NETWORK</div>
            </div>
          </div>
          <div style={{textAlign:"right"}}>
            <div style={{color:"#d4a843",fontWeight:900,fontSize:"22px",letterSpacing:"2px"}}>{istTime}</div>
            <div style={{color:"rgba(255,255,255,0.4)",fontSize:"10px",letterSpacing:"3px"}}>INDIA STANDARD TIME</div>
          </div>
        </div>
        {news.length > 0 && (
          <div key={currentNews} className="news-fade" style={{marginTop:"14px",padding:"8px 14px",background:"rgba(0,0,0,0.6)",borderLeft:"4px solid #cc0000",borderRadius:"0 4px 4px 0"}}>
            <span style={{color:"#ff4444",fontWeight:900,fontSize:"10px",letterSpacing:"3px",marginRight:"10px"}}>BREAKING</span>
            <span style={{color:"rgba(255,255,255,0.9)",fontWeight:600,fontSize:"14px",fontFamily:"sans-serif"}}>{news[currentNews]?.title}</span>
          </div>
        )}
      </div>
      <div style={{background:"#0a0000",borderBottom:"1px solid rgba(212,168,67,0.2)",padding:"0 4%",display:"flex"}}>
        {[["tamil","TAMIL NADU"],["india","INDIA"],["world","INTERNATIONAL"]].map(([key,label]) => (
          <button key={key} onClick={() => { setActiveTab(key); setWatching(null); }}
            style={{padding:"12px 24px",background:"transparent",border:"none",borderBottom:activeTab===key?"3px solid #cc0000":"3px solid transparent",color:activeTab===key?"#fff":"rgba(255,255,255,0.4)",fontWeight:900,fontSize:"13px",letterSpacing:"2px",cursor:"pointer",transition:"all 0.2s"}}>
            {label}
          </button>
        ))}
      </div>
      <NethajiBulletin lang={activeTab === "tamil" ? "ta" : activeTab === "india" ? "en_india" : "en_world"} />
      {watching && (
        <div style={{background:"#000"}}>
          <div style={{background:"#0a0000",padding:"8px 16px",display:"flex",alignItems:"center",justifyContent:"space-between",borderBottom:"1px solid rgba(204,0,0,0.3)"}}>
            <div style={{display:"flex",alignItems:"center",gap:"10px"}}>
              <div style={{width:"7px",height:"7px",borderRadius:"50%",background:"#ff0000",animation:"pulse 1s infinite"}}></div>
              <span style={{color:"#d4a843",fontWeight:900,fontSize:"15px"}}>{watching.name}</span>
              <span style={{background:"#cc0000",color:"#fff",fontSize:"9px",fontWeight:900,padding:"2px 7px",borderRadius:"2px"}}>ON AIR</span>
              <span style={{color:"rgba(255,255,255,0.4)",fontSize:"10px"}}>Content courtesy: {watching.name}</span>
            </div>
            <div style={{display:"flex",gap:"8px"}}>


              <button onClick={() => setWatching(null)}
                style={{background:"rgba(204,0,0,0.15)",border:"1px solid rgba(204,0,0,0.5)",color:"#ff4444",padding:"4px 12px",borderRadius:"3px",cursor:"pointer",fontSize:"11px",fontWeight:700}}>CLOSE</button>
            </div>
          </div>
          <div style={{position:"relative",paddingTop:"56.25%"}}>
            <iframe key={watching.videoId}
              src={"https://www.youtube.com/embed/"+watching.videoId+"?autoplay=1&rel=0&vq=hd1080&modestbranding=1&modestbranding=1"}
              style={{position:"absolute",top:0,left:0,width:"100%",height:"100%",border:"none"}}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen />
          </div>
        </div>
      )}
      <div style={{padding:"20px 4%",background:"#050000"}}>
        <div style={{display:"flex",alignItems:"center",gap:"10px",marginBottom:"18px"}}>
          <div style={{height:"1px",flex:1,background:"linear-gradient(90deg,#cc0000,transparent)"}}></div>
          <span style={{color:"#d4a843",fontWeight:900,fontSize:"12px",letterSpacing:"4px"}}>
            {activeTab==="tamil"?"TAMIL NADU NEWS CHANNELS":activeTab==="india"?"INDIA NEWS CHANNELS":"INTERNATIONAL NEWS CHANNELS"}
          </span>
          <div style={{height:"1px",flex:1,background:"linear-gradient(90deg,transparent,#cc0000)"}}></div>
        </div>
        {renderGrid(activeChannels)}
      </div>
      {news.length > 0 && (
        <div style={{background:"linear-gradient(90deg,#cc0000,#880000,#cc0000)",padding:"7px 0",overflow:"hidden"}}>
          <div style={{display:"flex",gap:"60px",animation:"ticker 60s linear infinite",whiteSpace:"nowrap",width:"max-content"}}>
            {news.concat(news).map((item,i) => (
              <span key={i} style={{color:"#fff",fontSize:"13px",fontWeight:700,flexShrink:0,fontFamily:"sans-serif"}}>{item.title}</span>
            ))}
          </div>
        </div>
      )}
      <div style={{padding:"20px 4% 32px",background:"#000"}}>
        <div style={{display:"flex",alignItems:"center",gap:"10px",marginBottom:"14px"}}>
          <div style={{width:"3px",height:"18px",background:"#cc0000",borderRadius:"2px"}}></div>
          <span style={{color:"#d4a843",fontWeight:900,fontSize:"12px",letterSpacing:"4px"}}>LATEST HEADLINES</span>
        </div>
        {loading ? <div style={{color:"rgba(255,255,255,0.25)",fontSize:"11px"}}>LOADING...</div> :
          news.slice(0,10).map((item,i) => (
            <a key={i} href={item.link} target="_blank" rel="noopener noreferrer"
              style={{display:"flex",alignItems:"flex-start",gap:"14px",padding:"11px 0",borderBottom:"1px solid rgba(255,255,255,0.05)",textDecoration:"none"}}>
              <span style={{color:"#cc0000",fontWeight:900,fontSize:"13px",minWidth:"26px"}}>{String(i+1).padStart(2,"0")}</span>
              <div style={{flex:1}}>
                <div style={{color:"rgba(255,255,255,0.85)",fontSize:"13px",lineHeight:1.5,fontFamily:"sans-serif"}}>{item.title}</div>
                <div style={{color:"rgba(255,255,255,0.2)",fontSize:"10px",marginTop:"3px"}}>{new Date(item.pubDate).toLocaleString("en-IN",{timeZone:"Asia/Kolkata"})}</div>
              </div>
            </a>
          ))
        }
      </div>
    </div>
  );
}


// ── FM RADIO ─────────────────────────────────────────────────────────────────
function RadioPage({ onClose, onPlay }) {
  const [stations, setStations] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [category, setCategory] = React.useState('tamil');
  const [search, setSearch] = React.useState('');

  const categories = [
    { id: 'tamil', label: 'தமிழ்', query: { language: 'tamil', countrycode: 'IN' } },
    { id: 'india', label: '🇮🇳 India', query: { countrycode: 'IN', language: 'hindi' } },
    { id: 'world', label: '🌍 World', query: { tag: 'pop', limit: 30 } },
  ];

  React.useEffect(() => {
    setLoading(true);
    const cat = categories.find(c => c.id === category);
    const params = new URLSearchParams({ ...cat.query, limit: 40, order: 'clickcount', reverse: true });
    fetch(`https://de1.api.radio-browser.info/json/stations/search?${params}`)
      .then(r => r.json())
      .then(data => { setStations(data.filter(s => s.url_resolved)); setLoading(false); })
      .catch(() => setLoading(false));
  }, [category]);

  const filtered = stations.filter(s =>
    !search || s.name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div style={{ position:'fixed', inset:0, background:'#0a0010', zIndex:9000, overflowY:'auto' }}>
      {/* Header */}
      <div style={{ background:'linear-gradient(90deg,#0a0010,#1a0030)', borderBottom:'3px solid #cc0000', padding:'10px 16px', display:'flex', alignItems:'center', justifyContent:'space-between', position:'sticky', top:0, zIndex:10 }}>
        <div style={{ display:'flex', alignItems:'center', gap:10 }}>
          <span style={{ display:'flex', alignItems:'center' }}><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="8" width="20" height="14" rx="2"/><path d="M6 8V6a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v2"/><circle cx="12" cy="15" r="3"/><line x1="17" y1="12" x2="17" y2="18"/></svg></span>
          <div>
            <div style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:18, color:'#fff', letterSpacing:3 }}>NETHAJI PRIME FM RADIO</div>
            <div style={{ fontSize:9, color:'#cc0000', letterSpacing:2 }}>LIVE STREAMING</div>
          </div>
        </div>
        <div style={{ display:'flex', gap:4, alignItems:'center' }}>
          {categories.map(cat => (
            <button key={cat.id} onClick={() => setCategory(cat.id)}
              style={{ background: category===cat.id ? '#cc0000' : 'rgba(255,255,255,0.08)', color:'#fff', border:'none', borderRadius:3, padding:'3px 8px', fontSize:10, cursor:'pointer' }}>
              {cat.label}
            </button>
          ))}
          <button onClick={onClose} style={{ background:'rgba(255,0,0,0.2)', border:'1px solid rgba(255,0,0,0.4)', color:'#fff', width:28, height:28, borderRadius:'50%', cursor:'pointer', fontSize:12, marginLeft:4 }}>✕</button>
        </div>
      </div>

      {/* Search */}
      <div style={{ padding:'10px 16px' }}>
        <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Search stations..."
          style={{ width:'100%', background:'rgba(255,255,255,0.08)', border:'1px solid rgba(255,255,255,0.15)', borderRadius:6, padding:'8px 12px', color:'#fff', fontSize:13, outline:'none', boxSizing:'border-box' }} />
      </div>

      {/* Stations */}
      {loading ? (
        <div style={{ padding:40, textAlign:'center', color:'rgba(255,255,255,0.4)' }}>Loading stations...</div>
      ) : (
        <div style={{ padding:'0 16px 80px' }}>
          {filtered.map((station, i) => (
            <div key={i} onClick={() => onPlay(station)}
              style={{ display:'flex', alignItems:'center', gap:12, padding:'10px 0', borderBottom:'1px solid rgba(255,255,255,0.06)', cursor:'pointer' }}>
              {station.favicon
                ? <img src={station.favicon} alt="" onError={e=>e.target.style.display='none'} style={{ width:40, height:40, borderRadius:8, objectFit:'cover', flexShrink:0, background:'rgba(255,255,255,0.1)' }} />
                : <div style={{ width:40, height:40, borderRadius:8, background:'linear-gradient(135deg,#cc0000,#ff4444)', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="8" width="20" height="14" rx="2"/><path d="M6 8V6a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v2"/><circle cx="12" cy="15" r="3"/><line x1="17" y1="12" x2="17" y2="18"/></svg></div>
              }
              <div style={{ flex:1, minWidth:0 }}>
                <div style={{ fontSize:13, fontWeight:700, color:'#fff', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{station.name}</div>
                <div style={{ fontSize:10, color:'rgba(255,255,255,0.4)', marginTop:2 }}>
                  {station.country} {station.tags ? '• ' + station.tags.split(',').slice(0,2).join(', ') : ''}
                </div>
              </div>
              <div style={{ background:'#cc0000', borderRadius:'50%', width:32, height:32, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>▶</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// ── MINI RADIO PLAYER ─────────────────────────────────────────────────────────
function MiniRadioPlayer({ station, onStop }) {
  const audioRef = React.useRef(null);
  const [playing, setPlaying] = React.useState(true);
  const [error, setError] = React.useState(false);

  // Register with the audio coordinator so video/bulletin can stop the radio.
  React.useEffect(() => {
    npAudio.register('radio', () => {
      if (audioRef.current) audioRef.current.pause();
      setPlaying(false);
    });
    return () => npAudio.unregister('radio');
  }, []);

  React.useEffect(() => {
    if (!station) return;
    setError(false);
    setPlaying(true);
    npAudio.stopOthers('radio');   // starting radio stops any video/bulletin
    if (audioRef.current) {
      audioRef.current.src = station.url_resolved;
      audioRef.current.play().catch(() => setError(true));
    }
    return () => { if (audioRef.current) audioRef.current.pause(); };
  }, [station?.stationuuid]);

  const togglePlay = () => {
    if (!audioRef.current) return;
    if (playing) { audioRef.current.pause(); setPlaying(false); }
    else { npAudio.stopOthers('radio'); audioRef.current.play(); setPlaying(true); }
  };

  if (!station) return null;

  return (
    <div style={{ position:'fixed', bottom:'calc(60px + env(safe-area-inset-bottom, 0px))', left:0, right:0, zIndex:9998, background:'linear-gradient(90deg,#1a0030,#0a0010)', borderTop:'1px solid rgba(204,0,0,0.5)', padding:'6px 16px', display:'flex', alignItems:'center', gap:10, transform:'translate3d(0,0,0)', boxShadow:'0 -1px 10px rgba(0,0,0,0.8)' }}>
      <audio ref={audioRef} />
      {station.favicon
        ? <img src={station.favicon} alt="" onError={e=>e.target.style.display='none'} style={{ width:32, height:32, borderRadius:6, objectFit:'cover', flexShrink:0 }} />
        : <span style={{ flexShrink:0, display:'flex', alignItems:'center' }}><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="8" width="20" height="14" rx="2"/><path d="M6 8V6a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v2"/><circle cx="12" cy="15" r="3"/><line x1="17" y1="12" x2="17" y2="18"/></svg></span>
      }
      <div style={{ flex:1, minWidth:0 }}>
        <div style={{ fontSize:12, fontWeight:700, color:'#fff', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{station.name}</div>
        <div style={{ fontSize:9, color:'rgba(255,255,255,0.4)' }}>{error ? '⚠️ Stream unavailable' : playing ? '🔴 LIVE' : 'Paused'}</div>
      </div>
      <button onClick={togglePlay} style={{ background:'#cc0000', border:'none', color:'#fff', width:32, height:32, borderRadius:'50%', cursor:'pointer', fontSize:14, display:'flex', alignItems:'center', justifyContent:'center' }}>
        {playing ? '⏸' : '▶'}
      </button>
      <button onClick={onStop} style={{ background:'rgba(255,255,255,0.1)', border:'none', color:'#fff', width:28, height:28, borderRadius:'50%', cursor:'pointer', fontSize:12, display:'flex', alignItems:'center', justifyContent:'center' }}>✕</button>
    </div>
  );
}

// ── BulletinPage wrapper for WatchNowPage nav ─────────────────

// ── WEATHER COMPONENT ────────────────────────────────────────────
function WeatherSection({ region, backend }) {
  const [weather, setWeather] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  React.useEffect(() => {
    setLoading(true);
    fetch(backend + '/api/weather?region=' + region)
      .then(r => r.json()).then(d => { setWeather(d.cities || []); setLoading(false); })
      .catch(() => setLoading(false));
  }, [region, backend]);
  if (loading) return <div style={{padding:'16px',textAlign:'center',color:'rgba(255,255,255,0.4)',fontSize:13}}>Loading weather...</div>;
  return (
    <div style={{padding:'12px 16px',display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(140px,1fr))',gap:8,marginBottom:8}}>
      {weather.filter(c=>!c.error).map((city,i) => (
        <div key={i} style={{background:'rgba(255,255,255,0.05)',borderRadius:8,padding:10,border:'1px solid rgba(255,255,255,0.08)'}}>
          <div style={{fontSize:11,color:'rgba(255,255,255,0.5)',marginBottom:3}}>{city.city_ta||city.city}</div>
          <div style={{display:'flex',alignItems:'center',gap:6}}>
            <span style={{fontSize:26}}>{city.icon||'🌡️'}</span>
            <div>
              <div style={{fontSize:20,fontWeight:700,color:'#fff'}}>{city.temp}°C</div>
              <div style={{fontSize:10,color:'rgba(255,255,255,0.4)'}}>{city.condition}</div>
            </div>
          </div>
          {city.max!=null && <div style={{fontSize:10,color:'rgba(255,255,255,0.35)',marginTop:3}}>↑{city.max}° ↓{city.min}° 💧{city.humidity}%</div>}
        </div>
      ))}
    </div>
  );
}

// ── NEWS FEED COMPONENT ──────────────────────────────────────────
function NewsFeedSection({ category, backend }) {
  const [news, setNews] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  React.useEffect(() => {
    setLoading(true);
    fetch(backend + '/api/news-feeds?category=' + category + '&limit=30')
      .then(r => r.json()).then(d => { setNews(d.items || []); setLoading(false); })
      .catch(() => setLoading(false));
  }, [category, backend]);
  if (loading) return <div style={{padding:'16px',textAlign:'center',color:'rgba(255,255,255,0.4)',fontSize:13}}>Loading news...</div>;
  return (
    <div style={{padding:'0 16px 24px'}}>
      {news.map((item,i) => (
        <div key={i} onClick={() => item.link && window.open(item.link,'_blank')}
          style={{display:'flex',gap:10,padding:'10px 0',borderBottom:'1px solid rgba(255,255,255,0.05)',cursor:item.link?'pointer':'default'}}>
          <div style={{width:3,borderRadius:2,background:item.color||'#cc0000',flexShrink:0}}/>
          <div style={{flex:1,minWidth:0}}>
            <div style={{display:'flex',gap:8,marginBottom:3,alignItems:'center'}}>
              <span style={{fontSize:10,fontWeight:700,color:item.color||'#cc0000',letterSpacing:1,textTransform:'uppercase',flexShrink:0}}>{item.source}</span>
              {item.pubDate && <span style={{fontSize:10,color:'rgba(255,255,255,0.25)'}}>{new Date(item.pubDate).toLocaleTimeString('en-IN',{hour:'2-digit',minute:'2-digit'})}</span>}
            </div>
            <div style={{fontSize:13,color:'rgba(255,255,255,0.88)',lineHeight:1.5}}>{item.title}</div>
          </div>
          {item.image && <img src={item.image} alt="" onError={e=>e.target.style.display='none'} style={{width:64,height:46,objectFit:'cover',borderRadius:4,flexShrink:0}}/>}
        </div>
      ))}
    </div>
  );
}

function BulletinPage({ backend, onClose }) {
  const [activeTab, setActiveTab] = React.useState('tamil');
  const [currentTime, setCurrentTime] = React.useState('');

  React.useEffect(() => {
    const tick = () => {
      const now = new Date();
      setCurrentTime(now.toLocaleTimeString('en-IN', { hour:'2-digit', minute:'2-digit', hour12:true, timeZone: 'Asia/Kolkata' }) + ' IST');
    };
    tick();
    const iv = setInterval(tick, 1000);
    return () => clearInterval(iv);
  }, []);

  const tabs = [
    { id: 'tamil', label: 'தமிழ்' },
    { id: 'india', label: '🇮🇳 INDIA' },
    { id: 'world', label: '🌍 WORLD' },
  ];

  return (
    <div style={{ position:'fixed', inset:0, background:'#1a0008', zIndex:9000, overflowX:'hidden', overflowY:'auto' }}>
      <div style={{ background:'linear-gradient(90deg,#0a0a0a,#1a0505,#0a0a0a)', borderBottom:'3px solid #cc0000', padding:'10px 20px', display:'flex', alignItems:'center', justifyContent:'space-between', position:'sticky', top:0, zIndex:10 }}>
        <div style={{ display:'flex', alignItems:'center', gap:10 }}>
          <div style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:15, color:'#fff', letterSpacing:2, lineHeight:1 }}>
            NETHAJI <span style={{color:'#FFD700'}}>PRIME</span>
            <span style={{fontSize:8, color:'#cc0000', letterSpacing:2, marginLeft:6}}>BULLETIN</span>
          </div>
          <div style={{ display:'flex', alignItems:'center', gap:3, background:'#cc0000', padding:'2px 6px', borderRadius:3, marginLeft:4 }}>
            <div style={{ width:6, height:6, borderRadius:'50%', background:'#fff', animation:'npbpulse 1s infinite' }}></div>
            <span style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:11, color:'#fff', letterSpacing:2 }}>LIVE</span>
          </div>
        </div>
        <div style={{ display:'flex', gap:3, alignItems:'center', overflowX:'auto', flexWrap:'nowrap', WebkitOverflowScrolling:'touch', scrollbarWidth:'none', msOverflowStyle:'none', flex:1, minWidth:0, justifyContent:'flex-end' }}>
          <span style={{ fontSize:12, color:'rgba(255,255,255,0.6)' }}>{currentTime}</span>
          {tabs.map(tab => (
            <button key={tab.id}
              onClick={() => { window.speechSynthesis && window.speechSynthesis.cancel(); window._npBulletinId=(window._npBulletinId||0)+1; window.stopBulletinAudio && window.stopBulletinAudio(); setActiveTab(tab.id); }}
              style={{ background: activeTab===tab.id ? '#cc0000' : 'rgba(255,255,255,0.08)', color:'#fff', border:'none', borderRadius:3, padding:'3px 6px', fontSize:10, cursor:'pointer', whiteSpace:'nowrap', flexShrink:0 }}>
              {tab.label}
            </button>
          ))}
          <button onClick={onClose} style={{ background:'rgba(255,0,0,0.2)', border:'1px solid rgba(255,0,0,0.4)', color:'#fff', width:28, height:28, borderRadius:'50%', cursor:'pointer', fontSize:12, flexShrink:0, display:'flex', alignItems:'center', justifyContent:'center' }}>✕</button>
        </div>
      </div>
      <div>
      <NethajiBulletin key={activeTab} lang={activeTab === 'tamil' ? 'ta' : activeTab === 'india' ? 'en_india' : 'en_world'} />

        <div style={{padding:'8px 16px 2px',fontFamily:"'Bebas Neue',sans-serif",fontSize:13,color:'#FFD700',letterSpacing:3}}>
          {activeTab==='tamil'?'🌤️ தமிழ்நாடு வானிலை':activeTab==='india'?'🌤️ INDIA WEATHER':'🌍 WORLD WEATHER'}
        </div>
        <WeatherSection key={'w-'+activeTab} region={activeTab==='tamil'?'tamilnadu':activeTab==='india'?'india':'world'} backend={API_URL}/>
      </div>
      <div style={{borderTop:'1px solid rgba(255,255,255,0.07)'}}>
        <div style={{padding:'8px 16px 2px',fontFamily:"'Bebas Neue',sans-serif",fontSize:13,color:'#FFD700',letterSpacing:3}}>
          {activeTab==='tamil'?'📰 தமிழ் செய்திகள்':activeTab==='india'?'📰 INDIA NEWS':'📰 WORLD NEWS'}
        </div>
        <NewsFeedSection key={'n-'+activeTab} category={activeTab==='tamil'?'tamil':activeTab==='india'?'india':'world'} backend={API_URL}/>
      </div>
      <style>{`@keyframes npbpulse { 0%,100%{opacity:1} 50%{opacity:0.3} }`}</style>
    </div>
  );
}


function GoogleAuthButton({ onLogin, onLogout, user, onShowWatchlist, onUpgrade }) {
  const GOOGLE_CLIENT_ID = "513916374374-9ju2ar957drp2evcbskmq127bpj6llao.apps.googleusercontent.com";

  useEffect(() => {
    // Task 2: Skip GSI init entirely if user already logged in
    const existingUser = localStorage.getItem("np_google_user");
    if (existingUser) {
      try {
        const userData = JSON.parse(existingUser);
        onLogin(userData);
      } catch(e) {}
      return;
    }
    if (window.google) {
      window.google.accounts.id.initialize({ client_id: GOOGLE_CLIENT_ID, callback: handleCredentialResponse, auto_select: false });
      return;
    }
    if (document.querySelector("script[src*='accounts.google.com']")) return;
    const script = document.createElement("script");
    script.src = "https://accounts.google.com/gsi/client";
    script.async = true; script.defer = true;
    script.onload = () => {
      if (window.google) {
        window.google.accounts.id.initialize({ client_id: GOOGLE_CLIENT_ID, callback: handleCredentialResponse, auto_select: false });
      }
    };
    document.head.appendChild(script);
  }, []);

  const handleCredentialResponse = async (response) => {
    try {
      const payload = JSON.parse(atob(response.credential.split(".")[1]));
      const userData = { id: payload.sub, name: payload.name, email: payload.email, picture: payload.picture, credential: response.credential };
      localStorage.setItem("np_google_user", JSON.stringify(userData));
      localStorage.setItem("np_user_id", payload.sub);
      onLogin(userData);
    } catch(e) { console.error("Google login error:", e); }
  };

  const handleGoogleLogin = () => {
    if (window.google && window.google.accounts) {
      window.google.accounts.id.prompt();
    }
    else {
      const authUrl = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${GOOGLE_CLIENT_ID}&redirect_uri=${window.location.origin}&response_type=token&scope=https://www.googleapis.com/auth/youtube.force-ssl&prompt=consent`;
      window.open(authUrl, "googleAuth", "width=500,height=600");
    }
  };

  const [showMenu, setShowMenu] = React.useState(false);
  const menuRef = React.useRef();
  React.useEffect(() => {
    const h = (e) => { if (menuRef.current && !menuRef.current.contains(e.target)) setShowMenu(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  if (user) {
    const initials = user.name ? user.name.split(" ").map(n => n[0]).join("").toUpperCase().slice(0,2) : "U";
    return (
      <div ref={menuRef} style={{ position:"relative" }}>
        <div onClick={() => setShowMenu(s => !s)} style={{ display:"flex", alignItems:"center", gap:8, cursor:"pointer", padding:"4px 8px", borderRadius:8, border:"1px solid rgba(255,215,0,0.3)", background:"rgba(255,215,0,0.1)" }}>
          {user.picture
            ? <img src={user.picture} alt={user.name} style={{ width:30, height:30, borderRadius:"50%", border:"2px solid #FFD700" }} />
            : <div style={{ width:30, height:30, borderRadius:"50%", background:"#FFD700", color:"#000", display:"flex", alignItems:"center", justifyContent:"center", fontFamily:"'Bebas Neue',sans-serif", fontSize:13 }}>{initials}</div>
          }
          <span style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:11, color:"#FFD700", letterSpacing:1 }}>{user.name.split(" ")[0].toUpperCase()}</span>
          <span style={{ color:"#FFD700", fontSize:9 }}>{showMenu ? "▲" : "▼"}</span>
        </div>
        {showMenu && (
          <div style={{ position:"absolute", top:"calc(100% + 8px)", right:0, background:"#0f0005", border:"1px solid rgba(255,215,0,0.3)", borderRadius:10, minWidth:220, zIndex:9999, boxShadow:"0 8px 32px rgba(0,0,0,0.8)", overflow:"hidden" }}>
            <div style={{ padding:"14px 16px", borderBottom:"1px solid rgba(255,255,255,0.1)", display:"flex", gap:10, alignItems:"center" }}>
              {user.picture ? <img src={user.picture} alt={user.name} style={{ width:38, height:38, borderRadius:"50%", border:"2px solid #FFD700" }} /> : <div style={{ width:38, height:38, borderRadius:"50%", background:"#FFD700", color:"#000", display:"flex", alignItems:"center", justifyContent:"center", fontFamily:"'Bebas Neue',sans-serif", fontSize:16 }}>{initials}</div>}
              <div>
                <div style={{ fontSize:14, fontWeight:700, color:"#fff" }}>{user.name}</div>
                <div style={{ fontSize:11, color:"rgba(255,255,255,0.5)" }}>{user.email}</div>
                <div style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:10, color:"#FFD700", letterSpacing:1 }}>FREE PLAN</div>
              </div>
            </div>
            {[
              ["📺", "My Watchlist"],
              ["👑", "Upgrade ₹99/mo", true],
              ["🔔", "Notifications"],
              ["❤️", "Liked Videos"],
              ["⏱", "Watch History"],
              ["⚙️", "Settings"],
            ].map(([icon, label, gold]) => (
              <div key={label} onClick={() => { if(label==="My Watchlist" && onShowWatchlist){ onShowWatchlist(); } if(label==="Upgrade ₹99/mo" && onUpgrade){ onUpgrade(); } setShowMenu(false); }}
                style={{ display:"flex", alignItems:"center", gap:10, padding:"10px 16px", cursor:"pointer", borderBottom:"1px solid rgba(255,255,255,0.05)", color: gold ? "#FFD700" : "#fff", fontSize:13, fontWeight:600 }}
                onMouseEnter={e => e.currentTarget.style.background="rgba(255,215,0,0.08)"}
                onMouseLeave={e => e.currentTarget.style.background="transparent"}>
                <span>{icon}</span>{label}
                {gold && <span style={{ marginLeft:"auto", fontFamily:"'Bebas Neue',sans-serif", fontSize:9, background:"#FFD700", color:"#000", padding:"2px 6px", borderRadius:3 }}>PRO</span>}
              </div>
            ))}
            <div onClick={() => { onLogout(); setShowMenu(false); }}
              style={{ display:"flex", alignItems:"center", gap:10, padding:"10px 16px", cursor:"pointer", color:"#FF4444", fontSize:13, fontWeight:600 }}
              onMouseEnter={e => e.currentTarget.style.background="rgba(255,68,68,0.1)"}
              onMouseLeave={e => e.currentTarget.style.background="transparent"}>
              🚪 Sign Out
            </div>
          </div>
        )}
      </div>
    );
  }

  return (
    <button onClick={handleGoogleLogin} style={{ background:"#fff", color:"#333", fontFamily:"'Bebas Neue',sans-serif", fontSize:12, letterSpacing:1, padding:"8px 16px", borderRadius:6, border:"none", cursor:"pointer", display:"flex", alignItems:"center", gap:6 }}>
      <img src="https://www.google.com/favicon.ico" width="14" height="14" alt="G" />
      SIGN IN WITH GOOGLE
    </button>
  );
}

// ── YOUTUBE ACTIONS ──────────────────────────────────────────────────────────

// -- VIDEO COMMENTS --
function VideoComments({ item, backend }) {
  const [comments, setComments] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [show, setShow] = React.useState(true);

  const fetchComments = React.useCallback(async () => {
    const vid = item?.id || item?.videoId;
    if (!vid) return;
    setLoading(true);
    try {
      // Try cached comments first
      const r = await fetch(`${backend}/api/youtube-comments?video_id=${vid}&max_results=20`);
      const d = await r.json();
      if (d.comments && d.comments.length > 0) {
        setComments(d.comments);
      }
    } catch(e) {}
    setLoading(false);
  }, [item?.id, backend]);

  // Auto-fetch comments when video opens
  React.useEffect(() => {
    if (item?.type === 'youtube') fetchComments();
  }, [item?.id, fetchComments]);

  const handleToggle = () => {
    if (!show && comments.length === 0) fetchComments();
    setShow(s => !s);
  };

  if (item?.type !== 'youtube') return null;

  return (
    <div style={{ marginTop: 12 }}>
      <button onClick={handleToggle} style={{ background: 'none', border: '1px solid rgba(255,255,255,0.15)', color: 'rgba(255,255,255,0.7)', fontFamily: "'Barlow Condensed',sans-serif", fontSize: 13, letterSpacing: 1, padding: '6px 14px', borderRadius: 4, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 6 }}>
        <span>&#x1F4AC;</span> {show ? 'HIDE' : 'SHOW'} COMMENTS {comments.length > 0 && `(${comments.length})`}
      </button>
      {show && (
        <div style={{ marginTop: 10 }}>
          {loading && <div style={{ color: 'rgba(255,255,255,0.4)', fontSize: 13, padding: 8 }}>Loading comments...</div>}
          {!loading && comments.length === 0 && <div style={{ color: 'rgba(255,255,255,0.4)', fontSize: 13, padding: 8 }}>No comments available</div>}
          {comments.map((c, i) => (
            <div key={i} style={{ display: 'flex', gap: 10, padding: '10px 0', borderBottom: '1px solid rgba(255,255,255,0.06)' }}>
              {c.avatar
                ? <img src={c.avatar} alt={c.author} style={{ width: 32, height: 32, borderRadius: '50%', flexShrink: 0 }} />
                : <div style={{ width: 32, height: 32, borderRadius: '50%', background: 'rgba(255,215,0,0.2)', flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14 }}>&#x1F464;</div>
              }
              <div>
                <div style={{ color: '#FFD700', fontSize: 12, fontWeight: 600, marginBottom: 3 }}>{c.author}</div>
                <div style={{ color: 'rgba(255,255,255,0.8)', fontSize: 13, lineHeight: 1.4 }} dangerouslySetInnerHTML={{ __html: c.text }} />
                {c.likes > 0 && <div style={{ color: 'rgba(255,255,255,0.4)', fontSize: 11, marginTop: 4 }}>&#x1F44D; {c.likes}</div>}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function YouTubeActions({ item }) {
  const [liked, setLiked] = React.useState(false);
  const [subscribed, setSubscribed] = React.useState(false);
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "https://nethajiprime-backend.onrender.com";

  React.useEffect(() => {
    const handler = (e) => {
      if (e.data && e.data.type === "youtube_action_done") {
        const msg = e.data.msg || "";
        if (msg.includes("liked") || msg.includes("Like")) setLiked(true);
        if (msg.includes("Subscribed") || msg.includes("subscribe")) setSubscribed(true);
        alert("✅ " + msg);
      }
    };
    window.addEventListener("message", handler);
    return () => window.removeEventListener("message", handler);
  }, []);

  if (!item || item.type !== "youtube") return null;

  const handleAction = (action) => {
    const authUrl = `${BACKEND_URL}/api/youtube/auth?video_id=${item.id}&action=${action}`;
    window.open(authUrl, "ytOAuth", "width=500,height=600,left=300,top=100");
  };

  return (
    <div style={{ display:"flex", gap:8, marginTop:8, flexWrap:"wrap" }}>
      <button onClick={() => handleAction("like")} disabled={liked}
        style={{ background: liked ? "#FF0000" : "rgba(255,0,0,0.15)", color: liked ? "#fff" : "#FF0000", border:"1px solid #FF0000", fontFamily:"'Bebas Neue',sans-serif", fontSize:11, letterSpacing:1, padding:"6px 14px", borderRadius:4, cursor: liked ? "default" : "pointer" }}>
        {liked ? "✅ LIKED!" : "👍 LIKE"}
      </button>
      <button onClick={() => handleAction("subscribe")} disabled={subscribed}
        style={{ background: subscribed ? "#FF0000" : "rgba(255,0,0,0.15)", color: subscribed ? "#fff" : "#FF0000", border:"1px solid #FF0000", fontFamily:"'Bebas Neue',sans-serif", fontSize:11, letterSpacing:1, padding:"6px 14px", borderRadius:4, cursor: subscribed ? "default" : "pointer" }}>
        {subscribed ? "✅ SUBSCRIBED!" : "\uD83D\uDD14 SUBSCRIBE"}
      </button>
    </div>
  );
}

// ── NP LIKE BUTTON ───────────────────────────────────────────────────────────
function NPLikeButton({ item, backend }) {
  const [liked, setLiked] = React.useState(false);
  const [likeCount, setLikeCount] = React.useState(item.like_count || 0);

  React.useEffect(() => {
    const userId = localStorage.getItem("np_user_id") || "guest";
    fetch(`${backend}/api/like-status/${item.id}?user_id=${userId}`)
      .then(r => r.json())
      .then(d => { setLiked(d.liked); setLikeCount(d.like_count || 0); })
      .catch(() => {});
  }, [item.id, backend]);

  const handleLike = async () => {
    const userId = localStorage.getItem("np_user_id") || "guest";
    try {
      const method = liked ? "DELETE" : "POST";
      const r = await fetch(`${backend}/api/video-like/${item.id}`, { method, headers: { "Content-Type": "application/json" }, body: JSON.stringify({ user_id: userId }) });
      const d = await r.json();
      setLiked(!liked);
      setLikeCount(d.like_count || 0);
    } catch(e) {}
  };

  if (item.type === "youtube") return null;

  return (
    <button onClick={handleLike}
      style={{ background: liked ? "#FF0000" : "rgba(255,0,0,0.15)", color: liked ? "#fff" : "#FF0000", border:"1px solid #FF0000", fontFamily:"'Bebas Neue',sans-serif", fontSize:11, letterSpacing:1, padding:"6px 14px", borderRadius:4, cursor:"pointer", marginTop:8 }}>
      {liked ? `♥ LIKED${likeCount > 0 ? " (" + likeCount + ")" : ""}` : `♡ LIKE${likeCount > 0 ? " (" + likeCount + ")" : ""}`}
    </button>
  );
}

// ── HERO BANNER ──────────────────────────────────────────────────────────────
function HeroBanner({
  items, onPlay, videoStats = {}, trendingIds = [], isInWatchlist = () => false, addToWatchlist = () => {}, removeFromWatchlist = () => {} }) {
  const [idx, setIdx] = React.useState(0);
  const [fade, setFade] = React.useState(true);
  const timer = React.useRef();

  const goTo = React.useCallback((i) => {
    setFade(false);
    setTimeout(() => { setIdx(i); setFade(true); }, 300);
  }, []);

  React.useEffect(() => {
    if (!items.length) return;
    timer.current = setInterval(() => { goTo(i => (i + 1) % Math.min(items.length, 10)); }, 10000);
    return () => clearInterval(timer.current);
  }, [items.length, goTo]);

  const resetAndGo = (i) => {
    clearInterval(timer.current);
    goTo(i);
    timer.current = setInterval(() => { goTo(j => (j + 1) % Math.min(items.length, 10)); }, 10000);
  };

  if (!items.length) return <div style={{ height: "var(--hero-height)", background: "var(--np-bg)" }} />;

  const item = items[Math.min(idx, items.length - 1)];
  const thumb = item.type === "youtube" ? item.thumb
    : item.type === "facebook" ? (item.thumbnail_url || "")
    : item.type === "speech" ? (item.thumbnail_url || "")
    : `${BUNNY_THUMB}/${item.bunny_video_id}/thumbnail.jpg`;
  const isFacebookNoThumb = item.type === "facebook" && !item.thumbnail_url;
  const isTrending = trendingIds.indexOf(item.id) >= 0 && trendingIds.indexOf(item.id) < 5;
  const stats = videoStats[item.id];

  return (
    <div className="np-hero">
      {/* Blurred background */}
      {thumb && <img src={thumb} alt="" className="np-hero-bg-blur" aria-hidden="true" />}

      {/* Main image */}
      {thumb && <img src={thumb} alt={item.title} className="np-hero-img" />}

      {/* Progress bar */}
      <div className="np-hero-bar">
        <div className="np-hero-bar-fill" style={{ width: `${((idx+1)/Math.min(items.length,10))*100}%` }} />
      </div>

      {/* Gradient overlay */}
      <div className="np-hero-gradient" />

      {/* Content */}
      <div className="np-hero-content" style={{ opacity: fade ? 1 : 0 }}>
        {/* Eyebrow */}
        <div className="np-hero-eyebrow">
          <div className="np-hero-eye-line" />
          <div className="np-hero-eye-text">NOW FEATURING</div>
          {item.is_series && <div className="np-hero-trending" style={{ background: 'rgba(255,215,0,0.92)', color: '#1a0505' }}>📚 SERIES</div>}
          {isTrending && <div className="np-hero-trending">🔥 TRENDING</div>}
        </div>

        {/* Category */}
        <div className="np-hero-category">
          {(item.is_series ? item._series : (item.category || item.channelLabel || "NP ORIGINAL")).toUpperCase()}
        </div>

        {/* Title */}
        <div className="np-hero-title">{item.title}</div>

        {/* Meta */}
        <div className="np-hero-meta">
          <span className="np-hero-meta-highlight">{item.category || item.channelLabel || "Nethaji Prime"}</span>
          {" • Tamil • 2026"}
        </div>

        {/* Buttons */}
        <div className="np-hero-btns">
          <button className="np-btn-play" onClick={() => onPlay(item)}>▶ PLAY NOW</button>
          <button
            className={`np-btn-wl${isInWatchlist(item.id) ? " np-btn-wl-active" : ""}`}
            onClick={(e) => { e.stopPropagation(); isInWatchlist(item.id) ? removeFromWatchlist(item.id) : addToWatchlist(item); }}>
            {isInWatchlist(item.id) ? "✅ IN WATCHLIST" : "+ WATCHLIST"}
          </button>
        </div>

        {/* Tags */}
        <div className="np-hero-tags">
          {item.category && <span className="np-tag-gold">{item.category}</span>}
          {item.lang && <span className="np-tag-white">{item.lang?.toUpperCase()}</span>}
        </div>

        {/* Stats */}
        {stats && (
          <div className="np-hero-stats">
            <span className="np-stat-badge">👁 {(stats.views || 0).toLocaleString("en-IN")}</span>
            <span className="np-stat-badge">👍 {(stats.likes || 0).toLocaleString("en-IN")}</span>
          </div>
        )}
      </div>

      {/* Navigation dots */}
      <div className="np-hero-dots">
        {items.slice(0, 10).map((_, i) => (
          <div
            key={i}
            onClick={() => resetAndGo(i)}
            className={`np-hero-dot${i === idx ? " np-hero-dot-active" : ""}`}
            style={{ width: i === idx ? 26 : 8 }}
          />
        ))}
      </div>
    </div>
  );
}

// ── VIDEO CARD ───────────────────────────────────────────────────────────────
function VideoCard({ item, onPlay, videoStats = {}, trendingIds = [] }) {
  const thumb = item.type === "youtube" ? item.thumb
    : item.type === "facebook" ? (item.thumbnail_url || "")
    : item.type === "speech" ? (item.thumbnail_url || "")
    : `${BUNNY_THUMB}/${item.bunny_video_id}/thumbnail.jpg`;
  const isFacebookNoThumb = item.type === "facebook" && !item.thumbnail_url;
  const stats = videoStats[item.id] || (item.views_count ? { views: item.views_count, likes: item.like_count || 0, comments: 0 } : null);
  const rank = trendingIds.indexOf(item.id);
  const [hovered, setHovered] = React.useState(false);
  const [showPreview, setShowPreview] = React.useState(false);
  const hoverTimer = React.useRef(null);

  const handleMouseEnter = () => {
    setHovered(true);
    // Only show video preview for YouTube videos on desktop
    if (item.type === "youtube" && item.url) {
      hoverTimer.current = setTimeout(() => setShowPreview(true), 1000);
    }
  };
  const handleMouseLeave = () => {
    setHovered(false);
    setShowPreview(false);
    if (hoverTimer.current) clearTimeout(hoverTimer.current);
  };

  // Extract YouTube video ID
  const ytId = item.type === "youtube" && item.url
    ? (item.url.match(/[?&]v=([^&]+)/)?.[1] || item.id)
    : null;

  return (
    <div
      style={{ ...S.card, transform: hovered ? "scale(1.06)" : "scale(1)", transition: "transform 0.25s ease, box-shadow 0.25s ease", boxShadow: hovered ? "0 12px 40px rgba(0,0,0,0.7), 0 0 20px rgba(255,215,0,0.15)" : "none", zIndex: hovered ? 10 : 1, position: "relative" }}
      className="np-card"
      onClick={() => onPlay(item)}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div style={{ ...S.cardImg, position: "relative", overflow: "hidden" }} className="np-card-img">
        {/* Thumbnail */}
        {isFacebookNoThumb ? (
          <div style={{ width:"100%", height:"100%", background:"linear-gradient(135deg, #1877f2, #0a3d8f)", display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", gap:8 }}>
            <div style={{ fontSize:32 }}>📘</div>
            <div style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:11, letterSpacing:2, color:"rgba(255,255,255,0.9)" }}>FACEBOOK</div>
            <div style={{ fontFamily:"'Rajdhani',sans-serif", fontSize:10, color:"rgba(255,255,255,0.6)", marginTop:2 }}>▶ Watch on Facebook</div>
          </div>
        ) : (
          <img
            src={thumb || ""}
            alt={item.title}
            style={{ width:"100%", height:"100%", objectFit:"cover", display:"block", opacity: showPreview ? 0 : 1, transition: "opacity 0.3s ease" }}
          />
        )}
        {/* YouTube hover preview iframe */}
        {showPreview && ytId && (
          <iframe
            src={`https://www.youtube.com/embed/${ytId}?autoplay=1&mute=1&controls=0&modestbranding=1&rel=0&loop=1&playlist=${ytId}`}
            style={{ position:"absolute", inset:0, width:"100%", height:"100%", border:"none", opacity: showPreview ? 1 : 0, transition: "opacity 0.3s ease" }}
            allow="autoplay"
            title={item.title}
          />
        )}
        {/* Play icon overlay on hover (non-YouTube) */}
        {hovered && !showPreview && (
          <div style={{ position:"absolute", inset:0, display:"flex", alignItems:"center", justifyContent:"center", background:"rgba(0,0,0,0.35)" }}>
            <div style={{ width:40, height:40, borderRadius:"50%", background:"rgba(255,215,0,0.9)", display:"flex", alignItems:"center", justifyContent:"center" }}>
              <span style={{ fontSize:16, marginLeft:3 }}>▶</span>
            </div>
          </div>
        )}
        <div style={S.cardShine} />
        {item.type !== "youtube" && <div style={S.cardBadge}>ORIGINAL</div>}
        {item.type === "youtube" && <div style={S.cardBadgeYT}>YOUTUBE</div>}
        {rank >= 0 && rank < 5 && (
          <div style={{ position:"absolute", bottom:6, right:6, background:"rgba(255,69,0,0.9)", color:"#fff", fontFamily:"'Bebas Neue',sans-serif", fontSize:9, letterSpacing:1, padding:"2px 6px", borderRadius:3 }}>
            {rank === 0 ? "🔥 #1" : rank === 1 ? "🔥 #2" : `⚡ #${rank+1}`}
          </div>
        )}
      </div>
      <div style={S.cardTitle} className="np-card-title">{item.title}</div>
      <div style={{ display:"flex", gap:6, marginTop:4, flexWrap:"wrap", alignItems:"center" }}>
        <div style={S.cardMeta} className="np-card-meta">{(item.category || item.channelLabel || "NP ORIGINAL").toUpperCase()}</div>
        {stats && <span style={S.statBadge}>👁 {formatNum(stats.views || 0)}</span>}
        {stats && stats.likes > 0 && <span style={S.statBadge}>👍 {formatNum(stats.likes)}</span>}
      </div>
      {/* ShareButtons hidden in list - only in modal */}
    </div>
  );
}

// ── VIDEO LIST ITEM ──────────────────────────────────────────────────────────
function VideoListItem({ item, onPlay }) {
  const thumb = item.type === "youtube" ? item.thumb
    : item.type === "facebook" ? (item.thumbnail_url || "")
    : item.type === "speech" ? (item.thumbnail_url || "")
    : `${BUNNY_THUMB}/${item.bunny_video_id}/thumbnail.jpg`;
  const isFacebookNoThumb = item.type === "facebook" && !item.thumbnail_url;

  return (
    <div style={S.vItem} className="np-vitem" onClick={() => onPlay(item)}>
      <div style={S.vThumb} className="np-vthumb">
        {thumb && <img src={thumb} alt={item.title} style={{ width:"100%", height:"100%", objectFit:"cover", display:"block" }} />}
        {item.type === "youtube" && <div style={S.ytBadge}>YOUTUBE</div>}
        {item.type !== "youtube" && <div style={S.cardBadge}>ORIGINAL</div>}
      </div>
      <div style={S.vInfo} className="np-vinfo">
        <div style={S.vTitle} className="np-vtitle">{item.title}</div>
        <div style={S.vMeta} className="np-vmeta">{(item.channelLabel || item.category || "NETHAJI PRIME").toUpperCase()}</div>
        <div className="np-stats-row" style={{ display:"flex", gap:6, marginTop:4, flexWrap:"nowrap", alignItems:"center", overflowX:"auto", scrollbarWidth:"none", msOverflowStyle:"none", WebkitOverflowScrolling:"touch" }}>
          <div style={S.vCat}>{(item.category || item.channelLabel || "NP ORIGINAL").toUpperCase()}</div>
          {(item.stats?.views > 0 || item.views_count > 0) && <span style={S.statBadge}>👁 {formatNum(item.stats?.views || item.views_count || 0)}</span>}
          {(item.stats?.likes > 0 || item.like_count > 0) && <span style={S.statBadge}>👍 {formatNum(item.stats?.likes || item.like_count || 0)}</span>}
          {item.stats?.comments > 0 && <span style={S.statBadge}>💬 {formatNum(item.stats.comments)}</span>}
          <HypeButton item={item} backend={process.env.REACT_APP_BACKEND_URL || "https://nethajiprime-backend.onrender.com"} />
        </div>
      {/* ShareButtons hidden in list - only in modal */}
      </div>
    </div>
  );
}

// ── CONTENT ROW ──────────────────────────────────────────────────────────────

// -- AD BANNER --
// Direct-sold banner on the Watch Now browse page.
//
// This component was missed when the other ad surfaces were fixed: it still
// chose by raw list position (newest-created first), so monthly_rate never
// influenced what showed here, and it had no premium exclusion, no frequency
// cap and no ad_events tracking. Brought to parity with AdUnit.
function AdBanner({ backend, index = 0, isPaidUser = false }) {
  const [ad, setAd] = React.useState(null);
  React.useEffect(() => {
    let cancelled = false;
    AdService.fetchGlobalConfig(backend).then(() => {
      if (cancelled || !AdService.shouldShowAds(isPaidUser)) return;
      return fetch(backend + '/api/ads?active_only=true')
        .then(r => r.json())
        .then(d => {
          if (cancelled) return;
          const banners = (d.ads || []).filter(a => a.type === 'banner');
          // Each slot draws from the pool minus the ads the earlier slots took,
          // so two banners on one page never land on the same creative.
          let picked = null;
          const remaining = [...banners];
          for (let i = 0; i <= index; i++) {
            picked = AdService.pickWeightedAd(remaining);
            if (!picked) break;
            remaining.splice(remaining.indexOf(picked), 1);
          }
          if (picked) { setAd(picked); AdService.recordAdShown(picked.id); }
        });
    }).catch(() => {});
    return () => { cancelled = true; };
  }, [backend, index, isPaidUser]);

  // Track impression - must be before conditional return
  React.useEffect(() => {
    if (ad) {
      fetch(backend + '/api/ads/' + ad.id + '/impression', { method: 'POST' }).catch(() => {});
      AdService.trackEvent(backend, { ad_id: ad.id, event_type: 'impression', placement: 'banner' });
    }
  }, [ad?.id]);

  if (!ad) return null;

  const isVideo = /\.(mp4|webm)(\?|$)/i.test(ad.media_url || '');

  const handleClick = async () => {
    try { await fetch(backend + '/api/ads/' + ad.id + '/click', { method: 'POST' }); } catch {}
    AdService.trackEvent(backend, { ad_id: ad.id, event_type: 'click', placement: 'banner' });
    if (ad.click_url) window.open(ad.click_url, '_blank');
  };

  return (
    <div onClick={handleClick} style={{ margin: '8px 28px', borderRadius: 10, overflow: 'hidden', cursor: ad.click_url ? 'pointer' : 'default', position: 'relative', border: '1px solid rgba(255,215,0,0.15)' }}>
      {isVideo
        ? <video src={ad.media_url} muted autoPlay loop playsInline
            style={{ width: '100%', height: 120, objectFit: 'contain', display: 'block', background: 'rgba(0,0,0,0.3)' }}
            onError={e => e.target.parentElement.style.display='none'} />
        : <img src={ad.media_url} alt={ad.title} style={{ width: '100%', height: 120, objectFit: 'contain', display: 'block', background: 'rgba(0,0,0,0.3)' }}
            onError={e => e.target.parentElement.style.display='none'} />}
      <div style={{ position: 'absolute', top: 6, right: 8, background: 'rgba(0,0,0,0.6)', color: 'rgba(255,255,255,0.5)', fontSize: 9, padding: '2px 6px', borderRadius: 3, letterSpacing: 1 }}>AD</div>
    </div>
  );
}

function ContentRow({ title, items, onPlay, accentColor = "#FFD700", asList = false, videoStats = {}, trendingIds = [], onSeeAll }) {
  const ref = useRef();
  if (!items?.length) return null;
  const scroll = d => ref.current?.scrollBy({ left: d * 420, behavior: "smooth" });

  return (
    <div style={S.section} className="np-section">
      <div style={S.secHd}>
        <div style={S.secTw}>
          <div style={{ ...S.secBar, background: accentColor }} />
          <div style={S.secNm} className="np-sec-nm">{title}</div>
        </div>
        {onSeeAll && <div style={S.seeAll} className="np-see-all" role="button" tabIndex={0} onClick={() => onSeeAll(title)}>SEE ALL ›</div>}
      </div>
      {asList ? (
        <div>{items.map(item => <VideoListItem key={item.id} item={{ ...item, stats: videoStats && videoStats[item.id] }} onPlay={onPlay} />)}</div>
      ) : (
        <div style={{ position:"relative" }}>
          <button style={{ ...S.scrollBtn, left:0 }} className="np-scroll-btn" onClick={() => scroll(-1)}>‹</button>
          <div ref={ref} style={S.hRow} className="np-hrow">{items.map(item => <VideoCard key={item.id} item={item} onPlay={onPlay} videoStats={videoStats} trendingIds={trendingIds} />)}</div>
          <button style={{ ...S.scrollBtn, right:0 }} className="np-scroll-btn" onClick={() => scroll(1)}>›</button>
        </div>
      )}
    </div>
  );
}

// ── LIVE STRIP ───────────────────────────────────────────────────────────────
function LiveStrip({ rssData, onPlay }) {
  // ALWAYS populated: the selected channel's latest daily upload in the red
  // LIVE-NOW banner, upgrading to the real live stream + pulsing badge when
  // /api/live-now reports that channel live. Refreshed ~every 2 min.
  const [liveMap, setLiveMap] = useState({});
  const [active, setActive] = useState(0);
  const [autoRotate, setAutoRotate] = useState(true);
  useEffect(() => {
    let alive = true;
    const load = () => fetch(`${BACKEND}/api/live-now`).then(r => r.json())
      .then(d => {
        if (!alive) return;
        const m = {};
        // channels[] = every channel with is_live + latest (server-side fallback)
        (Array.isArray(d.channels) ? d.channels : []).forEach(c => { if (c.channel_id) m[c.channel_id] = c; });
        setLiveMap(m);
      }).catch(() => {});
    load();
    const t = setInterval(load, 120000);
    return () => { alive = false; clearInterval(t); };
  }, []);

  // Auto-rotate through the 4 channels every 6s (parity with the app LiveScreen),
  // showcasing each channel's latest. A channel-button click pauses rotation so
  // the banner never switches out from under the user.
  useEffect(() => {
    if (!autoRotate) return;
    const id = setInterval(() => {
      setActive(prev => (prev + 1) % RSS_CHANNELS.length);
    }, 6000);
    return () => clearInterval(id);
  }, [autoRotate]);

  const ch = RSS_CHANNELS[active] || RSS_CHANNELS[0];
  const liveEntry = liveMap[ch.channelId];
  const isLive = !!(liveEntry && liveEntry.is_live);
  const liveLatest = liveEntry?.latest;
  const latest = rssData[ch.id]?.[0]
    || (liveLatest ? { id: liveLatest.video_id, title: liveLatest.title, thumb: liveLatest.thumb, url: liveLatest.url, type: "youtube" } : null);
  const title = isLive ? (liveEntry.title || `${ch.label} — Live Now`) : (latest?.title || `${ch.label} — Latest`);
  const item = isLive
    ? { id: liveEntry.video_id, youtube_id: liveEntry.video_id, type: "youtube", title: liveEntry.title, thumb: liveEntry.thumb, thumbnail_url: liveEntry.thumb, channelLabel: ch.label }
    : (latest ? { ...latest, channelLabel: ch.label } : null);

  return (
    <div style={S.live} className="np-live">
      <div style={{ ...S.livePill, background: isLive ? "#FF0000" : "#333" }}>
        <div style={{ ...S.liveDot, animation: isLive ? "pulse 1s ease-in-out infinite" : "none" }} />
        {isLive ? "LIVE" : "LATEST"}
      </div>
      <div style={S.liveInfo}>
        <div style={S.liveT} className="np-live-t">{title}</div>
        <div style={S.liveS}>📺 {ch.label} · {isLive ? "LIVE ON YOUTUBE" : "LATEST ON YOUTUBE"}</div>
      </div>
      <div style={S.liveChs}>
        {RSS_CHANNELS.map((c, i) => (
          <button key={c.id} onClick={() => { setAutoRotate(false); setActive(i); }} style={{ ...S.lch, backgroundColor: c.color, opacity: i === active ? 1 : 0.6 }}>
            {c.label.toUpperCase()}
          </button>
        ))}
      </div>
      {item && <button onClick={() => onPlay && onPlay(item)} style={{ ...S.watchLive, border: "none", cursor: "pointer" }}>▶ {isLive ? "WATCH LIVE" : "WATCH"}</button>}
    </div>
  );
}

// ── SEARCH BAR ───────────────────────────────────────────────────────────────
function SearchBar({ allVideos, onPlay, onClose }) {
  const [q, setQ] = useState("");
  const results = q.length > 1 ? sortNewest(allVideos.filter(v => v.title?.toLowerCase().includes(q.toLowerCase()))).slice(0, 8) : [];

  return (
    <div style={S.searchOverlay}>
      <div style={S.searchBox}>
        <input autoFocus style={S.searchInput} placeholder="Search videos, channels..." value={q} onChange={e => setQ(e.target.value)} />
        <button style={S.searchClose} onClick={onClose}>✕</button>
      </div>
      {results.length > 0 && (
        <div style={S.searchResults}>
          {results.map(item => (
            <div key={item.id} style={S.searchItem} onClick={() => { onPlay(item); onClose(); }}>
              <div style={S.searchThumb}>
                <img src={item.thumb || item.thumbnail_url || ""} alt={item.title} style={{ width:"100%", height:"100%", objectFit:"cover" }} />
              </div>
              <div>
                <div style={S.searchTitle}>{item.title}</div>
                <div style={S.searchMeta}>{(item.channelLabel || item.category || "NP ORIGINAL").toUpperCase()}</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// ── VIDEO MODAL ──────────────────────────────────────────────────────────────

// -- PRE-ROLL AD --
function PreRollAd({ backend, onComplete, isPaidUser = false }) {
  const [ad, setAd] = React.useState(null);
  const [countdown, setCountdown] = React.useState(5);
  const [canSkip, setCanSkip] = React.useState(false);
  const [loading, setLoading] = React.useState(true);
  const timerRef = React.useRef(null);

  React.useEffect(() => {
    let cancelled = false;
    // This path used to bypass AdService entirely: no global kill switch, no
    // premium exclusion, no frequency cap - subscribers got a pre-roll on every
    // single video open even with ads switched off in Ad Manager.
    AdService.fetchGlobalConfig(backend).then(() => {
      if (cancelled) return;
      if (!AdService.shouldShowAds(isPaidUser)) { setLoading(false); onComplete(); return; }
      return fetch(backend + '/api/ads?active_only=true')
        .then(r => r.json())
        .then(d => {
          if (cancelled) return;
          const prerolls = (d.ads || []).filter(a => a.type === 'preroll');
          const picked = AdService.pickWeightedAd(prerolls);
          if (picked) {
            setAd(picked);
            AdService.recordAdShown(picked.id);
            // Impression was recorded against prerolls[0].id while a different,
            // randomly-chosen ad was displayed - so with more than one active
            // pre-roll every impression was billed to the wrong advertiser.
            fetch(backend + '/api/ads/' + picked.id + '/impression', { method: 'POST' }).catch(()=>{});
            AdService.trackEvent(backend, { ad_id: picked.id, event_type: 'impression', placement: 'preroll' });
          } else {
            onComplete(); // No eligible pre-roll, skip immediately
          }
          setLoading(false);
        });
    }).catch(() => { if (!cancelled) { setLoading(false); onComplete(); } });
    return () => { cancelled = true; };
  }, [backend, isPaidUser]);

  React.useEffect(() => {
    if (!ad) return;
    timerRef.current = setInterval(() => {
      setCountdown(c => {
        if (c <= 1) {
          clearInterval(timerRef.current);
          setCanSkip(true);
          return 0;
        }
        return c - 1;
      });
    }, 1000);
    // Auto complete after ad duration
    const duration = (ad.duration_seconds || 15) * 1000;
    setTimeout(() => { clearInterval(timerRef.current); onComplete(); }, duration);
    return () => clearInterval(timerRef.current);
  }, [ad]);

  const handleSkip = () => { clearInterval(timerRef.current); onComplete(); };
  const handleAdClick = async () => {
    try { await fetch(backend + '/api/ads/' + ad.id + '/click', { method: 'POST' }); } catch {}
    AdService.trackEvent(backend, { ad_id: ad.id, event_type: 'click', placement: 'preroll' });
    if (ad.click_url) window.open(ad.click_url, '_blank');
  };

  if (loading) return null;
  if (!ad) return null;

  const isVideo = ad.media_url && (ad.media_url.endsWith('.mp4') || ad.media_url.includes('video'));

  return (
    <div style={{ position: 'absolute', inset: 0, zIndex: 20, background: '#000', display: 'flex', flexDirection: 'column' }}>
      {/* Ad media */}
      <div style={{ flex: 1, position: 'relative', cursor: 'pointer' }} onClick={handleAdClick}>
        {isVideo
          ? <video src={ad.media_url} autoPlay muted playsInline style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
          : <img src={ad.media_url} alt={ad.title} style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
        }
        {/* AD label */}
        <div style={{ position: 'absolute', top: 8, left: 8, background: 'rgba(0,0,0,0.7)', color: '#FFD700', fontSize: 10, padding: '2px 8px', borderRadius: 3, letterSpacing: 1 }}>AD</div>
        {/* Click to visit */}
        {ad.click_url && <div style={{ position: 'absolute', top: 8, right: 8, background: 'rgba(0,0,0,0.7)', color: '#fff', fontSize: 11, padding: '4px 10px', borderRadius: 4, cursor: 'pointer' }}>Visit Site ↗</div>}
      </div>
      {/* Bottom bar */}
      <div style={{ background: 'rgba(0,0,0,0.9)', padding: '8px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{ color: 'rgba(255,255,255,0.6)', fontSize: 12 }}>
          {ad.title} • Your video will play {countdown > 0 ? 'in ' + countdown + 's' : 'shortly'}
        </div>
        <button onClick={canSkip ? handleSkip : undefined}
          style={{ background: canSkip ? '#FFD700' : 'rgba(255,255,255,0.2)', color: canSkip ? '#000' : 'rgba(255,255,255,0.5)', border: 'none', borderRadius: 4, padding: '6px 16px', fontSize: 12, fontFamily: "'Bebas Neue',sans-serif", letterSpacing: 1, cursor: canSkip ? 'pointer' : 'not-allowed' }}>
          {canSkip ? 'SKIP AD ›' : 'SKIP IN ' + countdown + 's'}
        </button>
      </div>
    </div>
  );
}


// -- L-BAND OVERLAY AD --
function LBandAd({ backend, isPaidUser = false }) {
  const [ad, setAd] = React.useState(null);
  const [visible, setVisible] = React.useState(false);
  const [closed, setClosed] = React.useState(false);

  React.useEffect(() => {
    if (closed) return;
    let cancelled = false;
    const timers = [];
    // Same bypass as the pre-roll: no kill switch, no premium exclusion, no cap.
    AdService.fetchGlobalConfig(backend).then(() => {
      if (cancelled || !AdService.shouldShowAds(isPaidUser)) return;
      return fetch(backend + '/api/ads?active_only=true')
        .then(r => r.json())
        .then(d => {
          if (cancelled) return;
          const lbands = (d.ads || []).filter(a => a.type === 'lband');
          const picked = AdService.pickWeightedAd(lbands);
          if (picked) {
            setAd(picked);
            AdService.recordAdShown(picked.id);
            // Show after 3 seconds
            timers.push(setTimeout(() => setVisible(true), 3000));
            // Auto hide after duration
            const dur = (picked.duration_seconds || 20) * 1000;
            timers.push(setTimeout(() => setVisible(false), 3000 + dur));
            fetch(backend + '/api/ads/' + picked.id + '/impression', { method: 'POST' }).catch(()=>{});
            AdService.trackEvent(backend, { ad_id: picked.id, event_type: 'impression', placement: 'lband' });
          }
        });
    }).catch(() => {});
    return () => { cancelled = true; timers.forEach(clearTimeout); };
  }, [backend, closed, isPaidUser]);

  if (!ad || !visible) return null;

  const isVideo = /\.(mp4|webm)(\?|$)/i.test(ad.media_url || '');

  const handleClick = async () => {
    try { await fetch(backend + '/api/ads/' + ad.id + '/click', { method: 'POST' }); } catch {}
    AdService.trackEvent(backend, { ad_id: ad.id, event_type: 'click', placement: 'lband' });
    if (ad.click_url) window.open(ad.click_url, '_blank');
  };

  return (
    <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, zIndex: 15, padding: '0 0 8px 0', pointerEvents: 'none' }}>
      <div style={{ position: 'relative', margin: '0 8px', pointerEvents: 'all' }}>
        {/* Close button */}
        <button onClick={() => { setVisible(false); setClosed(true); }}
          style={{ position: 'absolute', top: -10, right: -6, width: 20, height: 20, borderRadius: '50%', background: 'rgba(0,0,0,0.8)', border: '1px solid rgba(255,255,255,0.3)', color: '#fff', fontSize: 10, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 16, lineHeight: 1 }}>
          ✕
        </button>
        {/* Ad content */}
        <div onClick={handleClick} style={{ background: 'rgba(0,0,0,0.85)', borderRadius: 6, overflow: 'hidden', cursor: ad.click_url ? 'pointer' : 'default', border: '1px solid rgba(255,215,0,0.2)', display: 'flex', alignItems: 'center', gap: 10, padding: '6px 10px' }}>
          {ad.media_url && (
            isVideo
              ? <video src={ad.media_url} muted autoPlay loop playsInline
                  onError={e => e.target.style.display='none'}
                  style={{ height: 40, maxWidth: 120, objectFit: 'contain', borderRadius: 4, flexShrink: 0 }} />
              : <img src={ad.media_url} alt={ad.title}
                  onError={e => e.target.style.display='none'}
                  style={{ height: 40, maxWidth: 120, objectFit: 'contain', borderRadius: 4, flexShrink: 0 }} />
          )}
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ color: '#FFD700', fontSize: 11, fontFamily: "'Bebas Neue',sans-serif", letterSpacing: 1 }}>{ad.title}</div>
            {ad.click_url && <div style={{ color: 'rgba(255,255,255,0.5)', fontSize: 10 }}>{ad.click_url.replace('https://','').substring(0,30)}</div>}
          </div>
          <div style={{ background: '#FFD700', color: '#000', fontSize: 10, padding: '3px 8px', borderRadius: 3, fontFamily: "'Bebas Neue',sans-serif", letterSpacing: 1, flexShrink: 0 }}>AD</div>
        </div>
      </div>
    </div>
  );
}

function VideoModal({ item, onClose, videoStats = {}, allVideos = [], onRelatedPlay, isPaidUser = false }) {
  // Lock body scroll when modal open
  React.useEffect(() => {
    const scrollY = window.scrollY;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
      window.scrollTo(0, scrollY);
    };
  }, []);
  const [showPreRoll, setShowPreRoll] = React.useState(true);
  React.useEffect(() => { setShowPreRoll(true); }, [item?.id]);
const [miniPlayer, setMiniPlayer] = React.useState(false);
const modalRef = React.useRef(null);
React.useEffect(() => { setMiniPlayer(false); }, [item?.id]);
// miniPlayer scroll disabled - conflicts with modal scroll
// React.useEffect(() => {
//   const el = modalRef.current;
//   if (!el) return;
//   const handleScroll = () => { setMiniPlayer(el.scrollTop > 200); };
//   el.addEventListener("scroll", handleScroll);
//   return () => el.removeEventListener("scroll", handleScroll);
// }, []);
  useEffect(() => {
    const h = e => e.key === "Escape" && onClose();
    window.addEventListener("keydown", h);
    return () => window.removeEventListener("keydown", h);
  }, [onClose]);

  const backend = process.env.REACT_APP_BACKEND_URL || "https://nethajiprime-backend.onrender.com";

  // ── OTT APP 19: Watch progress tracker ──
  const progressRef = React.useRef(0);
  const videoElemRef = React.useRef(null);

  // ── Autoplay-next (own uploads only; mirrors AppMain FullscreenPlayer) ──────
  const [autoplayOn, setAutoplayOn] = React.useState(() => { try { return localStorage.getItem('np_autoplay') !== '0'; } catch (e) { return true; } });
  const [upNext, setUpNext] = React.useState(null);
  const [upNextIsEpisode, setUpNextIsEpisode] = React.useState(false);
  const [nextEpisode, setNextEpisode] = React.useState(null);  // series next-ep from /series/next (null = standalone/last)
  const [episodes, setEpisodes] = React.useState([]);          // full series episode list (Netflix-style), [] = no series
  const [countdown, setCountdown] = React.useState(0);
  const countdownRef = React.useRef(null);
  const AUTOPLAY_SECONDS = 6;
  const clearCountdown = () => { if (countdownRef.current) { clearInterval(countdownRef.current); countdownRef.current = null; } };
  // Next same-category OWN UPLOAD the viewer can watch. YouTube can't report
  // end-of-video from a plain iframe, so autoplay stays within native uploads;
  // premium-locked items are skipped for non-paying users.
  const pickNext = () => {
    const cur = String(item.id || item.video_id || '');
    // NOTE: the /speeches map stamps type:'speech' on ALL rows, so classify by
    // content_type + a real (non-YouTube) video_url — only these play in <video> and can chain.
    const isNative = (v) => v.content_type !== 'youtube' && !!v.video_url && !/youtube\.com|youtu\.be/.test(v.video_url || '');
    const pool = (allVideos || []).filter(v => {
      const id = String(v.id || v.video_id || '');
      if (!id || id === cur) return false;
      if (!isNative(v)) return false;
      if (v.is_premium && !isPaidUser) return false;
      return true;
    });
    const sameCat = item.category ? pool.filter(v => v.category === item.category) : [];
    return sameCat[0] || pool[0] || null;
  };
  const shapeForPlay = (v) => ({ id: v.id || v.video_id, title: v.title, thumb: v.thumbnail_url || v.thumb, type: v.content_type || v.type || 'speech', video_url: v.video_url, bunny_video_id: v.bunny_video_id || '', category: v.category });
  const advanceTo = (next) => {
    clearCountdown();
    const nv = next || upNext;
    setUpNext(null); setUpNextIsEpisode(false); setCountdown(0);
    if (nv && onRelatedPlay) onRelatedPlay(shapeForPlay(nv));
  };
  const cancelUpNext = () => { clearCountdown(); setUpNext(null); setUpNextIsEpisode(false); setCountdown(0); };
  const startUpNext = () => {
    const episode = nextEpisode;
    const next = episode || pickNext();   // series next episode wins; same-category is the fallback
    if (!next) return;
    setUpNext(next); setUpNextIsEpisode(!!episode); setCountdown(AUTOPLAY_SECONDS); clearCountdown();
    countdownRef.current = setInterval(() => {
      if (document.hidden) return;  // pause countdown while tab is backgrounded
      setCountdown(c => { if (c <= 1) { clearCountdown(); advanceTo(next); return 0; } return c - 1; });
    }, 1000);
  };
  const toggleAutoplay = () => setAutoplayOn(on => { const nv = !on; try { localStorage.setItem('np_autoplay', nv ? '1' : '0'); } catch (e) {} if (!nv) cancelUpNext(); return nv; });
  React.useEffect(() => { setUpNext(null); setUpNextIsEpisode(false); setCountdown(0); return () => clearCountdown(); }, [item?.id]);

  // Series continuity: ask the backend for this video's next episode. Gated on a
  // truthy id and reset per item; a null/failed result leaves pickNext() (the
  // same-category fallback) in charge.
  React.useEffect(() => {
    setNextEpisode(null);
    if (!item?.id) return;
    let cancelled = false;
    (async () => {
      try {
        const url = `${backend}/series/next/${item.id}`;
        const r = await fetch(url);
        if (!r.ok) return;
        const d = await r.json();
        if (!cancelled) setNextEpisode(d.next || null);
      } catch (e) {}
    })();
    return () => { cancelled = true; };
  }, [item?.id]);

  // Full series episode list (Netflix-style). Uses item.series_id when present
  // (grid rows carry it). Fallback for trimmed items (search / continue-watching)
  // that lack series_id: discover it via /series/next/{id}. NOTE: that fallback
  // can't recover the series if this video is the LAST episode (next=null) — such
  // items simply show no episode list, which is an acceptable degrade.
  React.useEffect(() => {
    setEpisodes([]);
    if (!item?.id && !item?.series_id) return;
    let cancelled = false;
    (async () => {
      try {
        let sid = item.series_id;
        if (!sid && item.id) {
          const nr = await fetch(`${backend}/series/next/${item.id}`);
          if (nr.ok) { const nd = await nr.json(); sid = nd?.next?.series_id || null; }
        }
        if (!sid || cancelled) return;
        const r = await fetch(`${backend}/series/${sid}`);
        if (!r.ok) return;
        const d = await r.json();
        if (!cancelled) setEpisodes(Array.isArray(d.episodes) ? d.episodes : []);
      } catch (e) {}
    })();
    return () => { cancelled = true; };
  }, [item?.id, item?.series_id]);

  // Audio coordination: opening/switching a video stops the radio + bulletin,
  // and registers a stopper so starting the radio pauses this OTT video and
  // closes the modal (covers the YouTube/Bunny iframe too).
  // onClose is an inline arrow (new identity each render) so read it via a ref
  // and key the effect only on the video id — otherwise it would re-fire every render.
  const onCloseRef = React.useRef(onClose);
  onCloseRef.current = onClose;
  React.useEffect(() => {
    npAudio.register('video', () => {
      if (videoElemRef.current) { try { videoElemRef.current.pause(); } catch (e) {} }
      onCloseRef.current();
    });
    npAudio.stopOthers('video');
    return () => npAudio.unregister('video');
  }, [item?.id]);

  React.useEffect(() => {
    if (!item) return;
    progressRef.current = 0;
    const token = localStorage.getItem('token'); let userId = 'anonymous'; try { if(token) userId = JSON.parse(atob(token.split('.')[1])).sub || 'anonymous'; } catch(e) {} const npUid = localStorage.getItem('np_user_id'); if(npUid) userId = npUid;
    const saveProgress = () => {
      const pct = progressRef.current;
      if (pct < 2) return; // don't save if barely started
      fetch(backend + '/api/watch-progress', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          user_id: userId,
          video_id: item.id || item.video_id || '',
          progress: pct,
          title: item.title || '',
          thumb: item.thumb || item.thumbnail || '',
          type: item.type || 'youtube',
          bunny_video_id: item.bunny_video_id || '',
          video_url: item.video_url || ''
        })
      }).catch(() => {});
    };
    // Count one view per opened video. The effect is keyed on item.id, so
    // this fires once per play rather than on every render. Native/OTT items
    // only - YouTube counts come from the YouTube API, not from us.
    const isNativeItem = item.type === 'speech' || (item.content_type && item.content_type !== 'youtube');
    const viewId = item.id || item.video_id || '';
    if (isNativeItem && viewId) {
      fetch(backend + '/speeches/' + viewId + '/view', {
        method: 'POST',
        headers: Object.assign({ 'Content-Type': 'application/json' },
          token ? { Authorization: 'Bearer ' + token } : {}),
        body: JSON.stringify({ viewer_id: userId }),
      }).catch(() => {});
    }
    // For <video> elements: track via timeupdate
    const trackVideo = () => {
      const v = videoElemRef.current;
      if (v && v.duration) {
        progressRef.current = Math.round((v.currentTime / v.duration) * 100);
      }
    };
    // Interval: save every 15 seconds
    const interval = setInterval(() => {
      trackVideo();
      saveProgress();
      // Increment for YouTube iframes (estimate based on time elapsed)
      progressRef.current = Math.min(99, progressRef.current + 5);
    }, 10000);
    // Save on unmount
    return () => {
      clearInterval(interval);
      trackVideo();
      saveProgress();
    };
  }, [item?.id]);

  if (!item) return null;
  // A YouTube video is either an RSS/feed item (type "youtube", id = videoId) or
  // an imported DB row (content_type "youtube", videoId inside video_url).
  const ytIdFromUrl = (u) => { const m = (u || "").match(/(?:v=|youtu\.be\/|embed\/|shorts\/)([A-Za-z0-9_-]{11})/); return m ? m[1] : ""; };
  const ytVideoId = item.type === "youtube" ? item.id
    : item.content_type === "youtube" ? ytIdFromUrl(item.video_url)
    : "";
  const isYT = !!ytVideoId;
  const isSpeech = item.type === "speech" && !isYT;
  const src = isYT
    ? `https://www.youtube.com/embed/${ytVideoId}?autoplay=1&rel=0`
    : item.bunny_video_id
      ? `${BUNNY_EMBED}/${item.bunny_video_id}?autoplay=1`
      : null;

  return (
    <div style={S.modalBg} onClick={onClose}>
      <div ref={modalRef} style={{...S.modal, ...(miniPlayer ? {paddingTop:0} : {})}} className="np-modal" onClick={e => e.stopPropagation()}>
        <button style={S.modalClose} onClick={onClose}>✕</button>
        <div style={{ ...S.modalVideo, position: miniPlayer ? 'fixed' : 'relative', bottom: miniPlayer ? 70 : 'auto', right: miniPlayer ? 10 : 'auto', width: miniPlayer ? 200 : '100%', height: miniPlayer ? 112 : S.modalVideo?.height, zIndex: miniPlayer ? 9998 : 'auto', borderRadius: miniPlayer ? 8 : 0, boxShadow: miniPlayer ? '0 4px 20px rgba(0,0,0,0.8)' : 'none', transition: 'all 0.3s ease', ...(item.is_reel && !miniPlayer ? { aspectRatio: '9/16', maxWidth: 400, height: 'auto', margin: '0 auto' } : {}) }}>
          {showPreRoll && <PreRollAd backend={backend} onComplete={() => setShowPreRoll(false)} isPaidUser={isPaidUser} />}
          {!showPreRoll && <LBandAd backend={backend} isPaidUser={isPaidUser} />}
          {isSpeech && (item.video_url || (!item.bunny_video_id && !src))
            ? <video ref={videoElemRef} onPlay={() => npAudio.stopOthers('video')} onTimeUpdate={() => { if(videoElemRef.current && videoElemRef.current.duration) progressRef.current = Math.round((videoElemRef.current.currentTime/videoElemRef.current.duration)*100); }} onEnded={() => { if (autoplayOn) startUpNext(); }} src={item.video_url} controls autoPlay playsInline webkit-playsinline="true" x5-playsinline="true" x5-video-player-type="h5" style={{ width:"100%", height:"100%", objectFit: item.is_reel ? "cover" : "contain" }} />
            : <iframe src={src} style={{ width:"100%", height:"100%", border:"none" }} allowFullScreen allow="autoplay; fullscreen; encrypted-media; picture-in-picture" title={item.title} />
          }
          {upNext && (
            <div style={{ position:'absolute', bottom:12, right:12, width:280, maxWidth:'80%', background:'rgba(0,0,0,0.92)', border:'1px solid rgba(255,215,0,0.4)', borderRadius:8, padding:10, zIndex:20, display:'flex', gap:10, alignItems:'center' }}>
              <div onClick={() => advanceTo(upNext)} style={{ position:'relative', flexShrink:0, width:96, height:54, borderRadius:6, overflow:'hidden', background:'#000', cursor:'pointer' }}>
                {(upNext.thumbnail_url||upNext.thumb) && <img src={upNext.thumbnail_url||upNext.thumb} alt="" style={{ width:'100%', height:'100%', objectFit:'cover' }} />}
              </div>
              <div style={{ flex:1, minWidth:0 }}>
                <div style={{ color:'#FFD700', fontSize:10, fontWeight:800, letterSpacing:1, marginBottom:3 }}>{upNextIsEpisode ? 'NEXT EPISODE' : 'PLAYING NEXT'} IN {countdown}s</div>
                <div style={{ color:'#fff', fontSize:12, fontWeight:600, lineHeight:1.3, overflow:'hidden', display:'-webkit-box', WebkitLineClamp:2, WebkitBoxOrient:'vertical' }}>{upNext.title}</div>
                <div style={{ display:'flex', gap:8, marginTop:6 }}>
                  <button onClick={() => advanceTo(upNext)} style={{ background:'#FFD700', color:'#1a0505', border:'none', borderRadius:4, padding:'4px 10px', fontSize:11, fontWeight:700, cursor:'pointer' }}>Play now</button>
                  <button onClick={cancelUpNext} style={{ background:'transparent', color:'#ccc', border:'1px solid rgba(255,255,255,0.3)', borderRadius:4, padding:'4px 10px', fontSize:11, cursor:'pointer' }}>Cancel</button>
                </div>
              </div>
            </div>
          )}
        </div>
        <div style={S.modalInfo} className="np-modal-info">
          <div style={S.modalTitle} className="np-modal-title">{item.title}</div>
          <div onClick={toggleAutoplay} title="Autoplay the next video when this one ends" style={{ display:'inline-flex', alignItems:'center', gap:8, cursor:'pointer', margin:'6px 0', userSelect:'none' }}>
            <span style={{ color:'rgba(255,255,255,0.8)', fontSize:12, fontWeight:600 }}>Autoplay next</span>
            <div style={{ width:36, height:20, borderRadius:10, background: autoplayOn ? '#FFD700' : 'rgba(255,255,255,0.25)', position:'relative', transition:'background 0.2s' }}>
              <div style={{ position:'absolute', top:2, left: autoplayOn ? 18 : 2, width:16, height:16, borderRadius:'50%', background:'#fff', transition:'left 0.2s' }} />
            </div>
          </div>
          {item._playlist && item._epIndex != null && item._epIndex < item._playlist.length - 1 && onRelatedPlay && (
            <button onClick={() => { const ni = item._epIndex + 1; onRelatedPlay({ ...item._playlist[ni], _playlist: item._playlist, _epIndex: ni }); }}
              style={{ margin: "8px 0", background: "linear-gradient(135deg,#FFD700,#d4a843)", color: "#1a0505", border: "none", borderRadius: 8, padding: "9px 16px", fontWeight: 900, fontSize: 13, cursor: "pointer", letterSpacing: 1 }}>
              Next Episode ▶
            </button>
          )}
          <div style={{ margin: "6px 0 10px" }}>
            <DonateButton />
          </div>
          <div style={{ display:"flex", gap:10, alignItems:"center", flexWrap:"wrap", marginBottom:8 }}>
            <div style={S.modalMeta}>{(item.category || item.channelLabel || "NETHAJI PRIME").toUpperCase()}</div>
            {item.type === "youtube" && videoStats[item.id] && (
              <>
                <span style={S.statBadge}>👁 {formatNum(videoStats[item.id].views)}</span>
                <span style={S.statBadge}>👍 {formatNum(videoStats[item.id].likes)}</span>
                <span style={S.statBadge}>💬 {formatNum(videoStats[item.id].comments)}</span>
              </>
            )}
            {item.views_count > 0 && (
              <>
                <span style={S.statBadge}>👁 {formatNum(item.views_count)}</span>
                {item.like_count > 0 && <span style={S.statBadge}>👍 {formatNum(item.like_count)}</span>}
              </>
            )}
          </div>
          {item.description && <div style={S.modalDesc}>{item.description}</div>}
          <YouTubeActions item={item} />
          <NPLikeButton item={item} backend={backend} />
          <ShareButtons item={item} />
          {/* Nethaji TV Description */}
          <div style={{marginTop:'12px',padding:'12px 14px',background:'rgba(255,255,255,0.03)',borderRadius:'8px',border:'1px solid rgba(212,168,67,0.15)',fontSize:'12px',color:'rgba(255,255,255,0.65)',lineHeight:1.7}}>
            <div style={{color:'#d4a843',fontWeight:900,fontSize:'13px',marginBottom:'6px'}}>📺 Nethaji TV</div>
            <div style={{marginBottom:'6px'}}>💰 Donate: Google Pay <strong style={{color:'#fff'}}>91-94444 56788</strong></div>
            <div style={{marginBottom:'6px',fontFamily:"'Noto Sans Tamil',sans-serif",fontSize:'11px'}}>அரசியல், சமூக பிரச்சனை, அறிவியல், கலாச்சாரம், விளையாட்டு, சினிமா மற்றும் பொழுதுபோக்கு அம்சங்களை வழங்கும் ஊடகம்.</div>
            <div style={{marginBottom:'8px',fontSize:'11px'}}>A Sociopolitical Tamil media channel focusing on Politics, Social issues, Science, Culture, Sports, Cinema and Entertainment.</div>
            <div style={{marginBottom:'2px',fontSize:'11px'}}>📱 <a href="https://wa.me/919342330234" target="_blank" rel="noreferrer" style={{color:'#25D366'}}>WhatsApp: 91 93423 30234</a></div>
            <div style={{marginBottom:'8px',fontSize:'11px'}}>📞 <a href="tel:+916382811018" style={{color:'#d4a843'}}>+91 6382811018</a></div>
            <div style={{display:'flex',flexWrap:'wrap',gap:'6px',fontSize:'11px'}}>
              <a href="https://www.nethajiprime.com/" target="_blank" rel="noreferrer" style={{color:'#d4a843',textDecoration:'none'}}>🎬 Nethaji Prime OTT</a>
              <a href="https://www.rvlawassociates.com/" target="_blank" rel="noreferrer" style={{color:'#d4a843',textDecoration:'none'}}>⚖️ Legal Help</a>
              <a href="https://facebook.com/R.Varadharajan.NMK" target="_blank" rel="noreferrer" style={{color:'#1877F2',textDecoration:'none'}}>📘 Facebook</a>
              <a href="https://instagram.com/nethaji_makkal_katchi" target="_blank" rel="noreferrer" style={{color:'#E1306C',textDecoration:'none'}}>📸 Instagram</a>
              <a href="https://twitter.com/nmkparty" target="_blank" rel="noreferrer" style={{color:'#1DA1F2',textDecoration:'none'}}>🐦 Twitter</a>
              <a href="https://t.me/nethaji_tv" target="_blank" rel="noreferrer" style={{color:'#2AABEE',textDecoration:'none'}}>💬 Telegram</a>
              <a href="https://nmkindia.com" target="_blank" rel="noreferrer" style={{color:'#d4a843',textDecoration:'none'}}>🌐 NMK Website</a>
            </div>
          </div>
          <VideoComments item={item} backend={backend} />

          {/* Episodes (series) — shown above MORE LIKE THIS when this video is
              part of a series with 2+ episodes. Current episode is highlighted
              and not clickable; others switch via onRelatedPlay. */}
          {episodes.length >= 2 && (
            <div style={{ marginTop:16, padding:'0 0 8px' }}>
              <div style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:14, letterSpacing:2, color:'rgba(255,215,0,0.7)', marginBottom:10, paddingLeft:2 }}>
                EPISODES
              </div>
              <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
                {episodes.map(ep => {
                  const isCurrent = String(ep.id) === String(item.id);
                  const badge = `S${ep.season_number||1}E${ep.episode_number||''}`;
                  const dur = (ep.duration>0) ? `${Math.floor(ep.duration/60)}:${String(ep.duration%60).padStart(2,'0')}` : '';
                  return (
                    <div key={ep.id}
                      onClick={isCurrent ? undefined : () => onRelatedPlay && onRelatedPlay({ id:ep.id, title:ep.title, thumb:ep.thumbnail_url, thumbnail_url:ep.thumbnail_url, type:(ep.content_type==='youtube'?'youtube':'speech'), content_type:ep.content_type, video_url:ep.video_url, bunny_video_id:ep.bunny_video_id||'', category:ep.category, duration:ep.duration, is_premium:ep.is_premium, series_id:ep.series_id, season_number:ep.season_number, episode_number:ep.episode_number })}
                      style={{ display:'flex', gap:10, background: isCurrent?'rgba(255,215,0,0.12)':'rgba(255,255,255,0.04)', borderRadius:8, padding:8, cursor: isCurrent?'default':'pointer', border: isCurrent?'1px solid rgba(255,215,0,0.5)':'1px solid rgba(255,215,0,0.08)', transition:'background 0.2s' }}
                      onMouseEnter={isCurrent?undefined:(e=>e.currentTarget.style.background='rgba(255,215,0,0.08)')}
                      onMouseLeave={isCurrent?undefined:(e=>e.currentTarget.style.background='rgba(255,255,255,0.04)')}>
                      <div style={{ position:'relative', flexShrink:0, width:100, aspectRatio:'16/9', borderRadius:5, overflow:'hidden', background:'#1a0010' }}>
                        {ep.thumbnail_url && <img src={ep.thumbnail_url} alt={ep.title} style={{ width:'100%', height:'100%', objectFit:'cover', display:'block' }} />}
                        <div style={{ position:'absolute', top:3, left:3, background:'rgba(0,0,0,0.8)', color:'#FFD700', fontFamily:"'Bebas Neue',sans-serif", fontSize:10, letterSpacing:1, padding:'1px 5px', borderRadius:3 }}>{badge}</div>
                      </div>
                      <div style={{ flex:1, minWidth:0 }}>
                        <div style={{ fontFamily:"'Rajdhani',sans-serif", fontSize:13, fontWeight:700, color: isCurrent?'#FFD700':'#fff', lineHeight:1.3, overflow:'hidden', display:'-webkit-box', WebkitLineClamp:2, WebkitBoxOrient:'vertical' }}>{ep.title}</div>
                        <div style={{ display:'flex', gap:8, alignItems:'center', marginTop:3 }}>
                          {isCurrent && <span style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:10, color:'#FFD700', letterSpacing:1 }}>▶ NOW PLAYING</span>}
                          {dur && <span style={{ fontFamily:"'Rajdhani',sans-serif", fontSize:11, color:'rgba(255,255,255,0.5)' }}>{dur}</span>}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          {/* Related Videos */}
          {sortNewest(allVideos.filter(v => v.id !== item.id && item.category && v.category === item.category)).slice(0,4).length > 0 && (
            <div style={{ marginTop:16, padding:'0 0 8px' }}>
              <div style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:14, letterSpacing:2, color:'rgba(255,215,0,0.7)', marginBottom:10, paddingLeft:2 }}>
                MORE LIKE THIS
              </div>
              <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
                {sortNewest(allVideos.filter(v => v.id !== item.id && item.category && v.category === item.category)).slice(0,4).map(v => (
                  <div key={v.id} onClick={() => onRelatedPlay && onRelatedPlay({ id:v.id, title:v.title, thumb:v.thumbnail_url||v.thumb, type:v.content_type||v.type||'speech', video_url:v.video_url, bunny_video_id:v.bunny_video_id||'', category:v.category })}
                    style={{ display:'flex', gap:10, background:'rgba(255,255,255,0.04)', borderRadius:8, padding:8, cursor:'pointer', border:'1px solid rgba(255,215,0,0.08)', transition:'background 0.2s' }}
                    onMouseEnter={e=>e.currentTarget.style.background='rgba(255,215,0,0.08)'}
                    onMouseLeave={e=>e.currentTarget.style.background='rgba(255,255,255,0.04)'}>
                    <div style={{ flexShrink:0, width:100, aspectRatio:'16/9', borderRadius:5, overflow:'hidden', background:'#1a0010' }}>
                      {(v.thumbnail_url||v.thumb) && <img src={v.thumbnail_url||v.thumb} alt={v.title} style={{ width:'100%', height:'100%', objectFit:'cover', display:'block' }} />}
                    </div>
                    <div style={{ flex:1, minWidth:0 }}>
                      <div style={{ fontFamily:"'Rajdhani',sans-serif", fontSize:13, fontWeight:700, color:'#fff', lineHeight:1.3, overflow:'hidden', display:'-webkit-box', WebkitLineClamp:2, WebkitBoxOrient:'vertical' }}>{v.title}</div>
                      <div style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:10, color:'#FFD700', marginTop:3, letterSpacing:1 }}>{(v.category||'').toUpperCase()}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

// ── MAIN PAGE ────────────────────────────────────────────────────────────────
function PlaylistBrowser({ backend, onPlay }) {
  const [playlists, setPlaylists] = useState([]);
  const [active, setActive] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let alive = true;
    fetch(`${backend}/api/playlists`).then(r => r.json())
      .then(d => { if (alive) { setPlaylists(d.playlists || []); setLoading(false); } })
      .catch(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, [backend]);
  const openPlaylist = (id) => {
    fetch(`${backend}/api/playlists/${id}`).then(r => r.json())
      .then(d => setActive(d && d.playlist ? d : null)).catch(() => {});
  };
  const mapEp = (ep) => ({
    id: ep.video_id, type: ep.video_type === 'youtube' ? 'youtube' : 'speech',
    content_type: ep.video_type, video_url: ep.video_url,
    title: ep.title, thumbnail_url: ep.thumbnail_url, thumb: ep.thumbnail_url,
    category: 'NethajiPrime Playlist',
  });
  const playEpisode = (episodes, idx) => {
    const mapped = episodes.map(mapEp);
    onPlay({ ...mapped[idx], _playlist: mapped, _epIndex: idx });
  };
  if (loading) return <div style={{ padding: 40, textAlign: 'center', color: 'rgba(212,168,67,0.5)', fontFamily: "'Barlow Condensed',sans-serif", letterSpacing: 2 }}>LOADING PLAYLISTS...</div>;
  if (active && active.playlist) {
    const eps = active.episodes || [];
    return (
      <div>
        <button onClick={() => setActive(null)} style={{ background: 'rgba(255,215,0,0.12)', border: '1px solid rgba(255,215,0,0.4)', color: '#FFD700', borderRadius: 6, padding: '6px 14px', fontSize: 12, fontWeight: 800, cursor: 'pointer', marginBottom: 14 }}>← ALL PLAYLISTS</button>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16 }}>
          {active.playlist.hero_image_url ? <img src={active.playlist.hero_image_url} alt="" style={{ width: 120, height: 68, objectFit: 'cover', borderRadius: 8 }} /> : <span style={{ fontSize: 40 }}>{active.playlist.emoji || '📚'}</span>}
          <div>
            <div style={{ color: '#fff', fontSize: 20, fontWeight: 800, fontFamily: "'Bebas Neue',sans-serif", letterSpacing: 1 }}>{active.playlist.emoji} {active.playlist.name}</div>
            <div style={{ color: 'rgba(255,255,255,0.5)', fontSize: 12 }}>{eps.length} episodes</div>
          </div>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          {eps.map((ep, i) => (
            <div key={ep.id} onClick={() => playEpisode(eps, i)}
              style={{ display: 'flex', alignItems: 'center', gap: 12, background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,215,0,0.1)', borderRadius: 8, padding: 8, cursor: 'pointer' }}
              onMouseEnter={e => e.currentTarget.style.background = 'rgba(255,215,0,0.08)'}
              onMouseLeave={e => e.currentTarget.style.background = 'rgba(255,255,255,0.04)'}>
              <span style={{ color: '#FFD700', fontWeight: 900, fontSize: 15, width: 34, textAlign: 'center', flexShrink: 0 }}>{ep.episode_number}</span>
              <div style={{ position: 'relative', width: 120, height: 68, flexShrink: 0, borderRadius: 6, overflow: 'hidden', background: '#140202' }}>
                {ep.thumbnail_url ? <img src={ep.thumbnail_url} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : null}
                <span style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontSize: 22, textShadow: '0 1px 4px #000' }}>▶</span>
              </div>
              <span style={{ color: '#f0e0c0', fontSize: 13, fontWeight: 600, lineHeight: 1.4 }}>{ep.title}</span>
            </div>
          ))}
        </div>
      </div>
    );
  }
  if (playlists.length === 0) return <div style={{ padding: 40, textAlign: 'center', color: 'rgba(255,255,255,0.4)' }}>No playlists yet.</div>;
  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(var(--np-cols, 4), 1fr)', gap: 'var(--card-gap, 12px)' }}>
      {playlists.map(p => (
        <div key={p.id} onClick={() => openPlaylist(p.id)}
          style={{ background: 'linear-gradient(160deg,#1e0404,#140202)', border: '1px solid rgba(212,168,67,0.15)', borderRadius: 10, overflow: 'hidden', cursor: 'pointer' }}
          onMouseEnter={e => e.currentTarget.style.borderColor = 'rgba(212,168,67,0.5)'}
          onMouseLeave={e => e.currentTarget.style.borderColor = 'rgba(212,168,67,0.15)'}>
          <div style={{ position: 'relative', width: '100%', aspectRatio: '16/9', background: '#0a0000', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            {p.hero_image_url ? <img src={p.hero_image_url} alt={p.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : <span style={{ fontSize: 46 }}>{p.emoji || '📚'}</span>}
            <span style={{ position: 'absolute', bottom: 6, right: 6, background: 'rgba(0,0,0,0.75)', color: '#FFD700', fontSize: 10, fontWeight: 800, padding: '2px 7px', borderRadius: 10 }}>{p.episode_count} EP</span>
          </div>
          <div style={{ padding: '8px 10px', color: '#fff', fontSize: 13, fontWeight: 700 }}>{p.emoji} {p.name}</div>
        </div>
      ))}
    </div>
  );
}

export default function WatchNowPage({ onBack, user: propUser, t, onGoogleLogin, onUpgrade, onLogoutMain, isPaidMode, onAdminDashboard, onDeals, onLegal }) {
  // Paid plans, free trials and admins go ad-free; plain free users do not.
  // Shape is {has_access, plan} from the backend's check_user_subscription.
  const isAdFreeUser = !!(propUser && propUser.subscription
    && propUser.subscription.has_access && propUser.subscription.plan !== 'free');
  const [navActive, setNavActive] = useState("HOME");
  const [chip, setChip] = useState("ALL");
  const [shorts, setShorts] = useState([]);
  const [rssShorts, setRssShorts] = useState([]);
  const [speeches, setSpeeches] = useState([]);
  const [rssData, setRssData] = useState({});
  const [loading, setLoading] = useState(true);
  const [activeVideo, setActiveVideo] = useState(null);
  const [showSearch, setShowSearch] = useState(false);
  const [showBulletin, setShowBulletin] = useState(false);
  const [showDeals, setShowDeals] = useState(false);
  const [showRadio, setShowRadio] = useState(false);
  const [showAdvertise, setShowAdvertise] = useState(() => window.location.hash === '#advertise');
  const [currentRadio, setCurrentRadio] = useState(null);
  const [showWatchlist, setShowWatchlist] = useState(false);
  const [showLikedVideos, setShowLikedVideos] = useState(false);
  const [showWatchHistory, setShowWatchHistory] = useState(false);
  const [showSettings, setShowSettings] = useState(false);
  const [googleUser, setGoogleUser] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("np_google_user"));
    } catch { return null; }
  });
  const [trendingIds, setTrendingIds] = useState([]);
  const [userId] = useState(() => localStorage.getItem("np_user_id") || "guest_" + Math.random().toString(36).slice(2));
  const [videoStats, setVideoStats] = useState({});

  // Engagement signals for the push-permission prompt: visit count bumps
  // once per page load, np_engaged is set the first time a video plays.
  React.useEffect(() => {
    try {
      const n = parseInt(localStorage.getItem('np_visit_count') || '0') + 1;
      localStorage.setItem('np_visit_count', String(n));
    } catch {}
  }, []);

  const handlePlay = (item) => {
    try { localStorage.setItem('np_engaged', '1'); } catch {}
    if (item.type === 'facebook') {
      window.open(item.fb_url, '_blank', 'noopener,noreferrer');
      return;
    }
    setActiveVideo(item);
    if (item.category) {
      fetch(`${BACKEND}/api/track-view`, {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ user_id: userId, category: item.category, video_id: item.id })
      }).catch(() => {});
    }
  };

  useEffect(() => {
    async function load() {
      try {
        const { data } = await supabase.from("shorts").select("*").eq("status", "published").order("created_at", { ascending: false });
        const mappedShorts = (data || []).map(s => ({ ...s, type: "speech" }));
        setShorts(mappedShorts);
      } catch(e) { console.error(e); }

      try {
        // RSS shorts: short (<4min) YouTube videos from the channels, filtered
        // server-side by /api/rss-shorts. Mapped to type:"youtube" + the video
        // id so VideoModal plays them via the embed, same as the app does.
        const res = await fetch(`${BACKEND}/api/rss-shorts`);
        const rj = await res.json();
        setRssShorts((rj.shorts || []).map(v => ({
          id: v.id,
          title: v.title,
          thumb: v.thumbnail_url || v.thumb || (v.id ? `https://i.ytimg.com/vi/${v.id}/mqdefault.jpg` : ''),
          thumbnail_url: v.thumbnail_url || v.thumb || (v.id ? `https://i.ytimg.com/vi/${v.id}/mqdefault.jpg` : ''),
          url: v.url || (v.id ? `https://www.youtube.com/watch?v=${v.id}` : ''),
          type: "youtube",
          category: "Shorts",
          channelLabel: v.channelLabel,
          views_count: v.views_count || 0,
          like_count: v.like_count || 0,
          comment_count: v.comment_count || 0,
        })));
      } catch(e) { console.error('rss-shorts', e); }

      try {
        const res = await fetch(`${BACKEND}/speeches`);
        const json = await res.json();
        const mapped = (json.speeches || []).map(s => ({ ...s, type: "speech" }));
        setSpeeches(mapped);
      } catch(e) { console.error(e); }

      try {
        const res = await fetch(`${BACKEND}/api/rss-cache`);
        const cached = await res.json();
        const results = {};
        RSS_CHANNELS.forEach(ch => {
          const cachedCh = cached[ch.channelId];
          if (cachedCh?.videos?.length) {
            // Normalize both formats: {id,thumb} and {videoId,thumbnail}
            const normalized = cachedCh.videos.map(v => ({
              id:    v.id || v.videoId,
              title: v.title,
              thumb: v.thumb || v.thumbnail,
              url:   v.url || (v.videoId ? `https://www.youtube.com/watch?v=${v.videoId}` : ''),
              type:  "youtube",
              published_at: v.published || null,
              channelLabel: ch.label,
              channelColor: ch.color,
            }));
            results[ch.id] = normalized;
          } else {
            results[ch.id] = [];
          }
        });
        setRssData(results);
      } catch(e) { console.error("RSS cache error:", e); }

      setLoading(false);

      // Task 5: Check for deep link video and auto-open it
      try {
        const deepVideoId = localStorage.getItem('np_deeplink_video');
        if (deepVideoId) {
          localStorage.removeItem('np_deeplink_video');
          // Wait for state to settle then find and open the video
          setTimeout(() => {
            setShorts(prev => {
              const found = prev.find(v => v.id === deepVideoId);
              if (found) { setActiveVideo(found); }
              return prev;
            });
            setSpeeches(prev => {
              const found = prev.find(v => v.id === deepVideoId);
              if (found) { setActiveVideo(found); }
              return prev;
            });
          }, 500);
        }
      } catch(e) {}

      try {
        const tr = await fetch(`${BACKEND}/api/trending`);
        const trData = await tr.json();
        setTrendingIds((trData.trending || []).map(v => v.video_id));
      } catch(e) {}
    }
    load();
  }, []);

  useEffect(() => {
    const allIds = Object.values(rssData).flat().filter(v => v && v.id).map(v => v.id).slice(0, 80).join(",");
    if (!allIds) return;
    fetch(`${BACKEND}/api/youtube-stats?video_ids=${allIds}`)
      .then(r => r.json())
      .then(data => {
        const stats = data.stats || data;
        setVideoStats(stats);
        console.log("Stats loaded:", Object.keys(stats).length, "videos");
      })
      .catch(e => console.error("Stats error:", e));
  }, [rssData]);

  const { watchlist, addToWatchlist, removeFromWatchlist, isInWatchlist } = useWatchlist(userId, BACKEND);

  const byCategory = useCallback((cat) => sortNewest([
    ...shorts.filter(s => s.category === cat),
    // Category rows are native-only; imports live under the ALL VIDEOS chip.
    ...speeches.filter(s => s.category === cat && s.content_type !== "youtube"),
  ]), [shorts, speeches]);

  // Native shorts first, then short RSS videos (deduped by video id, native wins).
  const nativeShortClips = shorts.filter(s => s.category === "Shorts" || !s.category);
  const _shortNativeIds = new Set(nativeShortClips.map(s => String(s.id)));
  const shortClips = [...nativeShortClips, ...rssShorts.filter(r => !_shortNativeIds.has(String(r.id)))];
  const originals = sortNewest([...shorts.filter(s => s.category && s.category !== "Shorts"), ...speeches.filter(s => s.content_type !== "youtube")]);
  // LIVE shows the raw RSS feed. Do NOT dedup against DB imports: the daily
  // importer covers every video in the ~15-item RSS window, so filtering out
  // imported IDs empties LIVE entirely. Imports surface only under the
  // ALL VIDEOS chip, so LIVE/ALL VIDEOS overlap is fine — different chips.
  const allRSS = Object.values(rssData).flat().filter(v => v?.id);
  const allVideos = [...originals, ...allRSS];
  // Hero: always the genuine newest video by date across native OTT + YouTube-RSS
  // (pure newest, no featured pin). sortNewest also gives the 'nothing today ->
  // most recent previous' fallback, since it just ranks everything by date.
  const heroItems = sortNewest(allVideos).slice(0, 8);

  const handleNav = (nav) => {
    setNavActive(nav);
    if (nav === "HOME") setChip("ALL");
    if (nav === "LIVE") setChip("🔴 LIVE");
    if (nav === "PODCASTS") setChip("PODCASTS");
    if (nav === "DEALS") { if (typeof onDeals === "function") onDeals(); }
    if (nav === "LEGAL") { if (typeof onLegal === "function") onLegal(); }
    if (nav === "SUBSCRIPTIONS") setChip("SUBSCRIPTIONS");
  if (nav === "BULLETIN") setShowBulletin(true);
  if (nav === "RADIO") setShowRadio(true);
    window.scrollTo({ top: 400, behavior: "smooth" });
  };

  // Chips carry an emoji prefix (e.g. "⭐ ASTROLOGY"); strip it so comparisons
  // against bare names ("ASTROLOGY", "STOCK MARKET") match.
  const chipKey = chip.replace(/^[^A-Za-z0-9]+/, "").trim();

  const getFiltered = () => {
    if (chipKey === "ALL") return null;
    if (chipKey === "NethajiPrime Playlist") return [];
    if (chipKey === "LIVE" || chipKey === "SUBSCRIPTIONS") return allRSS;
    // Imported YouTube back-catalogue: filter on content_type (robust even if
    // a row's category string drifts), newest publish date first.
    if (chipKey === "ALL VIDEOS") return speeches
      .filter(v => v.content_type === "youtube")
      .slice().sort((a, b) => new Date(b.created_at || 0) - new Date(a.created_at || 0));
    if (chipKey === "INTERVIEWS") return sortNewest(speeches.filter(v => v.content_type !== "youtube" && (v.category === "Interviews" || v.content_type === "interview")));
    if (chipKey === "PODCASTS") return speeches.filter(v => v.category === "Interviews" || v.content_type === "interview" || v.category === "Podcast").concat(speeches.filter(v => v.category !== "Interviews" && v.content_type !== "interview" && v.category !== "Podcast")).slice(0, 20);
    if (chipKey === "NP ORIGINALS") return originals;
    if (chipKey === "SHORTS") { const nat = [...byCategory("Shorts"), ...shorts.filter(sh => sh.thumbnail_url)]; const ids = new Set(nat.map(s => String(s.id))); return [...nat, ...rssShorts.filter(r => !ids.has(String(r.id)))]; }
    if (chipKey === "DEVOTIONAL") return byCategory("Devotional");
    if (chipKey === "ASTROLOGY") return byCategory("Astrology");
    if (chipKey === "NethajIQ") return [];
    if (chipKey === "STOCK MARKET") return byCategory("Stock Market");
    if (chipKey === "KIDS") return byCategory("Kids");
    if (chipKey === "HEALTH") return byCategory("Health");
    if (chipKey === "KITCHEN") return byCategory("Kitchen");
    // A reel is marked explicitly at upload time via the is_reel column (admin
    // "REEL (9:16)" toggle), not inferred from duration - the old duration<=180
    // heuristic swallowed every short video from every category.
    if (chipKey === "REELS") return sortNewest(speeches.filter(v => v.is_reel === true));
    return [];
  };

  const filtered = getFiltered();
  // SEE ALL on a category row -> select that category chip (getFiltered then
  // renders the full grid) and jump to the top so the grid is in view. The chip
  // is looked up from CHIPS by name so the chip bar highlights the active one.
  const handleSeeAll = (name) => {
    const key = String(name || "").toUpperCase();
    const match = CHIPS.find(c => c.replace(/^[^A-Za-z0-9]+/, "").trim().toUpperCase() === key);
    setChip(match || name);
    if (typeof window !== "undefined") window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div style={S.page}>
      {/* NAV */}
      <div style={S.nav} className="np-nav">
        <div style={S.logoWrap}>
          <span style={S.logoN} className="np-logo-n">NETHAJI</span>
          <span style={S.logoP} className="np-logo-p">PRIME</span>
          <span style={S.logoOtt}>OTT</span>
        </div>
        <div style={S.navMid} className="np-nav-mid">
          {[
            { key: "HOME", label: "HOME" },
            { key: "LEGAL", label: "⚖️ LEGAL" },
            { key: "DEALS", label: "🔥 DEALS" },
            { key: "LIVE", label: "🔴 LIVE" },
            { key: "BULLETIN", label: "📺 Bulletin" },
            { key: "RADIO", label: "📻 Radio" },
          ].map(({ key, label }) => (
            <span key={key} onClick={() => { if(key==="RADIO"){ setShowRadio(true); setShowBulletin(false); return; } handleNav(key); if(key==="BULLETIN") setShowBulletin(true); }} style={
              key === "DEALS"
                ? { ...S.nl, position: 'relative', color: '#FFD700', fontWeight: 800,
                    background: navActive === key ? 'rgba(255,215,0,0.15)' : 'rgba(255,100,0,0.1)',
                    border: '1px solid rgba(255,150,0,0.4)', borderRadius: 6, padding: '4px 10px' }
                : navActive === key ? S.nlActive : S.nl
            }>
              {label}
              {key === "DEALS" && <span style={{ position: 'absolute', top: -6, right: -6, background: 'linear-gradient(135deg,#ff4500,#ff0000)', color: '#fff', fontSize: 8, fontWeight: 900, padding: '1px 4px', borderRadius: 6, letterSpacing: 0.5 }}>HOT</span>}
            </span>
          ))}
        </div>
        <div style={S.navRight} className="np-nav-right">
          <DonateButton user={propUser || googleUser} />
          <button style={S.searchBtn} className="np-search-btn" onClick={() => setShowSearch(true)}>🔍</button>
          {/* MY LIST in avatar dropdown */}
          {/* SUBSCRIBE button removed from nav - available in avatar dropdown */}
          <NotificationBell backend={BACKEND} />
          {(propUser || googleUser)
            ? <AvatarMenu
                user={googleUser || propUser}
                onLogout={onLogoutMain || (() => { setGoogleUser(null); localStorage.removeItem('np_google_user'); })}
                onWatchlist={() => setShowWatchlist(true)}
                onUpgrade={onUpgrade}
                onLikedVideos={() => setShowLikedVideos(true)}
                onWatchHistory={() => setShowWatchHistory(true)}
                onSettings={() => setShowSettings(true)}
                onAdminDashboard={() => { if (typeof onAdminDashboard === 'function') onAdminDashboard(); }}
                onAdvertise={() => { setShowAdvertise(true); window.location.hash='advertise'; }}
              />
            : <GoogleAuthButton user={googleUser} onLogin={u => { setGoogleUser(u); if (typeof onGoogleLogin === "function") onGoogleLogin(u); }} onLogout={() => { setGoogleUser(null); localStorage.removeItem("np_google_user"); localStorage.removeItem("yt_access_token"); }} onShowWatchlist={() => setShowWatchlist(true)} onUpgrade={onUpgrade} />
          }
        </div>
      </div>

      
      {/* Mobile Bottom Nav CSS */}
      <style>{`
        @media (max-width: 768px) {
          .np-mobile-bottom-nav { display: flex !important; }
          .np-nav-mid { display: none !important; }
          body { padding-bottom: 60px; }
        }
      `}</style>
      {showRadio && <RadioPage onClose={() => setShowRadio(false)} onPlay={(station) => { setCurrentRadio(station); setShowRadio(false); }} />}
      {currentRadio && <MiniRadioPlayer station={currentRadio} onStop={() => setCurrentRadio(null)} />}
      {showBulletin && <BulletinPage backend={BACKEND} onClose={() => { setShowBulletin(false); setNavActive('HOME'); window.location.hash=''; }} />}
      {showAdvertise && <AdvertisePage onBack={() => { setShowAdvertise(false); window.location.hash=''; }} />}
      {showSearch && <SearchBar allVideos={allVideos} onPlay={handlePlay} onClose={() => setShowSearch(false)} />}

      <HeroBanner items={heroItems} onPlay={handlePlay} videoStats={videoStats} trendingIds={trendingIds} isInWatchlist={isInWatchlist} addToWatchlist={addToWatchlist} removeFromWatchlist={removeFromWatchlist} />
      <PushPromptBanner backend={BACKEND} />

      {/* CHIPS */}
      <div style={S.chips} className="np-chips">
        {CHIPS.map(c => (
          <button key={c} onClick={() => { setChip(c); setNavActive("HOME"); }}
            style={{ ...S.chip, ...(chip === c ? S.chipOn : {}) }}>{c}
          </button>
        ))}
      </div>

      {(chipKey === "ALL" || chipKey === "LIVE") && <LiveStrip rssData={rssData} onPlay={handlePlay} />}

      {loading && <div style={{ background:"#040000", minHeight:"60vh", paddingTop:20 }}><SkeletonScreen /></div>}

      {!loading && filtered && (
        <div className="np-main-content" style={{ padding: "20px 28px 60px" }}>
          {chipKey === "ASTROLOGY" && <AstrologyContent />}
          {chipKey === "STOCK MARKET" && <StockMarketLive />}
          {chipKey === "NethajIQ" && <NethajIQPage onBack={() => setChip("ALL")} user={propUser || googleUser} />}
          {chipKey === "NethajiPrime Playlist" && <PlaylistBrowser backend={BACKEND} onPlay={handlePlay} />}
          {chipKey === "ASTROLOGY" && <BirthChartContent />}
          {filtered.length === 0
            ? (chipKey === "NethajiPrime Playlist" ? null : <div style={S.empty}>NO VIDEOS IN THIS CATEGORY YET</div>)
            : (
              <div className="np-category-grid" style={{
                display: 'grid',
                gridTemplateColumns: `repeat(var(--np-cols, 4), 1fr)`,
                gap: 'var(--card-gap, 12px)',
                width: '100%'
              }}>
                {filtered.map(item => (
                  <VideoCard key={item.id} item={item} onPlay={handlePlay} videoStats={videoStats} trendingIds={trendingIds} />
                ))}
              </div>
            )
          }
        </div>
      )}

      {!loading && !filtered && (
        <div>
          <ContinueWatchingRow userId={userId} onPlay={handlePlay} backend={BACKEND} />
          <Leaderboard backend={BACKEND} />
          <ContentRow title="NP ORIGINALS" items={originals} onPlay={handlePlay} accentColor="#FFD700" videoStats={videoStats} trendingIds={trendingIds} onSeeAll={handleSeeAll} />
          <AdBanner backend={BACKEND} isPaidUser={isAdFreeUser} />
          <ContentRow title="DEVOTIONAL" items={byCategory("Devotional")} onPlay={handlePlay} accentColor="#FF6F00" videoStats={videoStats} trendingIds={trendingIds} onSeeAll={handleSeeAll} />
          <AdBanner backend={BACKEND} index={1} isPaidUser={isAdFreeUser} />
          <GoogleAdUnit slot="HOMEPAGE_BANNER" />
          {chipKey === "ASTROLOGY" && <AstrologyContent />}
          <ContentRow title="ASTROLOGY" items={byCategory("Astrology")} onPlay={handlePlay} accentColor="#9C27B0" videoStats={videoStats} trendingIds={trendingIds} onSeeAll={handleSeeAll} />
          <ContentRow title="STOCK MARKET" items={byCategory("Stock Market")} onPlay={handlePlay} accentColor="#2E7D32" videoStats={videoStats} trendingIds={trendingIds} onSeeAll={handleSeeAll} />
          <ContentRow title="KIDS" items={byCategory("Kids")} onPlay={handlePlay} accentColor="#F06292" videoStats={videoStats} trendingIds={trendingIds} onSeeAll={handleSeeAll} />
          <ContentRow title="HEALTH" items={byCategory("Health")} onPlay={handlePlay} accentColor="#00897B" videoStats={videoStats} trendingIds={trendingIds} onSeeAll={handleSeeAll} />
          <ContentRow title="KITCHEN" items={byCategory("Kitchen")} onPlay={handlePlay} accentColor="#FFA726" videoStats={videoStats} trendingIds={trendingIds} onSeeAll={handleSeeAll} />
          {allRSS.length > 0 && (
            <div style={S.divider}>
              <div style={S.divLine} /><div style={S.divTxt}>LATEST FROM YOUR CHANNELS</div><div style={S.divLine} />
            </div>
          )}
          {RSS_CHANNELS.map(ch => (
            <ContentRow key={ch.id} title={ch.label.toUpperCase()} items={rssData[ch.id] || []}
              onPlay={handlePlay} accentColor={ch.color} asList={true} videoStats={videoStats} trendingIds={trendingIds} />
          ))}
        </div>
      )}

      {activeVideo && <VideoModal item={activeVideo} onClose={() => setActiveVideo(null)} videoStats={videoStats}
  isPaidUser={isAdFreeUser}
  allVideos={[
    ...speeches,
    ...Object.values(rssData).flat().filter(v=>v&&v.id).map(v=>({
      id: v.id, title: v.title, thumbnail_url: v.thumb||v.thumbnail,
      category: v.channelLabel||v.channel||'YouTube', type:'youtube',
      content_type:'youtube'
    }))
  ]}
  onRelatedPlay={(v) => setActiveVideo(v)} />}
      {showLikedVideos && <LikedVideosPanel onPlay={handlePlay} userId={(propUser?.id || googleUser?.id || '')} backend={BACKEND} onClose={() => setShowLikedVideos(false)} />}
      {showWatchHistory && <WatchHistoryPanel userId={(() => { try { const t=localStorage.getItem('token'); if(t) return JSON.parse(atob(t.split('.')[1])).sub; } catch(e){} return propUser?.id || googleUser?.id || ''; })()} backend={BACKEND} onClose={() => setShowWatchHistory(false)} onPlay={async (v) => {
        // If watch_progress lacks video_url/bunny_video_id (stale record), look up the live video data
        if ((v.video_type === 'speech' || v.type === 'speech') && !v.video_url && !v.bunny_video_id) {
          // Check speeches table first
          try {
            const r = await fetch(BACKEND + '/speeches');
            const d = await r.json();
            const full = (d.speeches || []).find(s => s.id === v.video_id);
            if (full) {
              setActiveVideo({ id: full.id, title: full.title, thumb: full.thumbnail_url || v.thumb, type: 'speech', video_url: full.video_url || '', bunny_video_id: full.bunny_video_id || '', category: full.category, is_reel: full.is_reel });
              setShowWatchHistory(false);
              return;
            }
          } catch (e) { console.error('Watch history speeches lookup failed:', e); }
          // Fallback: check shorts table (Bunny/R2 upload path)
          try {
            const { data: shortData } = await supabase.from('shorts').select('*').eq('id', v.video_id).single();
            if (shortData) {
              setActiveVideo({ id: shortData.id, title: shortData.title, thumb: shortData.thumbnail_url || v.thumb, type: 'speech', video_url: shortData.video_url || '', bunny_video_id: shortData.bunny_video_id || '' });
              setShowWatchHistory(false);
              return;
            }
          } catch (e2) { console.error('Watch history shorts lookup failed:', e2); }
        }
        setActiveVideo({ id: v.video_id, title: v.title, thumb: v.thumb || v.thumbnail_url, type: v.video_type || v.type || 'youtube', bunny_video_id: v.bunny_video_id || '', video_url: v.video_url || '' });
        setShowWatchHistory(false);
      }} />}
      {showSettings && <SettingsPanel user={propUser || googleUser} onClose={() => setShowSettings(false)} />}
      {showWatchlist && <WatchlistPage userId={userId} backend={BACKEND} onPlay={handlePlay} onClose={() => setShowWatchlist(false)} />}
      {/* Mobile Bottom Nav */}
      <div className="np-mobile-bottom-nav" style={{
        position:'fixed', bottom:0, left:0, right:0, zIndex:9999,
        background:'#0d0005', borderTop:'2px solid #FFD700',
        padding:'8px 0 env(safe-area-inset-bottom, 12px)',
        transform:'translate3d(0,0,0)', WebkitTransform:'translate3d(0,0,0)', willChange:'transform',
        WebkitBackfaceVisibility:'hidden', backfaceVisibility:'hidden',
        boxShadow:'0 -2px 10px rgba(0,0,0,0.9)'
      }}>
        <div style={{display:'flex', justifyContent:'space-around', alignItems:'center'}}>
          <button onClick={() => { setShowBulletin(false); setNavActive('HOME'); window.location.hash=''; }}
            style={{background:'none',border:'none',color:'#ccc',display:'flex',flexDirection:'column',alignItems:'center',gap:1,fontSize:9,cursor:'pointer',padding:'2px 6px'}}>
            <span style={{fontSize:16}}>🏠</span>HOME
          </button>
          <button onClick={() => { if (typeof onLegal === 'function') onLegal(); }}
            style={{background:'none',border:'none',color:'#ccc',display:'flex',flexDirection:'column',alignItems:'center',gap:2,fontSize:11,cursor:'pointer',padding:'4px 8px',minWidth:44}}>
            <span style={{fontSize:16}}>⚖️</span>LEGAL
          </button>
          <button onClick={() => { if (typeof onDeals === 'function') onDeals(); }}
            style={{background:'none',border:'none',color:'#FFD700',display:'flex',flexDirection:'column',alignItems:'center',gap:2,fontSize:11,cursor:'pointer',padding:'4px 8px',minWidth:44}}>
            <span style={{fontSize:16}}>🔥</span>DEALS
          </button>
          <button onClick={() => { setNavActive('LIVE'); setChip('🔴 LIVE'); setShowBulletin(false); }}
            style={{background:'none',border:'none',color:'#ccc',display:'flex',flexDirection:'column',alignItems:'center',gap:2,fontSize:11,cursor:'pointer',padding:'4px 8px'}}>
            <span style={{fontSize:16}}>🔴</span>LIVE
          </button>
          <button onClick={() => { setShowBulletin(true); setNavActive('BULLETIN'); }}
            style={{background:'none',border:'none',color:'#FFD700',display:'flex',flexDirection:'column',alignItems:'center',gap:1,fontSize:9,cursor:'pointer',padding:'2px 6px'}}>
            <span style={{fontSize:20}}>📺</span>BULLETIN
          </button>
          <button onClick={() => setShowSearch(true)}
            style={{background:'none',border:'none',color:'#ccc',display:'flex',flexDirection:'column',alignItems:'center',gap:2,fontSize:11,cursor:'pointer',padding:'4px 8px'}}>
            <span style={{fontSize:16}}>🔍</span>SEARCH
          </button>
          <button onClick={() => { setShowRadio(true); setShowBulletin(false); }}
            style={{background:'none',border:'none',color:'#ccc',display:'flex',flexDirection:'column',alignItems:'center',gap:2,fontSize:11,cursor:'pointer',padding:'4px 8px'}}>
            <span style={{fontSize:16}}>👤</span>RADIO
          </button>
        </div>
      </div>
      {/* Compliance legal footer — bottom margin clears the fixed mobile nav */}
      <LegalFooter style={{ marginBottom: 72 }} />
    </div>
  );
}

// Mobile nav CSS injected via style tag in component
// ── STYLES ───────────────────────────────────────────────────────────────────
const S = {
  page: { background: "#1a0008", minHeight: "100vh", paddingBottom: "env(safe-area-inset-bottom, 0px)", paddingBottom: "env(safe-area-inset-bottom, 0px)", fontFamily: "'Rajdhani',sans-serif", color: "#fff", overflowX: "clip" },
  nav: { height: 66, background: "#000000", borderBottom: "3px solid #FFD700", display: "flex", alignItems: "center", justifyContent: "space-between", padding: "0 28px", position: "sticky", top: 0, zIndex: 100 },
  logoWrap: { display: "flex", alignItems: "center" },
  logoN: { fontFamily: "'Bebas Neue',sans-serif", fontSize: 32, letterSpacing: 3, color: "#FFD700", textShadow: "0 0 20px rgba(255,215,0,0.8)" },
  logoP: { fontFamily: "'Bebas Neue',sans-serif", fontSize: 24, color: "#FFFFFF", letterSpacing: 2, marginLeft: 4 },
  logoOtt: { background: "#FF0000", color: "#FFFFFF", fontFamily: "'Bebas Neue',sans-serif", fontSize: 10, padding: "3px 7px", borderRadius: 3, marginLeft: 6 },
  navMid: { display: "flex", alignItems: "center", gap: 28, overflowX: "auto", overflowY: "visible", paddingTop: 8, WebkitOverflowScrolling: "touch", scrollbarWidth: "none", msOverflowStyle: "none", flexShrink: 0 },
  nl: { fontFamily: "'Bebas Neue',sans-serif", fontSize: 14, letterSpacing: 2, color: "#CCCCCC", cursor: "pointer", background: "none", border: "none", padding: "4px 0", textTransform: "uppercase" },
  nlActive: { fontFamily: "'Bebas Neue',sans-serif", fontSize: 14, letterSpacing: 2, color: "#FFD700", cursor: "pointer", borderBottom: "2px solid #FFD700", paddingBottom: 2, textTransform: "uppercase" },
  navRight: { display: "flex", alignItems: "center", gap: 10 },
  searchBtn: { background: "transparent", border: "1px solid rgba(255,215,0,0.4)", color: "#FFD700", borderRadius: 6, padding: "8px 12px", cursor: "pointer", fontSize: 16 },
  subBtn: { background: "#FFD700", color: "#000000", fontFamily: "'Bebas Neue',sans-serif", fontSize: 13, letterSpacing: 2, padding: "8px 16px", border: "none", borderRadius: 8, cursor: "pointer", fontWeight: 900 },
  hero: { display: "flex", alignItems: "stretch", minHeight: 560, width: "100vw", position: "relative", overflow: "hidden", background: "#1a0008" },
  heroBg: { position: "absolute", inset: 0, background: "linear-gradient(to right, #1a0008 0%, rgba(26,0,8,0.7) 25%, rgba(26,0,8,0.1) 50%, transparent 70%)" },
  heroBar: { position: "absolute", top: 0, left: 0, right: 0, height: 3, background: "rgba(255,255,255,0.1)", zIndex: 10 },
  heroBarFill: { height: "100%", background: "#FFD700", transition: "width 0.5s" },
  heroLeft: { flex: "0 0 40%", padding: "50px 40px 60px 48px", display: "flex", flexDirection: "column", justifyContent: "center", position: "relative", zIndex: 2 },
  heroRight: { flex: "1 1 60%", position: "relative", minHeight: 560, overflow: "hidden", zIndex: 1 },
  heroRightFade: { position: "absolute", inset: 0, background: "linear-gradient(to right, #1a0008 0%, rgba(26,0,8,0.3) 15%, transparent 35%)" },
  heroRightBottom: { position: "absolute", bottom: 0, left: 0, right: 0, height: 120, background: "linear-gradient(to top, #1a0008 0%, rgba(26,0,8,0.5) 50%, transparent 100%)" },
  heroDots: { position: "absolute", bottom: 20, right: 24, display: "flex", gap: 6, zIndex: 10 },
  heroDot: { height: 3, borderRadius: 2, cursor: "pointer", transition: "all 0.3s" },
  eyebrow: { display: "flex", alignItems: "center", gap: 12, marginBottom: 18 },
  eyeLine: { width: 36, height: 3, background: "#FFD700", borderRadius: 2 },
  eyeTxt: { fontFamily: "'Bebas Neue',sans-serif", fontSize: 12, letterSpacing: 5, color: "#FFD700" },
  heroEng: { fontFamily: "'Bebas Neue',sans-serif", fontSize: 62, lineHeight: 1, letterSpacing: 3, color: "#FFFFFF", textShadow: "2px 2px 0 #000,0 4px 20px rgba(0,0,0,0.95)", marginBottom: 8 },
  heroTam: { fontFamily: "'Noto Sans Tamil',sans-serif", fontSize: 38, fontWeight: 700, color: "#FFD700", textShadow: "0 0 40px rgba(255,215,0,1),2px 2px 0 #000", lineHeight: 1.2, marginBottom: 18 },
  heroDesc: { fontSize: 17, fontWeight: 700, color: "#FFFFFF", marginBottom: 26, lineHeight: 1.5 },
  heroBtns: { display: "flex", gap: 16, marginBottom: 22, flexWrap: "nowrap" },
  btnPlay: { background: "#FFD700", color: "#000000", fontFamily: "'Bebas Neue',sans-serif", fontSize: 22, letterSpacing: 2, padding: "16px 38px", border: "none", borderRadius: 8, cursor: "pointer", boxShadow: "0 0 30px rgba(255,215,0,0.9)", fontWeight: 900 },
  btnWl: { background: "rgba(255,255,255,0.18)", color: "#FFFFFF", fontFamily: "'Bebas Neue',sans-serif", fontSize: 22, letterSpacing: 2, padding: "16 30px", border: "3px solid #FFFFFF", borderRadius: 8, cursor: "pointer", fontWeight: 900 },
  heroTags: { display: "flex", gap: 8, flexWrap: "wrap" },
  tagGold: { fontFamily: "'Bebas Neue',sans-serif", fontSize: 11, letterSpacing: 2, padding: "6px 14px", borderRadius: 20, color: "#000", background: "#FFD700", fontWeight: 900 },
  tagWhite: { fontFamily: "'Bebas Neue',sans-serif", fontSize: 11, letterSpacing: 2, padding: "6px 14px", borderRadius: 20, color: "#fff", background: "rgba(255,255,255,0.2)", border: "2px solid rgba(255,255,255,0.5)" },
  chips: { background: "#0d0005", borderBottom: "2px solid rgba(255,215,0,0.2)", display: "flex", overflowX: "auto", padding: "0 28px", scrollbarWidth: "none" },
  chip: { fontFamily: "'Bebas Neue',sans-serif", fontSize: 13, letterSpacing: 2, color: "#AAAAAA", padding: "14px 18px", cursor: "pointer", border: "none", borderBottom: "3px solid transparent", background: "none", whiteSpace: "nowrap", textTransform: "uppercase" },
  chipOn: { color: "#FFD700", borderBottom: "3px solid #FFD700" },
  live: { margin: "18px 28px", background: "#1a0000", border: "2px solid #FF0000", borderRadius: 10, padding: "15px 20px", display: "flex", alignItems: "center", gap: 14, flexWrap: "wrap", boxShadow: "0 0 20px rgba(255,0,0,0.2)" },
  livePill: { background: "#FF0000", color: "#FFFFFF", fontFamily: "'Bebas Neue',sans-serif", fontSize: 12, letterSpacing: 2, padding: "8px 16px", borderRadius: 5, display: "flex", alignItems: "center", gap: 7, flexShrink: 0, boxShadow: "0 0 20px rgba(255,0,0,0.7)" },
  liveDot: { width: 7, height: 7, background: "#fff", borderRadius: "50%" },
  liveInfo: { flex: 1, minWidth: 160 },
  liveT: { fontSize: 16, fontWeight: 700, color: "#FFFFFF" },
  liveS: { fontFamily: "'Bebas Neue',sans-serif", fontSize: 11, letterSpacing: 2, color: "#FFD700", marginTop: 3 },
  liveChs: { display: "flex", gap: 7 },
  lch: { fontFamily: "'Bebas Neue',sans-serif", fontSize: 11, letterSpacing: 1, border: "none", borderRadius: 5, padding: "8px 14px", color: "#FFFFFF", cursor: "pointer", fontWeight: 900 },
  watchLive: { background: "#FF0000", color: "#FFFFFF", fontFamily: "'Bebas Neue',sans-serif", fontSize: 14, letterSpacing: 2, border: "none", borderRadius: 7, padding: "12px 22px", cursor: "pointer", boxShadow: "0 0 20px rgba(255,0,0,0.7)", whiteSpace: "nowrap", textDecoration: "none", display: "inline-block" },
  searchOverlay: { position: "fixed", inset: 0, background: "rgba(0,0,0,0.92)", zIndex: 999, padding: "80px 20px 20px" },
  searchBox: { display: "flex", gap: 10, maxWidth: 700, margin: "0 auto 20px" },
  searchInput: { flex: 1, background: "#1a0008", border: "2px solid #FFD700", borderRadius: 8, padding: "14px 20px", color: "#fff", fontSize: 18, fontFamily: "'Rajdhani',sans-serif", fontWeight: 700, outline: "none" },
  searchClose: { background: "#FF0000", border: "none", color: "#fff", borderRadius: 8, padding: "14px 20px", cursor: "pointer", fontSize: 16, fontFamily: "'Bebas Neue',sans-serif", letterSpacing: 2 },
  searchResults: { maxWidth: 700, margin: "0 auto" },
  searchItem: { display: "flex", gap: 14, padding: "12px 0", cursor: "pointer", borderBottom: "1px solid rgba(255,255,255,0.1)" },
  searchThumb: { flexShrink: 0, width: 120, height: 68, borderRadius: 6, overflow: "hidden", background: "#2a0010" },
  searchTitle: { fontFamily: "'Rajdhani',sans-serif", fontSize: 15, fontWeight: 700, color: "#fff", marginBottom: 4 },
  searchMeta: { fontFamily: "'Bebas Neue',sans-serif", fontSize: 11, letterSpacing: 2, color: "#FFD700" },
  section: { padding: "0 28px", marginTop: 28 },
  secHd: { display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 14 },
  secTw: { display: "flex", alignItems: "center", gap: 10, lineHeight: 1 },
  secBar: { width: 4, height: 24, borderRadius: 2, flexShrink: 0 },
  secNm: { fontFamily: "'Bebas Neue',sans-serif", fontSize: 20, letterSpacing: 3, color: "#FFFFFF", lineHeight: 1, display: "flex", alignItems: "center" },
  seeAll: { fontFamily: "'Bebas Neue',sans-serif", fontSize: 12, letterSpacing: 2, color: "#FFD700", cursor: "pointer", background: "rgba(255,215,0,0.15)", padding: "6px 14px", borderRadius: 4, border: "1px solid #FFD700" },
  hRow: { display: "flex", gap: 12, overflowX: "auto", scrollbarWidth: "none", paddingBottom: 8 },
  scrollBtn: { position: "absolute", top: "35%", zIndex: 10, background: "rgba(0,0,0,0.8)", border: "1px solid rgba(255,215,0,0.3)", borderRadius: "50%", width: 36, height: 36, color: "#FFD700", fontSize: 20, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" },
  card: { flexShrink: 0, width: 320, cursor: "pointer" },
  cardImg: { width: 320, height: 180, borderRadius: 9, position: "relative", overflow: "hidden", border: "2px solid rgba(255,215,0,0.25)", background: "#2a0010", flexShrink: 0 },
  cardShine: { position: "absolute", inset: 0, background: "linear-gradient(135deg,rgba(255,255,255,0.07),transparent 50%)", pointerEvents: "none" },
  cardBadge: { position: "absolute", top: 6, left: 6, fontFamily: "'Bebas Neue',sans-serif", fontSize: 9, letterSpacing: 1, background: "#FFD700", color: "#000", padding: "3px 8px", borderRadius: 3, fontWeight: 900 },
  cardBadgeYT: { position: "absolute", top: 6, left: 6, fontFamily: "'Bebas Neue',sans-serif", fontSize: 9, letterSpacing: 1, background: "#FF0000", color: "#fff", padding: "3px 8px", borderRadius: 3 },
  cardTitle: { fontFamily: "'Rajdhani',sans-serif", fontSize: 15, fontWeight: 600, color: "#FFFFFF", marginTop: 8, lineHeight: 1.3, display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden" },
  cardMeta: { fontFamily: "'Barlow Condensed',sans-serif", fontSize: 13, letterSpacing: 1, color: "#FFD700", marginTop: 3, opacity: 0.8 },
  vItem: { display: "flex", gap: 8, padding: "12px 0", cursor: "pointer", borderBottom: "1px solid rgba(255,255,255,0.07)" },
  vThumb: { flexShrink: 0, width: 190, height: 107, borderRadius: 9, overflow: "hidden", border: "1px solid rgba(255,255,255,0.1)", position: "relative", background: "#2a0010" },
  ytBadge: { position: "absolute", top: 6, left: 6, background: "#FF0000", color: "#fff", fontFamily: "'Bebas Neue',sans-serif", fontSize: 9, padding: "2px 6px", borderRadius: 3 },
  vInfo: { flex: 1, padding: "2px 0", minWidth: 0 },
  vTitle: { fontFamily: "'Rajdhani',sans-serif", fontSize: 16, fontWeight: 700, color: "#FFFFFF", lineHeight: 1.4, display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden", marginBottom: 6 },
  vMeta: { fontFamily: "'Bebas Neue',sans-serif", fontSize: 11, letterSpacing: 2, color: "#888888" },
  vCat: { display: "inline-block", fontFamily: "'Bebas Neue',sans-serif", fontSize: 10, letterSpacing: 1.5, color: "#FFD700", background: "rgba(255,215,0,0.15)", border: "1px solid rgba(255,215,0,0.35)", padding: "3px 9px", borderRadius: 3, marginTop: 7 },
  divider: { display: "flex", alignItems: "center", gap: 14, padding: "22px 28px 6px" },
  divLine: { flex: 1, height: 1, background: "rgba(255,215,0,0.2)" },
  divTxt: { fontFamily: "'Bebas Neue',sans-serif", fontSize: 10, letterSpacing: 4, color: "rgba(255,215,0,0.6)" },
      modalBg: { position: "fixed", top: 0, left: 0, right: 0, bottom: 0, background: "rgba(0,0,0,0.92)", zIndex: 9999, display: "flex", alignItems: "flex-start", justifyContent: "center", padding: "16px", overflow: "hidden" },
  modal: { background: "#0f0005", borderRadius: 10, width: "100%", maxWidth: 860, height: "calc(100vh - 32px)", overflowY: "auto", overflowX: "hidden", position: "relative", border: "1px solid rgba(255,215,0,0.2)", WebkitOverflowScrolling: "touch", scrollbarWidth: "thin", scrollbarColor: "rgba(212,168,67,0.4) transparent" },
  modalClose: { position: "fixed", top: 16, right: 16, width: 36, height: 36, minWidth: 36, minHeight: 36, borderRadius: "50%", background: "#cc0000", border: "2px solid #fff", color: "#fff", fontSize: 18, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 99999, fontWeight: "bold", lineHeight: 1, padding: 0, boxSizing: "border-box", flexShrink: 0, boxShadow: "0 2px 8px rgba(0,0,0,0.8)" },
  modalVideo: { width: "100%", aspectRatio: "16/9", background: "#000" },
  modalInfo: { padding: "16px 20px 80px" },
  modalTitle: { fontFamily: "'Bebas Neue',sans-serif", fontSize: 22, letterSpacing: 2, color: "#FFFFFF", marginBottom: 6 },
  modalMeta: { fontFamily: "'Bebas Neue',sans-serif", fontSize: 11, letterSpacing: 2, color: "#FFD700" },
  modalDesc: { fontFamily: "'Rajdhani',sans-serif", fontSize: 14, fontWeight: 600, color: "rgba(255,255,255,0.7)", marginTop: 8, lineHeight: 1.6 },
  loading: { fontFamily: "'Bebas Neue',sans-serif", fontSize: 16, letterSpacing: 4, color: "#FFD700", padding: "40px", textAlign: "center" },
  empty: { fontFamily: "'Bebas Neue',sans-serif", fontSize: 14, letterSpacing: 3, color: "#555", padding: "40px", textAlign: "center" },
  statHero: { fontFamily: "'Bebas Neue',sans-serif", fontSize: 12, letterSpacing: 1.5, color: "#FFD700", background: "rgba(255,215,0,0.12)", border: "1px solid rgba(255,215,0,0.3)", padding: "4px 12px", borderRadius: 4, whiteSpace: "nowrap" },
  statBadge: { fontFamily: "'Barlow Condensed',sans-serif", fontSize: 12, letterSpacing: 0.5, color: "rgba(255,255,255,0.6)", background: "rgba(255,255,255,0.08)", padding: "2px 8px", borderRadius: 3, whiteSpace: "nowrap" },
};

